var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategicConsulting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M77.66,251.7c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,196.75,77.66,251.7Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "467.09 204.41 465.26 205.5 404.87 170.63 406.7 169.54 467.09 204.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.7 169.54 465.26 203.35 465.26 81.05 406.7 47.25 406.7 169.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.42,172.62l67.3,38.86V79.06L401.42,40.2Zm3.45-126.45,60.39,34.88V205.5l-60.39-34.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.87 170.63 406.7 169.54 406.7 47.25 404.87 46.17 404.87 170.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.26 160.56 465.26 162.7 404.87 127.83 406.7 126.74 465.26 160.56",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.26 117.73 465.26 119.88 404.87 85 406.7 83.91 465.26 117.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.42 40.2 403.28 39.13 470.57 77.99 468.71 79.06 401.42 40.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.57 77.99 468.71 79.06 468.71 211.48 470.57 210.42 470.57 77.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.65 65.69 436.8 64.61 436.8 189.07 438.65 188.01 438.65 65.69",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "433.34 62.63 436.8 64.61 436.8 189.07 433.34 187.07 433.34 62.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.42 83.01 401.42 86.99 468.71 125.85 468.71 121.87 401.42 83.01",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.42 125.83 401.42 129.81 468.71 168.67 468.71 164.69 401.42 125.83",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.8 103.44 438.65 102.37 465.26 117.73 465.26 119.88 436.8 103.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.8 146.24 438.65 145.17 465.26 160.53 465.26 162.68 436.8 146.24",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.58,375.55s-3.58-22.65,4.71-44.68c4.63-12.32,12.8-17.95,17.78-18.43,5.58-.54,11.15,4.8,6.11,12.9-4.79,7.69-13.9,10.73-19.46,30.88-3.66,13.29-3.22,22.11-3.22,22.11Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.58,375.55s-3.58-22.65,4.71-44.68c4.63-12.32,12.8-17.95,17.78-18.43,5.58-.54,11.15,4.8,6.11,12.9-4.79,7.69-13.9,10.73-19.46,30.88-3.66,13.29-3.22,22.11-3.22,22.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.1,369.87a.33.33,0,0,0,.32-.37c-2.11-24.76,10.05-45.3,19.35-52a.35.35,0,0,0,.08-.49.34.34,0,0,0-.48-.08c-9.44,6.77-21.78,27.56-19.64,52.6A.33.33,0,0,0,455.1,369.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.5,378.33c.89-5.68,4.11-11.48,10.93-17.58s16.17-11.64,14.89-17.17-8.63-4.51-13.82-1.57-16.94,14.73-15,34.93Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.5,378.33c.89-5.68,4.11-11.48,10.93-17.58s16.17-11.64,14.89-17.17-8.63-4.51-13.82-1.57-16.94,14.73-15,34.93Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.17,372a.36.36,0,0,0,.32-.32c1.15-12,15.24-26.83,21.68-29a.35.35,0,0,0-.23-.66c-6.75,2.3-20.95,17.14-22.14,29.63a.35.35,0,0,0,.31.38Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diplomas--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--diplomas--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.29 131.13 34.79 132 72.28 110.35 70.78 109.49 33.29 131.13",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.78 109.49 34.79 130.27 34.79 99.07 70.78 78.3 70.78 109.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,74.83,33.29,98.21v36.38l40.49-23.37Zm-1.5,35.52L34.79,132V99.07L72.28,77.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.28 110.35 70.78 109.49 70.78 78.3 72.28 77.43 72.28 110.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.78 74.83 72.28 73.97 31.79 97.34 33.29 98.21 73.78 74.83",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.79 97.34 33.29 98.21 33.29 134.59 31.79 133.73 31.79 97.34",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.62,102.81c1.62-.93,2.93-.38,2.93,1.24a6.08,6.08,0,0,1-2.93,4.61c-1.61.93-2.92.38-2.92-1.24A6.07,6.07,0,0,1,65.62,102.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,98.05,64,85.33c.61-.35,1.11-.14,1.11.47v.06A2.29,2.29,0,0,1,64,87.6L42,100.33c-.62.35-1.11.14-1.11-.47V99.8A2.27,2.27,0,0,1,42,98.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52,107l29-16.72c.61-.36,1.1-.26,1.1.22A2.13,2.13,0,0,1,67.49,92l-29,16.73c-.61.36-1.1.25-1.1-.23A2.19,2.19,0,0,1,38.52,107Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52,110.45l29-16.72c.61-.36,1.1-.26,1.1.22a2.15,2.15,0,0,1-1.1,1.51l-29,16.73c-.61.36-1.1.25-1.1-.23A2.19,2.19,0,0,1,38.52,110.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52,113.91l29-16.72c.61-.36,1.1-.26,1.1.22a2.15,2.15,0,0,1-1.1,1.51l-29,16.73c-.61.36-1.1.25-1.1-.23A2.19,2.19,0,0,1,38.52,113.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42,110.62a1.83,1.83,0,0,1-.72.22c-.62.06-.56-.5-.54-.88,0-.17-.27-.41-.41-.18-.37.62-.85,1.2-1.26,1.8-.24.37-.71,1.2-1.31,1.13-.24,0-.33-.25-.33-.54a2.62,2.62,0,0,0,.39-1.59c0-.16-.34-.34-.44-.11a4.62,4.62,0,0,0-.38,1.47,10,10,0,0,1-.93,1.28c-.2.25-.38.52-.6.75,0,.06-.16.2-.24.22s-.19-.06-.21-.18a1.07,1.07,0,0,1,.1-.52h0s0,0,0,0h0c0-.17-.25-.4-.35-.18a8.32,8.32,0,0,1-1.7,2.58l-.12.09c0-.1,0-.2,0-.3a1.91,1.91,0,0,0-.14-.67c0-.1-.27-.25-.38-.1a13.76,13.76,0,0,1-1.93,2.46,3.52,3.52,0,0,1-.4.27c-.14,0,.07-.68.09-.77.08-.28.19-.55.29-.83a2.73,2.73,0,0,0,.23-.68c0-.21-.37-.49-.45-.21,0,.11-.14.4-.26.75a18.87,18.87,0,0,1-1.63,2.51,6.71,6.71,0,0,1-2.26,2.06c-.26.14-.74.35-1,.2s-.25-.47-.26-.69a5.34,5.34,0,0,1,.27-1.76A13.68,13.68,0,0,0,46,116.44a9.08,9.08,0,0,0,1.9-2c.25-.42.41-1.09-.22-1.28a2,2,0,0,0-1.35.39,6.49,6.49,0,0,0-1.38,1,7.3,7.3,0,0,0-1.73,2.87c-.05.15-.12.37-.19.61a6.45,6.45,0,0,1-3.19.71c-.06,0-.09.11,0,.12a6.24,6.24,0,0,0,3.12-.5c-.28,1.07-.43,2.47.7,2.65s2.49-1.15,3.09-1.89a12.5,12.5,0,0,0,1.21-1.79.69.69,0,0,1,.11-.13c0,.48.11.83.66.71s1.06-.85,1.37-1.25.55-.76.82-1.14c0,.43.14.92.62.8s.89-.88,1.11-1.19a7.45,7.45,0,0,0,.55-.83.49.49,0,0,0,.11.14c.4.34.88-.1,1.14-.41s.78-.92,1.13-1.42a.79.79,0,0,0,.48.43c.62.2,1.2-.29,1.55-.71a12.31,12.31,0,0,0,1.17-1.71.7.7,0,0,0,.42.48,1.63,1.63,0,0,0,1.46-.2C60.81,110.86,60.63,110.51,60.42,110.62Zm-13.55,3.14c.29-.15.89-.41.92,0,0,.24-.24.57-.39.77a11.68,11.68,0,0,1-1.69,1.68,14.49,14.49,0,0,1-2.11,1.55A6.76,6.76,0,0,1,46.87,113.76Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.29 178.54 34.79 179.41 72.28 157.77 70.78 156.9 33.29 178.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.78 156.9 34.79 177.68 34.79 146.49 70.78 125.71 70.78 156.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,122.25,33.29,145.62V182l40.49-23.38Zm-1.5,35.52L34.79,179.41V146.49l37.49-21.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.28 157.77 70.78 156.9 70.78 125.71 72.28 124.84 72.28 157.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.78 122.25 72.28 121.38 31.79 144.75 33.29 145.62 73.78 122.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.79 144.75 33.29 145.62 33.29 182.01 31.79 181.14 31.79 144.75",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.62,150.22c1.62-.93,2.93-.37,2.93,1.24a6.06,6.06,0,0,1-2.93,4.61c-1.61.93-2.92.38-2.92-1.24A6.09,6.09,0,0,1,65.62,150.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,145.46l22-12.71c.61-.36,1.11-.15,1.11.46v.06A2.32,2.32,0,0,1,64,135L42,147.74c-.62.35-1.11.15-1.11-.47v-.06A2.28,2.28,0,0,1,42,145.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52,154.4l29-16.72c.61-.35,1.1-.25,1.1.23a2.13,2.13,0,0,1-1.1,1.5l-29,16.74c-.61.35-1.1.25-1.1-.24A2.21,2.21,0,0,1,38.52,154.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52,157.86l29-16.72c.61-.35,1.1-.25,1.1.23a2.13,2.13,0,0,1-1.1,1.5l-29,16.74c-.61.35-1.1.24-1.1-.24A2.19,2.19,0,0,1,38.52,157.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52,161.32l29-16.72c.61-.36,1.1-.25,1.1.22a2.13,2.13,0,0,1-1.1,1.51l-29,16.73c-.61.36-1.1.25-1.1-.23A2.19,2.19,0,0,1,38.52,161.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42,158a1.83,1.83,0,0,1-.72.22c-.62.06-.56-.5-.54-.88,0-.17-.27-.41-.41-.17-.37.61-.85,1.19-1.26,1.8-.24.36-.71,1.19-1.31,1.12-.24,0-.33-.25-.33-.54a2.59,2.59,0,0,0,.39-1.59c0-.16-.34-.34-.44-.11a4.7,4.7,0,0,0-.38,1.47,9.32,9.32,0,0,1-.93,1.28c-.2.25-.38.52-.6.75,0,.06-.16.2-.24.22s-.19-.06-.21-.18a1.12,1.12,0,0,1,.1-.52h0s0,0,0,0h0c0-.17-.25-.4-.35-.18a8.48,8.48,0,0,1-1.7,2.59l-.12.08c0-.09,0-.19,0-.29a1.91,1.91,0,0,0-.14-.67c0-.11-.27-.26-.38-.11a13.76,13.76,0,0,1-1.93,2.46l-.4.28c-.14-.06.07-.68.09-.78.08-.28.19-.55.29-.82a3,3,0,0,0,.23-.69c0-.21-.37-.49-.45-.21,0,.12-.14.4-.26.75a18.87,18.87,0,0,1-1.63,2.51,6.71,6.71,0,0,1-2.26,2.06c-.26.14-.74.35-1,.2s-.25-.47-.26-.69a5.38,5.38,0,0,1,.27-1.76A13.68,13.68,0,0,0,46,163.85a8.86,8.86,0,0,0,1.9-2c.25-.42.41-1.09-.22-1.27a2,2,0,0,0-1.35.38,6.84,6.84,0,0,0-1.38,1,7.37,7.37,0,0,0-1.73,2.87c-.05.16-.12.37-.19.61a6.34,6.34,0,0,1-3.19.71c-.06,0-.09.11,0,.12a6.13,6.13,0,0,0,3.12-.5c-.28,1.07-.43,2.47.7,2.65s2.49-1.14,3.09-1.89a12.5,12.5,0,0,0,1.21-1.79.69.69,0,0,1,.11-.13c0,.49.11.83.66.71s1.06-.85,1.37-1.24.55-.76.82-1.15c0,.44.14.93.62.81s.89-.88,1.11-1.2a8.38,8.38,0,0,0,.55-.82.63.63,0,0,0,.11.13c.4.34.88-.09,1.14-.41s.78-.92,1.13-1.42a.77.77,0,0,0,.48.43c.62.21,1.2-.28,1.55-.71a12.31,12.31,0,0,0,1.17-1.71.66.66,0,0,0,.42.48,1.66,1.66,0,0,0,1.46-.19C60.81,158.27,60.63,157.93,60.42,158Zm-13.55,3.15c.29-.15.89-.41.92,0,0,.24-.24.56-.39.76a11.19,11.19,0,0,1-1.69,1.68,14.49,14.49,0,0,1-2.11,1.55A6.74,6.74,0,0,1,46.87,161.18Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M225,454.23,124.53,396.17c-1.59-.92-1.59-2.4,0-3.32l157.89-91.47a6.31,6.31,0,0,1,5.74,0l100.52,58.06c1.58.92,1.58,2.4,0,3.32L230.79,454.23A6.33,6.33,0,0,1,225,454.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M176.58,338.72c21.51,12.41,21.51,32.55,0,45s-56.37,12.42-77.88,0-21.51-32.55,0-45S155.08,326.3,176.58,338.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M391.29,428.83l78.13-44.31c1.71-1,1.73-2.57,0-3.57L407,344.28a6.82,6.82,0,0,0-6.19,0l-78.13,44.31c-1.72,1-1.73,2.58,0,3.58l62.49,36.66A6.82,6.82,0,0,0,391.29,428.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 55.72,
    cy: 386.48,
    rx: 31.95,
    ry: 18.62,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 119.77,
    cy: 435.91,
    rx: 30.51,
    ry: 17.61,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "235.5 188.46 348.44 123.19 348.44 37.33 235.5 102.6 235.5 188.46",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,189l-.33-.19a2.08,2.08,0,0,1-.94-1.64V106.1a2.11,2.11,0,0,1,.94-1.64L351,40.59a2.1,2.1,0,0,1,1.89,0l.33.19a2.08,2.08,0,0,1,.94,1.63v81.06a2.08,2.08,0,0,1-.94,1.63L242.86,189A2.1,2.1,0,0,1,241,189Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,189l-.33-.19a2.08,2.08,0,0,1-.94-1.64V106.1a2.11,2.11,0,0,1,.94-1.64L351,40.59a2.1,2.1,0,0,1,1.89,0l.33.19a2.08,2.08,0,0,1,.94,1.63v81.06a2.08,2.08,0,0,1-.94,1.63L242.86,189A2.1,2.1,0,0,1,241,189Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,106.1v81.05a2.11,2.11,0,0,0,.94,1.65l.32.18a2.13,2.13,0,0,0,1.68.1c-.43.12-.74-.12-.74-.65V107.38a1.87,1.87,0,0,1,.29-.93L240,105.17A2.06,2.06,0,0,0,239.7,106.1Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,106.1v81.05a2.11,2.11,0,0,0,.94,1.65l.32.18a2.13,2.13,0,0,0,1.68.1c-.43.12-.74-.12-.74-.65V107.38a1.87,1.87,0,0,1,.29-.93L240,105.17A2.06,2.06,0,0,0,239.7,106.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.25,41.87,242.86,105.74a2.1,2.1,0,0,0-1,1.64v81.05c0,.61.42.85,1,.55L353.25,125.1a2.08,2.08,0,0,0,.94-1.63V42.41C354.19,41.81,353.77,41.57,353.25,41.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.19,43.06v80.41a1.15,1.15,0,0,1-.44.77L242.91,187.79V107.38a1.11,1.11,0,0,1,.45-.77L353.19,43.06m.48-1.32a.82.82,0,0,0-.42.13L242.86,105.74a2.1,2.1,0,0,0-1,1.64v81.05c0,.43.21.68.52.68a.88.88,0,0,0,.43-.13L353.25,125.1a2.08,2.08,0,0,0,.94-1.63V42.41c0-.42-.21-.67-.52-.67Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11,173.18h0a2.94,2.94,0,0,0,1.4-2.23,1,1,0,0,0-.15-.54l8.71-17.25c.22.34.71.39,1.26.06a2.91,2.91,0,0,0,1.4-2.21.82.82,0,0,0-.29-.69l9-12a1,1,0,0,0,1.12-.08A2.94,2.94,0,0,0,272,136a1.08,1.08,0,0,0,0-.32l8.5-19.32c.15.53.7.66,1.36.29a2.94,2.94,0,0,0,1.4-2.22.92.92,0,0,0-.15-.55l8.71-9.42c.22.33.7.38,1.25.06a2.93,2.93,0,0,0,1-1l9.23,4a2.5,2.5,0,0,0-.41,1.24c0,.78.63,1,1.4.6a2.9,2.9,0,0,0,1.41-2.22,1.65,1.65,0,0,0,0-.32l8.5-7c.15.53.7.67,1.36.29a2.93,2.93,0,0,0,1.4-2.22c0-.45-.21-.73-.53-.79h0l9.47-17.38a1.29,1.29,0,0,0,.88-.2,2.91,2.91,0,0,0,1.4-2.22h0l8.41-4.86c0,.78.63,1,1.41.6a2.91,2.91,0,0,0,1.4-2.22.74.74,0,0,0-.53-.8l9.44-17.32a1.22,1.22,0,0,0,.91-.19v67.59l-101,58.31Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11,173.18h0a2.94,2.94,0,0,0,1.4-2.23,1,1,0,0,0-.15-.54l8.71-17.25c.22.34.71.39,1.26.06a2.91,2.91,0,0,0,1.4-2.21.82.82,0,0,0-.29-.69l9-12a1,1,0,0,0,1.12-.08A2.94,2.94,0,0,0,272,136a1.08,1.08,0,0,0,0-.32l8.5-19.32c.15.53.7.66,1.36.29a2.94,2.94,0,0,0,1.4-2.22.92.92,0,0,0-.15-.55l8.71-9.42c.22.33.7.38,1.25.06a2.93,2.93,0,0,0,1-1l9.23,4a2.5,2.5,0,0,0-.41,1.24c0,.78.63,1,1.4.6a2.9,2.9,0,0,0,1.41-2.22,1.65,1.65,0,0,0,0-.32l8.5-7c.15.53.7.67,1.36.29a2.93,2.93,0,0,0,1.4-2.22c0-.45-.21-.73-.53-.79h0l9.47-17.38a1.29,1.29,0,0,0,.88-.2,2.91,2.91,0,0,0,1.4-2.22h0l8.41-4.86c0,.78.63,1,1.41.6a2.91,2.91,0,0,0,1.4-2.22.74.74,0,0,0-.53-.8l9.44-17.32a1.22,1.22,0,0,0,.91-.19v67.59l-101,58.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.44,53l-.77.06-9.05,16.62a1.8,1.8,0,0,0-.9.26,3.3,3.3,0,0,0-1.56,2.35l-7.82,4.51a.92.92,0,0,0-.5-.57,1.52,1.52,0,0,0-1.34.19,3.24,3.24,0,0,0-1.57,2.49,1.06,1.06,0,0,0,.46.94l-9.21,16.91a1.83,1.83,0,0,0-.9.26,3.22,3.22,0,0,0-1.57,2.49.93.93,0,0,0,0,.24l-8,6.64a.85.85,0,0,0-.33-.26,1.52,1.52,0,0,0-1.34.19,3.28,3.28,0,0,0-.92.83l-8.67-3.73a2.54,2.54,0,0,0,.29-1.1,1,1,0,0,0-.58-1,1.48,1.48,0,0,0-1.34.18,3.24,3.24,0,0,0-1.57,2.5,1.21,1.21,0,0,0,.11.52l-8.31,9-.11-.07a1.52,1.52,0,0,0-1.34.19,3.22,3.22,0,0,0-1.57,2.49,1.68,1.68,0,0,0,.06.41l-8.18,18.6a1.22,1.22,0,0,0-.19-.12,1.52,1.52,0,0,0-1.34.19,3.22,3.22,0,0,0-1.57,2.49,1.09,1.09,0,0,0,.23.72l-8.65,11.53a1.52,1.52,0,0,0-1.22.22,3.19,3.19,0,0,0-1.58,2.49,1.28,1.28,0,0,0,.14.61l-8.42,16.67h0a1.49,1.49,0,0,0-1.33.18,3.23,3.23,0,0,0-1.58,2.5,1,1,0,0,0,.58,1,1.1,1.1,0,0,0,.54.08,1.9,1.9,0,0,0,.8-.27,3.24,3.24,0,0,0,1.58-2.49,1.32,1.32,0,0,0-.11-.51l8.46-16.75a1,1,0,0,0,.49.07,1.9,1.9,0,0,0,.8-.27,3.22,3.22,0,0,0,1.58-2.49,1.18,1.18,0,0,0-.19-.67l8.68-11.56a1,1,0,0,0,.35,0,2.08,2.08,0,0,0,.8-.26,3.25,3.25,0,0,0,1.58-2.5,1.1,1.1,0,0,0,0-.27l8.23-18.69.11.07a1.1,1.1,0,0,0,.54.08,1.79,1.79,0,0,0,.8-.26,3.25,3.25,0,0,0,1.58-2.5,1.24,1.24,0,0,0-.09-.45l8.35-9,0,0a1.23,1.23,0,0,0,.54.09,2,2,0,0,0,.8-.27,3.3,3.3,0,0,0,.94-.85l8.67,3.72a2.56,2.56,0,0,0-.31,1.12,1,1,0,0,0,.58,1,1.23,1.23,0,0,0,.54.09,2,2,0,0,0,.8-.27,3.24,3.24,0,0,0,1.57-2.5s0-.1,0-.16l8-6.66a1,1,0,0,0,.28.2,1.1,1.1,0,0,0,.54.08,1.79,1.79,0,0,0,.8-.26,3.24,3.24,0,0,0,1.57-2.5,1.07,1.07,0,0,0-.39-.89L326,80h0a2,2,0,0,0,.8-.27,3.3,3.3,0,0,0,1.55-2.28l7.85-4.53a.91.91,0,0,0,.48.52,1.18,1.18,0,0,0,.54.08,2,2,0,0,0,.8-.27,3.22,3.22,0,0,0,1.57-2.49,1.06,1.06,0,0,0-.39-.89ZM248,172.92a.77.77,0,0,1-.65.13c-.15-.06-.24-.25-.24-.51a2.59,2.59,0,0,1,1.23-1.95,1.07,1.07,0,0,1,.45-.16.33.33,0,0,1,.2,0c.15.06.24.25.24.51A2.63,2.63,0,0,1,248,172.92ZM259.19,153a.77.77,0,0,1-.65.13l-.07,0a.22.22,0,0,0-.1-.15h0a.79.79,0,0,1-.06-.32,2.61,2.61,0,0,1,1.23-2,.77.77,0,0,1,.65-.13c.15.06.24.25.24.51A2.63,2.63,0,0,1,259.19,153Zm11.21-15a.83.83,0,0,1-.62.14.27.27,0,0,0-.08-.07h-.05a.7.7,0,0,1-.13-.44,2.61,2.61,0,0,1,1.23-1.95.77.77,0,0,1,.65-.13c.15.06.23.25.23.51A2.59,2.59,0,0,1,270.4,138Zm11.22-21.57a.75.75,0,0,1-.64.13.29.29,0,0,1-.16-.15.23.23,0,0,0-.07-.22s0-.09,0-.14a2.61,2.61,0,0,1,1.23-2,.77.77,0,0,1,.65-.13c.15.06.23.25.23.51A2.59,2.59,0,0,1,281.62,116.44Zm11.22-12.13a.79.79,0,0,1-.64.14l-.06,0a.22.22,0,0,0-.1-.15h0a.76.76,0,0,1-.06-.32,2.57,2.57,0,0,1,1.23-1.94,1.07,1.07,0,0,1,.45-.16.43.43,0,0,1,.2,0c.15.07.23.25.23.52A2.57,2.57,0,0,1,292.84,104.31Zm11.22,4.82a.79.79,0,0,1-.64.14.54.54,0,0,1-.24-.52,2,2,0,0,1,.32-1,.76.76,0,0,0,.09-.09.28.28,0,0,0,0-.12,2.77,2.77,0,0,1,.78-.75,1.23,1.23,0,0,1,.45-.16.6.6,0,0,1,.2,0c.15.07.23.25.23.51A2.57,2.57,0,0,1,304.06,109.13Zm11.22-9.3a.75.75,0,0,1-.64.13.29.29,0,0,1-.16-.15.25.25,0,0,0-.07-.2s0-.1,0-.16a2.61,2.61,0,0,1,1.23-2,.77.77,0,0,1,.65-.13c.15.06.23.25.23.51A2.59,2.59,0,0,1,315.28,99.83Zm11.22-20.6a.8.8,0,0,1-.64.14.54.54,0,0,1-.24-.52,2.61,2.61,0,0,1,1.23-1.95.84.84,0,0,1,.65-.13c.15.07.23.25.23.51A2.57,2.57,0,0,1,326.5,79.23Zm11.22-6.47a.79.79,0,0,1-.64.13.43.43,0,0,1-.23-.39.26.26,0,0,0,0-.24,2.64,2.64,0,0,1,1.22-1.83.8.8,0,0,1,.64-.14.54.54,0,0,1,.24.52A2.61,2.61,0,0,1,337.72,72.76Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.67,56.2a.31.31,0,0,1-.37-.29V53l-3,1.4a.37.37,0,0,1-.49-.12.33.33,0,0,1,.19-.44l3.51-1.66a.43.43,0,0,1,.35,0,.28.28,0,0,1,.17.26v3.37A.37.37,0,0,1,348.67,56.2Z",
    style: {
      fill: "#800080"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.4 350.71 154.76 348.89 151.34 348.07 151.4 350.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,355.81S144.5,338.94,144.1,341.7a4.08,4.08,0,0,0,.08,1.65,1.71,1.71,0,0,0-.11-.14l.94,5.08a12,12,0,0,0,6.39,2.42c0-.25,0-1.77-.06-2.64a20.61,20.61,0,0,1,3.64,1.77c2.65,1.63,4.43,4.59,7.31,8,2.1,2.48,5.72,3.54,11,4.1,5.73.61,10.7-.68,12.06-2.27C186.48,358.39,185.83,356.15,185.61,355.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.46,354.9c-.41-.4-1.91-1.94-3.92-3.61-1.77-1.46-3.82-3.31-6-4.79a22.58,22.58,0,0,1-3-2.29,30.45,30.45,0,0,1-2.09-2.31,42.35,42.35,0,0,1-4.71-7.21,11.5,11.5,0,0,1-1.44-6.22,144.62,144.62,0,0,1,1.08-18.13l-19.48.32c.68,3.07,1.08,8.32,1.5,11.83.65,5.34.84,6.52-1,11.93-.55,1.6-1.41,3.14-1.43,4.83,0,2.74,2.2,5,4.64,6.27,2,1,4.32,1.43,6.28,2.55a19.8,19.8,0,0,1,5.22,4.78c1.43,1.7,2.6,3.73,4.55,4.89a17.64,17.64,0,0,0,6.67,2.05,35.27,35.27,0,0,0,8.86.12C184.33,359.43,187.4,357.78,184.46,354.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,352c-1.8-1.41-4.34-3.43-7.41-5.7a7.63,7.63,0,0,0-6.25.81c-5.89,3.4-6.75,7.93-6.75,7.93a8.65,8.65,0,0,0,5.06,4.14c7,2.79,19.44,1.37,19.44-1.85C186.12,355.28,184.21,353.71,182,352Zm-36.34-18.75s-.37,1.07-1.35,3.18a5.84,5.84,0,0,0,.29,6.19,9.2,9.2,0,0,0,6.24,3.93C152.57,340.39,148.15,334.48,145.69,333.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,340.54c1.15,1.84-.34,8.78-.08,13.72.24,4.49,1.44,12.31.06,16.75-1.63,5.25-5,11.35-11.13,6.43-3.83-3.05-6-7-6.55-13.46-.36-4.49,1.43-10.7,3-16.21,1.79-6.44,2.48-9.88,2.48-9.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61,307.43c-.44,10.47.78,17.82.85,24.52a47.09,47.09,0,0,1-1,9.06c-.88,4.28-2.37,10.23-3,13-.87,3.87-1.54,6.32-.2,10.66a5.35,5.35,0,0,0,.44,1c1.87,3.58,6.62,6.29,8.15,5.86a2.61,2.61,0,0,0,2.67.93,4.7,4.7,0,0,0,.51-.12l.51-.21a5.18,5.18,0,0,0,2.53-3.29c.09-.29.17-.61.24-.95,1.11-5.39.31-8.88.2-11-.12-2.43,0-5.53.24-9.46s1.15-16.26,2.51-22.16c1-4.12,2.28-9.28,3.61-14.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.58,359.05c3.75-1.65,14.62-1.88,16.35,3.41,0,5,.08,8.36-3.07,12.69-4.18,5.77-9.64-.34-11.73-4.22S97.07,361.74,97.58,359.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.79,170.66c-5.3,9.5-9.57,17.5-11,42.58-1.56,28.3-1.33,39.08-1.46,42.49s-2.34,9.68-4.21,26.5.1,57.6.1,57.6,1.32,2.75,7.76,3.37c5.93.58,9.42-1.51,9.42-1.51s11.45-51,13.72-61.15c3.21-14.33,7.93-42.72,7.93-42.72l2.9,23.87s-1.88,9.27-.17,24,4.86,43,4.86,43a20.77,20.77,0,0,0,8.78,3.19,14.92,14.92,0,0,0,9.59-2.07s5.75-58.56,5.88-75.29-1.17-58.48-6.26-83.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.85,202.48l-4.75,35.34,2.9,23.87-.66-24.21,4.14-29.57c4-.94,13.26-5.71,15.83-12.6C154,201.77,142.85,202.48,142.85,202.48Zm-18.72-18.94c.74-2.7,1.51-5.38,2.37-8.08a40.23,40.23,0,0,0-3.69,7.65,74.67,74.67,0,0,0-2.48,8.13,83.79,83.79,0,0,0-1.59,8.33,55.54,55.54,0,0,0-.62,8.46c.69-2.75,1.34-5.48,2-8.21s1.27-5.45,2-8.16S123.42,186.24,124.13,183.54Zm-4-2.06c.92-1.64,1.85-3.29,2.7-5a30.5,30.5,0,0,0-3.86,4.26,41.44,41.44,0,0,0-3.15,4.81,37.53,37.53,0,0,0-2.4,5.24,23.06,23.06,0,0,0-1.34,5.61l2.61-5c.89-1.65,1.77-3.3,2.69-4.93S119.18,183.13,120.1,181.48ZM116,288.89q-2.45,13-4.55,26.16,3.12-12.92,5.92-25.89c1.88-8.65,3.66-17.29,5.42-26s2.8-17.54,3.72-26.35,1.64-17.63,2.24-26.47c-1.29,8.77-2.45,17.54-3.62,26.31s-2.41,17.51-4.09,26.17S117.56,280.19,116,288.89ZM162,245.21c.15,3.84.35,7.7.26,11.49s-.37,7.67-.59,11.51L161,279.75q-.68,11.55-1.08,23.11,1.44-11.49,2.47-23c.69-7.69,1.34-15.34,1.65-23.11,0-7.8-.57-15.46-1.2-23.16s-1.53-15.36-2.66-23l1.27,23.09C161.66,237.52,161.88,241.36,162,245.21Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.5,130.84a10.06,10.06,0,0,0-2.38.85,12.29,12.29,0,0,0,4.11-4,2,2,0,0,0,.25-1c0-.28-.23-1.07-.68-1.2,0,0,.64-.8,1.22-1.48s1.43-1.92.41-2.37c-.8-.35-1.89.09-3.06.84a3,3,0,0,0,.92-1.64c-.07-1.14-.84-1.69-3-.45s-7.49,4.62-12,5c-.8.07-2.39.43-3.11,0h0c-1-.66.25-2,.76-2.59a16.19,16.19,0,0,0,1.35-1.74,6.34,6.34,0,0,0,1-2.23,2.82,2.82,0,0,0-.49-2.34c-.28-.34-.72-.59-1.08-.25-1.46,1.32-3,2.6-4.42,3.91a31.5,31.5,0,0,0-4,4c-1.32,1.7-2.3,4-4.23,6.35s-4,4.52-9,8.56c-2.74,2.23-7.3,6.28-7.3,6.28L165.59,126.2c-5.33-9.94-10-12.51-19.06-13.77l2.4,22.62s9.81,20.92,13.63,27.73,7.24,7.91,9.85,7.59h0c8.18-1.07,14.15-11.64,25.53-27.09a9.93,9.93,0,0,1,7.07-4.09c1.52-.15,3.22-.43,4.22-.58a27.09,27.09,0,0,0,4.5-1.26c2.41-.92,2.45-.73,5.81-3.5.41-.35,2.07-1.88,1.92-2.39A.9.9,0,0,0,220.5,130.84Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,131.69a23.68,23.68,0,0,1-3.33,1.43c-1.12.42-2.3.7-3.45,1.13a13.93,13.93,0,0,0,3.6-.71A8.92,8.92,0,0,0,218.12,131.69Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.65,134.59a2.39,2.39,0,0,1,.12-.7,4.39,4.39,0,0,1,.62-1.22,6,6,0,0,1,2-1.79,5.87,5.87,0,0,1,5.73.11c.05,0,.1.21,0,.2-1.84-.33-3.68-.56-5.4.36a6.16,6.16,0,0,0-2.75,3.79c0,.14-.19.1-.22,0A2.18,2.18,0,0,1,196.65,134.59Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.54,128a41.22,41.22,0,0,0,5.48-2.44c1.69-.85,3.33-1.82,5-2.77,0,0,0,0,0,.05a24.23,24.23,0,0,1-5.17,3.32,35.12,35.12,0,0,1-5.3,1.88S209.53,128,209.54,128Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.69,131.3a41.16,41.16,0,0,0,5.48-2.43c.68-.34,1.34-.7,2-1.07a20.79,20.79,0,0,0,1.93-1.14l.56-.4a5.74,5.74,0,0,1,.73-.48,2.49,2.49,0,0,1,.88-.23s.07,0,.06,0a3.29,3.29,0,0,0-1,.48,7,7,0,0,0-.6.48c-.18.15-.36.28-.54.42-.58.43-1.17.83-1.78,1.2-.77.47-1.57.89-2.37,1.29a34.42,34.42,0,0,1-5.3,1.88S209.67,131.31,209.69,131.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.69,111.91c9.48,1.13,13.62,3,17.42,8.85,3.58,5.56,12.95,24,12.95,24l8-6.45s-.53,2.4,2.18,6.8a10.72,10.72,0,0,0,7.14,5,126.44,126.44,0,0,1-9.45,12.85c-4.58,5.19-9.2,9.05-14.18,7.44s-7.27-6.41-10.17-12.07-11.18-23.38-11.18-23.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,159.24c1-5.33,4.42-11.87,8.52-14.47l-1-2C168.79,147.07,167.49,154.4,167.54,159.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158,70.53c-.53-5.55-6.76-6.09-8.42-6a7.86,7.86,0,0,1-6.28-3,7.9,7.9,0,0,0-7.54-2.63c-4.49,1-3.55,2.85-7.36,3.94-3.4,1-5.83-.25-9,2.51a8.65,8.65,0,0,0-2.61,7.16c-2.36,1.31-5.81,9.56-1.56,19,2.19,4.85,5,7.21,8.4,11.3l3.49.18c1.28-2.91,4.23-2.22,7-2.77,1.77-.7,2.85-2.6,4.62-3.3s3.85,0,5.77-.26c1.49-.19,3-1,4.55-.54,3.44,1.59,8.86-1.21,8.66-5.28-.08-1.23-.7-2.46-.41-3.65.39-1.58,2.12-2.37,3.09-3.67a4.24,4.24,0,0,0,0-5.08C158,75.65,158.3,73.69,158,70.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.51,114.14a4.83,4.83,0,0,0-2.22-1.23c-.87-.15-.93-1.1-1-2.64l0-2.38a10.61,10.61,0,0,0,7.88-2.1c3.34-2.66,5.31-8.16,5.28-14.16,0-4-1-5.9-.87-6.8.58-5.32.21-6.28-.91-9.1-2-4.49-7.59-6.35-10.23-1.74-6.71-5.74-14.72,1-14.8,9.28.63,6.84-1.48,7.08-2.8,7.06-1.76-4.32-6.15-4.45-8.12-1.8-1.78,2.4-1.91,6.21,1.15,9.83s6.58,1.51,6.66.83c0,0,.1,9.18.09,11s-.47,3.83-2.78,4.48h0a9.38,9.38,0,0,0-2.92,1.13,7.22,7.22,0,0,1,.84.8c.77,1,2,1.89,4.82,5.61,7.6,3.25,16.64,7.71,22,11.21a99.56,99.56,0,0,0,4.06-11.78A43.76,43.76,0,0,0,143.51,114.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,96.94a1.62,1.62,0,1,0,1.7-1.53A1.63,1.63,0,0,0,118.77,96.94Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.48,96.16l5.12,1.62a2.63,2.63,0,0,1-3.32,1.85A2.82,2.82,0,0,1,136.48,96.16Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81,97.35a3,3,0,0,1,3,2.29,2.52,2.52,0,0,1-1.49,0,2.75,2.75,0,0,1-1.87-2.23A1.75,1.75,0,0,1,136.81,97.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,82.63,147,81.37A2,2,0,0,1,149.56,80,2.16,2.16,0,0,1,151,82.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.26,82.71l3.9-1.51A2,2,0,0,0,133.53,80,2.2,2.2,0,0,0,132.26,82.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,86.55a1.74,1.74,0,0,0,1.56,1.83,1.64,1.64,0,0,0,1.81-1.49,1.74,1.74,0,0,0-1.56-1.84A1.64,1.64,0,0,0,146.05,86.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.82,86.21a1.76,1.76,0,0,0,1.59,1.87,1.65,1.65,0,0,0,1.84-1.52,1.78,1.78,0,0,0-1.59-1.88A1.66,1.66,0,0,0,133.82,86.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.26,107.89c-6.55-.65-12.84-2.43-14.45-6.43a6.73,6.73,0,0,0,3.74,5.58,23.68,23.68,0,0,0,10.73,2.77Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.08 91.53 141.05 93.75 140.26 82.43 147.08 91.53",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.5,158.86a79,79,0,0,1,.07-10.39s4.28-4.44,4.28-10.17c0-6-2.63-10.11-8.92-16.07a74.21,74.21,0,0,0-11.85-9.29l-4.79,0s3.14,6,1.29,9.7c-9.85-.74-18.3-5-21.77-7.93l-8.2,1.62s-5,10.5-3,19.19c1.09,4.71,3.25,12.68,5,19a26,26,0,0,1-1.68,18.36c-.25.52-.5,1.05-.75,1.56-2.37,4.89-5.5,13.89-5.5,13.89s13.77,6.17,36.39,3.43S167.57,185,167.57,185l-4.22-19.68A40.12,40.12,0,0,1,162.5,158.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.88,148.65a12.65,12.65,0,0,0,11.19,8,13.33,13.33,0,0,0,12-5.8s-1.36,9.2-12.29,8S124.88,148.65,124.88,148.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,113s8.74,16.61,11.81,25.6,1.94,16.32,1.54,32.81c-.31,12.7-1,31.87-1,31.87s-24,.57-31.84-9.86c1.72-6.37,7.33-21.29,8.76-25.37s.52-7.6-2.4-16.79-7.25-14.12-7.39-21a19.28,19.28,0,0,1,6.14-13.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.48,112.17a1.12,1.12,0,0,0,.57.73S158,128,159.71,144.16s4.13,51.73,4.13,51.73,1.74-.89,5-4.79c-1-7.35-4.67-36.38-4.11-39.75s8.22-11.26.52-21.83-19.6-17.61-19.6-17.61l-5.33-.58A4.35,4.35,0,0,0,140.48,112.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.17,115.66c1.07.89,2.14,1.79,3.17,2.73,2.08,1.87,4.14,3.75,6.14,5.7,1,1,2,2,2.94,3,.49.51,1,1,1.43,1.56a5.66,5.66,0,0,1,1.22,1.89,6.16,6.16,0,0,1,.21,2.24,13.49,13.49,0,0,1-.31,2.13,26.34,26.34,0,0,1-1.2,3.81,17,17,0,0,1,2.92,4.4,3.26,3.26,0,0,1,.2.73,3.79,3.79,0,0,1,0,.75c0,.47-.08.92-.13,1.38-.13.9-.27,1.8-.43,2.69-.62,3.57-1.4,7.1-2.25,10.61.56-3.57,1.14-7.14,1.64-10.71.12-.89.23-1.78.32-2.67,0-.45.08-.89.08-1.32a2.49,2.49,0,0,0-.19-1.18,17.23,17.23,0,0,0-3-4.3l-.18-.21.1-.25a24.58,24.58,0,0,0,1.19-3.92,13.94,13.94,0,0,0,.28-2,5,5,0,0,0-.15-1.9,4.86,4.86,0,0,0-1-1.59c-.44-.52-.91-1-1.38-1.55-.94-1-1.91-2-2.88-3-1.95-2-3.92-4-5.92-5.89s-4-3.89-6.12-5.69C146,113.87,147.1,114.77,148.17,115.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.36,138.3l-.08-2.21-.17-4.42c-.16-5.9-.32-11.8-.34-17.71.48,5.89.82,11.8,1.16,17.7l.21,4.43.11,2.22,0,.54a2,2,0,0,0,.07.42,2.23,2.23,0,0,0,.49.77,10.19,10.19,0,0,0,3.59,2.13,29.86,29.86,0,0,0,4.16,1.28l.48.11-.16.47a51.49,51.49,0,0,0-1.64,5.53c-.1.47-.19.94-.25,1.4a3.45,3.45,0,0,0,0,1.28l0,.12.09.16,1.22,2.24c.92,1.71,1.87,3.4,2.77,5.13l2.72,5.16-3.05-5c-1-1.66-2-3.34-3-5l-.74-1.26-.37-.63-.28-.47-.08-.22a3.89,3.89,0,0,1-.08-1.61,12,12,0,0,1,.23-1.48,48.87,48.87,0,0,1,1.46-5.2,30.45,30.45,0,0,1-3.85-1.16,10.35,10.35,0,0,1-3.94-2.38,3.07,3.07,0,0,1-.65-1.11,2.25,2.25,0,0,1-.11-.68Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.65,116.41c-7.81,1.68-10.75,6.6-13.81,17-4.2,14.13-7.82,28-8.44,35.06l18.35-5.78,9.16-20.36S117,126.1,108.65,116.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.27 193.52 108.89 188.88 100.82 137.66 141.2 142.29 149.27 193.52",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.27 193.52 108.89 188.88 100.82 137.66 141.2 142.29 149.27 193.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.7 191.32 109.01 186.87 101.49 139.09 140.17 143.54 147.7 191.32",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,177l-5.08-32.25-36.3-7.08,8.07,51.25,38.38,7.48a1,1,0,0,0,1.18-1.17l-2.58-16.34a1.82,1.82,0,0,0-1.38-1.44Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,168.41c.17,5.28,1,6.12,6.92,8.87s20.67,6.75,32.29,7.43c7.56.43,11.43-.07,14.31-1.34a12.11,12.11,0,0,0,7-13.55c1.11-3.68-.81-4.1-2.4-4.44l.38,2.37s-3.3,2.43-6.41,2.59-.36-3.59.11-5.82.32-3.48-1.53-4.46c-1,0-1.29,1.44-4.32,4.69-2.29,2.47-4,6.88-7.71,6.52-2.92-.29-20.44-7.62-20.44-7.62l-1-6.56Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,168.42c-.1,3.3.54,5,2.12,6.36s7.94,4.06,11.83,5.26,14.08,3.53,16,3.82c-2.12-3.06-1.87-9.24-.27-12.07s3.85-2.25,3.85-2.25l-15.07-6.1-1.41-9Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Target--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--target--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--target--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.68,51c-4-2.32-9.57-2-15.7,1.55C181.73,59.65,171.8,76.86,171.8,91c0,7.1,2.5,12.07,6.55,14.38,1.05.6,5.29,3.16,6.35,3.78,4,2.32,9.56,2,15.69-1.55,12.25-7.08,22.18-24.28,22.18-38.43,0-7.07-2.48-12-6.49-14.36",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,91h0c0,7.1,2.5,12.07,6.55,14.38,1.05.6,5.29,3.16,6.35,3.78,4,2.32,9.56,2,15.69-1.55Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,75.81A41.06,41.06,0,0,0,171.8,91l28.59,16.61h0a41.14,41.14,0,0,0,11.54-10.4Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.93,97.22c6.38-8.19,10.64-18.76,10.64-28,0-7.07-2.48-12-6.49-14.36l-6.4-3.8c-4-2.32-9.57-2-15.7,1.55-8,4.63-15,13.61-18.94,23.23Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,56.38c-12.25,7.08-22.19,24.28-22.19,38.43s9.94,19.88,22.19,12.81,22.2-24.28,22.18-38.43S212.63,49.31,200.39,56.38Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,56.38c-12.25,7.08-22.19,24.28-22.19,38.43s9.94,19.88,22.19,12.81,22.2-24.28,22.18-38.43S212.63,49.31,200.39,56.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,62.78C191.2,68.09,183.74,81,183.75,91.61s7.45,14.91,16.64,9.61S217,83,217,72.39,209.58,57.47,200.39,62.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,68.61c-6.41,3.69-11.6,12.69-11.6,20.08s5.19,10.4,11.6,6.7S212,82.7,212,75.3,206.79,64.91,200.39,68.61Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,68.61c-6.41,3.69-11.6,12.69-11.6,20.08s5.19,10.4,11.6,6.7S212,82.7,212,75.3,206.79,64.91,200.39,68.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,74.59A14.16,14.16,0,0,0,194,85.7c0,4.1,2.87,5.76,6.42,3.71a14.2,14.2,0,0,0,6.42-11.12C206.81,74.2,203.93,72.54,200.39,74.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,78.87a6,6,0,0,0-2.71,4.69c0,1.73,1.21,2.43,2.71,1.57a6,6,0,0,0,2.71-4.7C203.1,78.71,201.88,78,200.39,78.87Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.62,109.52s.52,6.51,3.53,8.24,4.63-3.53,2.68-4.65Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,109.52s5.9-2.81,8.9-1.07-.74,5.78-2.69,4.65Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,109.52s5.9-2.81,8.9-1.07-.74,5.78-2.69,4.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.1 87.45 258.26 116.42 258.91 115.27 208 85.86 208.1 87.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.46,114a1.94,1.94,0,1,0,2.66.71A1.95,1.95,0,0,0,257.46,114Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.26,87.35c1.59,2.1-1.29,5.74-1.29,5.74l-7.52-10.82Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.26,87.35c1.59,2.1-1.29,5.74-1.29,5.74l-7.52-10.82Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.58,83.36s-1.7,4.32-4.32,4l-8.81-5.08Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.58,83.36s-1.7,4.32-4.32,4l-8.81-5.08Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chess-pieces--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chess-piece--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.47,369.54c-8.69-5.06-22.78-5.06-31.47,0-4.35,2.54-6.5,5.85-6.5,9.17v3.79c0,3.32,2.14,6.64,6.5,9.18,8.69,5.06,22.78,5.06,31.47,0,4.35-2.54,6.51-5.86,6.49-9.18v-3.79C78,375.39,75.82,372.08,71.47,369.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.47,369.54c-8.69-5.06-22.78-5.06-31.47,0-4.35,2.54-6.5,5.85-6.5,9.17v3.79c0,3.32,2.14,6.64,6.5,9.18,8.69,5.06,22.78,5.06,31.47,0,4.35-2.54,6.51-5.86,6.49-9.18v-3.79C78,375.39,75.82,372.08,71.47,369.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.45,367.21A25.93,25.93,0,0,0,40,369.54c-4.35,2.54-6.5,5.85-6.5,9.17v3.79c0,3.32,2.14,6.64,6.5,9.18A25.93,25.93,0,0,0,45.45,394Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,369.54c8.69-5.06,22.78-5.06,31.47,0s8.69,13.28,0,18.34-22.78,5.06-31.47,0S31.31,374.61,40,369.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,369.54c8.69-5.06,22.78-5.06,31.47,0s8.69,13.28,0,18.34-22.78,5.06-31.47,0S31.31,374.61,40,369.54Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.72,360.79c-21.28,0-24,9.23-24,14s2.87,8.72,8.8,12.18h0a30.8,30.8,0,0,0,15.21,3.65A30.82,30.82,0,0,0,71,387c5.92-3.46,8.8-7.41,8.8-12.18S77,360.79,55.72,360.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.66,380.14l-.39.05c-1.59.22-4.5,0-5.78,1.28-2.16,2.11.82,3.93,2.69,4.52a13.45,13.45,0,0,0,9.39-.87,14.41,14.41,0,0,0,6.15-5.29c.58-1,1.67-3.9.22-4.58a2,2,0,0,0-2.3.58,18.71,18.71,0,0,1-2.25,1.6,15.55,15.55,0,0,1-2.21,1.26A20.42,20.42,0,0,1,63.66,380.14Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13,377.36c12.55,1.14,21.36-3.91,24.45-9.33-2.76-3.78-8.84-7.24-21.86-7.24-21.28,0-24,9.23-24,14s2.87,8.72,8.8,12.18h0a30.8,30.8,0,0,0,15.21,3.65A30.82,30.82,0,0,0,71,387a27.88,27.88,0,0,0,3.62-2.49c-4.48,3.14-11.88,5.48-21.44,4.07S40,376.17,53.13,377.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.48,373.42,44.31,362c-10.93,2.63-12.62,9.1-12.62,12.83,0,4.77,2.87,8.72,8.8,12.18h0l.58.3C34.53,383,38.58,371.39,45.48,373.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.43,348.66c-8.67-5.05-22.72-5.05-31.39,0-4.33,2.53-6.48,5.84-6.48,9.15v4.95c0,3.31,2.14,6.63,6.48,9.16,8.67,5.05,22.72,5.05,31.39,0,4.34-2.53,6.49-5.85,6.47-9.16v-4.95C77.91,354.5,75.76,351.19,71.43,348.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.43,348.66c-8.67-5.05-22.72-5.05-31.39,0-4.33,2.53-6.48,5.84-6.48,9.15v4.95c0,3.31,2.14,6.63,6.48,9.16,8.67,5.05,22.72,5.05,31.39,0,4.34-2.53,6.49-5.85,6.47-9.16v-4.95C77.91,354.5,75.76,351.19,71.43,348.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,371.92A24.91,24.91,0,0,0,44.85,374V346.55A24.91,24.91,0,0,0,40,348.66c-4.33,2.53-6.48,5.84-6.48,9.15v4.95C33.55,366.07,35.7,369.39,40,371.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,348.66c8.67-5.05,22.72-5.05,31.39,0s8.66,13.24,0,18.29S48.71,372,40,367,31.37,353.71,40,348.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.84,353.92h0c-2.76-5.74-9.75-23-9.75-51.35H45.36c0,28.33-7,45.61-9.75,51.35h0c-1.7,3.73.1,7.84,5.44,10.76,8.1,4.42,21.23,4.42,29.33,0C75.74,361.76,77.53,357.65,75.84,353.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.39,321.27a131.76,131.76,0,0,0,5.67,26.36c1.81,5.54,4.45,9.32,1,12.78s-12,4.51-12,4.51a26.84,26.84,0,0,0,8.36-5c3.54-3.33,1.42-8.16.36-12.28C67.1,340.93,64.79,330.5,65.39,321.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.44,367.9c-1.77-.7-5.43-2-2.71-15.69s2.67-35.31,2.61-49.64h-13c0,28.33-7,45.61-9.75,51.35h0c-1.7,3.73.1,7.84,5.44,10.76C45.81,367.27,52.27,368.34,58.44,367.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.36,345.15c2.42-9.18,3.15-28.07,3.2-42.58h-4.2c0,28.33-7,45.61-9.75,51.35h0c-1.7,3.73.1,7.84,5.44,10.76a24.52,24.52,0,0,0,4.5,1.85C38.81,362.38,43.84,354.69,46.36,345.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,287.25c-6.38-3.72-16.71-3.72-23.09,0-3.19,1.86-4.77,4.3-4.76,6.73v6c0,2.43,1.57,4.87,4.76,6.73,6.38,3.71,16.71,3.71,23.09,0,3.19-1.86,4.77-4.3,4.76-6.74v-6C72.05,291.54,70.47,289.1,67.28,287.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,287.25c-6.38-3.72-16.71-3.72-23.09,0-3.19,1.86-4.77,4.3-4.76,6.73v6c0,2.43,1.57,4.87,4.76,6.73,6.38,3.71,16.71,3.71,23.09,0,3.19-1.86,4.77-4.3,4.76-6.74v-6C72.05,291.54,70.47,289.1,67.28,287.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81,284.53a22.56,22.56,0,0,0-9.62,2.71c-3.19,1.86-4.77,4.3-4.76,6.73v6c0,2.43,1.57,4.87,4.76,6.73a22.42,22.42,0,0,0,9.62,2.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.19,287.24c6.38-3.71,16.71-3.71,23.09,0s6.37,9.73,0,13.45-16.71,3.71-23.09,0S37.82,291,44.19,287.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.44,264.41C61.87,260,49.6,260,42,264.4c-4.35,2.54-6.19,6-5.54,9.29h0l4.86,19.59h0c.38,1.81,1.74,3.57,4.13,5,5.66,3.3,14.84,3.3,20.51,0,2.38-1.39,3.75-3.15,4.13-5h0L75,273.69h0C75.63,270.38,73.79,266.94,69.44,264.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.69,265.22c-1.06,8.9-3.33,22.69-4.63,33a7.88,7.88,0,0,0,4.06-4.91h0L75,273.69h0C75.56,270.72,74.13,267.65,70.69,265.22Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35,262.52A22.46,22.46,0,0,0,42,264.4c-4.35,2.54-6.19,6-5.54,9.29h0l4.86,19.59h0c.38,1.81,1.74,3.57,4.13,5a17.1,17.1,0,0,0,4.06,1.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,264.4c7.57-4.41,19.84-4.4,27.41,0s7.57,11.56,0,16-19.84,4.41-27.41,0S34.46,268.82,42,264.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21,278.09c-6.34,3.69-16.61,3.69-22.95,0-3.65-2.12-5.19-5-4.64-7.77h0L43.68,255h0a6.58,6.58,0,0,1,3.46-4.15c4.74-2.76,12.43-2.76,17.17,0A6.61,6.61,0,0,1,67.78,255h0l4.07,15.32h0C72.39,273.09,70.86,276,67.21,278.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.25,277.41c-.88-7.45-2.78-17.92-3.87-26.52a6.56,6.56,0,0,1,3.4,4.11h0l4.07,15.32h0C72.34,272.8,71.14,275.37,68.25,277.41Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.88,279.67a18.51,18.51,0,0,1-3.62-1.58c-3.65-2.12-5.19-5-4.64-7.77h0L43.68,255h0a6.58,6.58,0,0,1,3.46-4.15,14.34,14.34,0,0,1,3.4-1.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.14,260.87c4.75,2.76,12.44,2.76,17.19,0s4.75-7.25,0-10-12.45-2.77-17.19,0S42.39,258.1,47.14,260.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,251.74h0a1.71,1.71,0,0,0-.2-.18,1.8,1.8,0,0,0-.2-.19,13,13,0,0,0-17.74,0l-.28.26c-.06.06-.14.12-.2.19h0c-2.29,2.38-1.71,5.44,1.76,7.46a16.59,16.59,0,0,0,15.15,0C66.81,257.23,67.37,254.12,65,251.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.47,249.33a12.84,12.84,0,0,1,4.32,3.16,4.32,4.32,0,0,1-.28,4.66,6.25,6.25,0,0,0-.47-4.37A11.82,11.82,0,0,0,60.47,249.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.46,257c-2.63-2.49-1.31-5.29.61-7.26a13.68,13.68,0,0,0-2.2,1.64l-.28.26c-.06.06-.14.12-.2.19h0c-2.29,2.38-1.71,5.44,1.76,7.46a16.59,16.59,0,0,0,15.15,0,8.42,8.42,0,0,0,1.81-1.41c-.14.13-1.34,1.23-5.4,1.65C53.47,260.16,50.46,258.87,48.46,257Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.79 231.4 60.79 237.29 65.84 234.34 65.84 240.24 60.79 243.18 60.79 252.47 55.73 255.41 55.73 246.13 50.68 249.07 50.68 243.18 55.73 240.24 55.73 234.34 60.79 231.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.73 255.41 50.68 252.47 50.68 249.07 55.73 246.13 55.73 255.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.68 243.18 45.62 240.24 45.62 246.13 50.68 249.07 50.68 243.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.73 240.24 50.68 237.29 45.62 240.24 50.68 243.18 55.73 240.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.73 240.24 50.68 237.29 45.62 240.24 50.68 243.18 55.73 240.24",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.73 234.34 50.68 231.4 50.68 237.29 55.73 240.24 55.73 234.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.79 231.4 55.73 228.45 50.68 231.4 55.73 234.34 60.79 231.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.79 231.4 55.73 228.45 50.68 231.4 55.73 234.34 60.79 231.4",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.84 234.34 60.79 231.4 60.79 237.29 65.84 234.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.84 234.34 60.79 231.4 60.79 237.29 65.84 234.34",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chess-piece--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.88,423.78c-7.24-4.18-19-4.18-26.2,0-3.62,2.09-5.41,4.82-5.4,7.56v3.12c0,2.74,1.78,5.48,5.4,7.57,7.23,4.18,19,4.18,26.2,0,3.62-2.1,5.41-4.84,5.4-7.58v-3.12C138.29,428.61,136.49,425.87,132.88,423.78Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.88,423.78c-7.24-4.18-19-4.18-26.2,0-3.62,2.09-5.41,4.82-5.4,7.56v3.12c0,2.74,1.78,5.48,5.4,7.57,7.23,4.18,19,4.18,26.2,0,3.62-2.1,5.41-4.84,5.4-7.58v-3.12C138.29,428.61,136.49,425.87,132.88,423.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.22,421.86a21.51,21.51,0,0,0-4.54,1.92c-3.62,2.09-5.41,4.82-5.4,7.56v3.12c0,2.74,1.78,5.48,5.4,7.57a21,21,0,0,0,4.54,1.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.68,423.78c7.24-4.18,19-4.18,26.2,0s7.23,11,0,15.12-19,4.18-26.2,0S99.45,428,106.68,423.78Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.68,423.78c7.24-4.18,19-4.18,26.2,0s7.23,11,0,15.12-19,4.18-26.2,0S99.45,428,106.68,423.78Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.77,416.56c-17.71,0-20,7.61-20,11.55s2.4,7.19,7.33,10h0a28.13,28.13,0,0,0,25.32,0c4.93-2.85,7.33-6.11,7.33-10S137.47,416.56,119.77,416.56Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.38,432.52l-.33,0c-1.32.18-3.74,0-4.81,1.06-1.8,1.74.68,3.23,2.24,3.72a11.23,11.23,0,0,0,7.81-.72,12.05,12.05,0,0,0,5.13-4.35c.48-.82,1.39-3.23.18-3.78a1.66,1.66,0,0,0-1.92.47,16.26,16.26,0,0,1-1.87,1.33,15,15,0,0,1-1.84,1A17.23,17.23,0,0,1,126.38,432.52Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61,430.23c10.45.94,17.78-3.23,20.35-7.7-2.3-3.12-7.35-6-18.19-6-17.71,0-20,7.61-20,11.55s2.4,7.19,7.33,10h0a28.13,28.13,0,0,0,25.32,0,23.7,23.7,0,0,0,3-2c-3.73,2.59-9.89,4.51-17.85,3.36S106.72,429.25,117.61,430.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.24,427l-1-9.46c-9.1,2.18-10.51,7.51-10.51,10.59,0,3.93,2.4,7.19,7.33,10h0c.15.09.32.17.48.25C102.13,434.88,105.5,425.31,111.24,427Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,407.21c-6.81-3.94-17.85-3.94-24.66,0-3.41,2-5.1,4.55-5.1,7.13,0,.49,0,3.37,0,3.86,0,2.58,1.68,5.16,5.09,7.13,6.82,3.93,17.86,3.93,24.67,0,3.41-2,5.1-4.55,5.09-7.14v-3.85C137.21,411.75,135.52,409.17,132.11,407.21Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,407.21c-6.81-3.94-17.85-3.94-24.66,0-3.41,2-5.1,4.55-5.1,7.13,0,.49,0,3.37,0,3.86,0,2.58,1.68,5.16,5.09,7.13,6.82,3.93,17.86,3.93,24.67,0,3.41-2,5.1-4.55,5.09-7.14v-3.85C137.21,411.75,135.52,409.17,132.11,407.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.44,425.32a20.16,20.16,0,0,0,3.78,1.64v-21.4a20.06,20.06,0,0,0-3.77,1.64c-3.41,2-5.1,4.55-5.1,7.13,0,.49,0,3.37,0,3.86C102.34,420.77,104,423.35,107.44,425.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.45,407.2c6.81-3.93,17.85-3.93,24.66,0s6.81,10.3,0,14.24-17.85,3.93-24.67,0S100.63,411.14,107.45,407.2Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.45,407.2c6.81-3.93,17.85-3.93,24.66,0s6.81,10.3,0,14.24-17.85,3.93-24.67,0S100.63,411.14,107.45,407.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,411.71h0c-2.1-4.31-7.39-17.27-7.39-38.52h-15.7c0,21.25-5.29,34.21-7.38,38.52h0c-1.28,2.8.08,5.88,4.12,8.06,6.13,3.32,16.07,3.32,22.2,0C134.92,417.59,136.28,414.51,135,411.71Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,387.22A98.15,98.15,0,0,0,131.38,407c1.37,4.16,3.37,7,.74,9.59s-9,3.39-9,3.39a20.26,20.26,0,0,0,6.32-3.76c2.69-2.5,1.08-6.13.28-9.22C128.38,402,126.63,394.14,127.09,387.22Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.83,422.19c-1.35-.53-4.12-1.48-2-11.77s2-26.48,2-37.23h-9.82c0,21.25-5.29,34.21-7.38,38.52h0c-1.28,2.8.08,5.88,4.12,8.06A24.87,24.87,0,0,0,121.83,422.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,405.12c1.83-6.88,2.39-21.05,2.43-31.93h-3.18c0,21.25-5.29,34.21-7.38,38.52h0c-1.28,2.8.08,5.88,4.12,8.06a18.29,18.29,0,0,0,3.41,1.39C107,418.05,110.78,412.29,112.68,405.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52,361.7c-4.83-2.79-12.65-2.79-17.48,0-2.41,1.39-3.61,3.21-3.6,5v4.48c0,1.83,1.19,3.66,3.6,5,4.83,2.79,12.65,2.79,17.48,0,2.41-1.39,3.61-3.22,3.6-5v-4.48C132.12,364.91,130.93,363.09,128.52,361.7Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52,361.7c-4.83-2.79-12.65-2.79-17.48,0-2.41,1.39-3.61,3.21-3.6,5v4.48c0,1.83,1.19,3.66,3.6,5,4.83,2.79,12.65,2.79,17.48,0,2.41-1.39,3.61-3.22,3.6-5v-4.48C132.12,364.91,130.93,363.09,128.52,361.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.32,359.66a17.05,17.05,0,0,0-7.28,2c-2.41,1.39-3.61,3.21-3.6,5v4.48c0,1.83,1.19,3.66,3.6,5a17.05,17.05,0,0,0,7.28,2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,361.7c4.83-2.79,12.65-2.79,17.48,0s4.82,7.3,0,10.08-12.65,2.79-17.48,0S106.22,364.48,111,361.7Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,361.7c4.83-2.79,12.65-2.79,17.48,0s4.82,7.3,0,10.08-12.65,2.79-17.48,0S106.22,364.48,111,361.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.48,343.31c-5.36-3.09-14-3.09-19.41,0-3.08,1.78-4.38,4.19-3.92,6.51h0l3.45,16.76h0a5.57,5.57,0,0,0,2.93,3.48,16,16,0,0,0,14.52,0,5.52,5.52,0,0,0,2.92-3.48h0l3.44-16.76h0C133.86,347.5,132.56,345.09,129.48,343.31Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.37,343.88c-.75,6.25-2.36,18.94-3.28,26.15a5.53,5.53,0,0,0,2.87-3.45h0l3.44-16.76h0C133.82,347.74,132.8,345.59,130.37,343.88Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14,342a15.7,15.7,0,0,0-3.07,1.32c-3.08,1.78-4.38,4.19-3.92,6.51h0l3.45,16.76h0a5.57,5.57,0,0,0,2.93,3.48,11.89,11.89,0,0,0,2.88,1.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,343.31c5.36-3.09,14.05-3.09,19.41,0s5.36,8.11,0,11.21-14,3.09-19.41,0S104.71,346.41,110.07,343.31Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,343.31c5.36-3.09,14.05-3.09,19.41,0s5.36,8.11,0,11.21-14,3.09-19.41,0S104.71,346.41,110.07,343.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.29,344.92h0l-.2-.18-.21-.19a13.41,13.41,0,0,0-18.21,0l-.28.26-.22.2h0c-2.35,2.41-1.76,5.53,1.8,7.58a17.21,17.21,0,0,0,15.55,0C131.15,350.51,131.72,347.35,129.29,344.92Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64,342.48a13.15,13.15,0,0,1,4.44,3.21,4.37,4.37,0,0,1-.3,4.74,6.22,6.22,0,0,0-.48-4.44A11.9,11.9,0,0,0,124.64,342.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.31,350.25c-2.7-2.53-1.34-5.37.63-7.38a13.75,13.75,0,0,0-2.26,1.67l-.28.26-.22.2h0c-2.35,2.41-1.76,5.53,1.8,7.58a17.21,17.21,0,0,0,15.55,0,8.38,8.38,0,0,0,1.86-1.44c-.15.13-1.37,1.25-5.54,1.68C117.46,353.49,114.37,352.18,112.31,350.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,338.08a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,125.45,338.08Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,338.08a5.67,5.67,0,1,1-6.31-5.63,4.69,4.69,0,1,0,6.3,5.46A1,1,0,0,1,125.45,338.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44,333.42a2.74,2.74,0,0,0-1.21,0,1.13,1.13,0,0,0-1,1.17c0,.72.84,1,1.43,1.2l1,.31c.44.13.83.4,1.28.53s.72-.25.74-.67a2,2,0,0,0-.21-1,2.53,2.53,0,0,0-.72-.87A2.93,2.93,0,0,0,121.44,333.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.27 348.22 238.2 345.37 236.57 431.35 233.27 433.26 233.27 348.22",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.27 348.22 228.33 345.37 229.96 431.35 233.27 433.26 233.27 348.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.67 282.8 351.6 279.94 349.98 365.92 346.67 367.83 346.67 282.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.67 282.8 341.74 279.94 343.37 365.92 346.67 367.83 346.67 282.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.57 306.26 165.5 303.41 163.88 389.39 160.57 391.3 160.57 306.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.57 306.26 155.64 303.41 157.27 389.39 160.57 391.3 160.57 306.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.98 240.84 278.91 237.98 277.28 323.96 273.98 325.87 273.98 240.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.98 240.84 269.05 237.98 270.67 323.96 273.98 325.87 273.98 240.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.76,296.47v-4.25a2.42,2.42,0,0,1,1.1-1.9l160-92.34a2.42,2.42,0,0,1,2.19,0L383.87,256.3a2.4,2.4,0,0,1,1.1,1.89v4.25a2.44,2.44,0,0,1-1.1,1.9l-160,92.34a2.42,2.42,0,0,1-2.19,0L120.86,298.36A2.4,2.4,0,0,1,119.76,296.47Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.76,296.47v-4.25a2.42,2.42,0,0,1,1.1-1.9l160-92.34a2.42,2.42,0,0,1,2.19,0L383.87,256.3a2.4,2.4,0,0,1,1.1,1.89v4.25a2.44,2.44,0,0,1-1.1,1.9l-160,92.34a2.42,2.42,0,0,1-2.19,0L120.86,298.36A2.4,2.4,0,0,1,119.76,296.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.79,350.17v6.77a2.4,2.4,0,0,1-1.09-.25L120.86,298.37a2.42,2.42,0,0,1-1.09-1.9v-4.25a2.39,2.39,0,0,1,.89-1.75c-.4.34-.33.81.2,1.12L221.7,349.91A2.17,2.17,0,0,0,222.79,350.17Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86,291.59,221.7,349.91a2.48,2.48,0,0,0,2.19,0l160-92.35a.66.66,0,0,0,0-1.26L283,198a2.42,2.42,0,0,0-2.19,0l-160,92.34A.67.67,0,0,0,120.86,291.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.94,198.72a1.17,1.17,0,0,1,.59.13L383,256.93,223.39,349a1.3,1.3,0,0,1-.6.13,1.29,1.29,0,0,1-.59-.13L121.77,291l159.58-92.1a1.11,1.11,0,0,1,.59-.13m0-1a2.32,2.32,0,0,0-1.1.26l-160,92.34a.67.67,0,0,0,0,1.27L221.7,349.91a2.28,2.28,0,0,0,1.09.26,2.32,2.32,0,0,0,1.1-.26l160-92.35a.66.66,0,0,0,0-1.26L283,198a2.28,2.28,0,0,0-1.09-.26Z",
    style: {
      fill: "#800080"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M180,317.28a3.16,3.16,0,0,0,1.61-.41l15.57-9a1.8,1.8,0,0,0,0-3.24l-27.78-16a3.39,3.39,0,0,0-3.23,0l-15.57,9a1.8,1.8,0,0,0,0,3.24l27.78,16A3.17,3.17,0,0,0,180,317.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calculator--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.62,303.46a.71.71,0,0,1,.42.58c0,.22,0,2,0,2.24a.74.74,0,0,1-.43.58l-15.56,9a2.25,2.25,0,0,1-2.05,0l-27.78-16a.73.73,0,0,1-.43-.59V297a.72.72,0,0,1,.42-.6l15.57-9a2.25,2.25,0,0,1,2.05,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.22,297.59l27.78,16a2.31,2.31,0,0,0,2.05,0l15.57-9a.62.62,0,0,0,0-1.18l-27.78-16a2.25,2.25,0,0,0-2.05,0l-15.57,9A.62.62,0,0,0,151.22,297.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.27,301.83a.13.13,0,0,1-.07.11l-2.28,1.32a.72.72,0,0,1-.61-.07l-1.93-1.12c-.13-.08-.2-.17-.2-.24v-.56a.13.13,0,0,1,.07-.11l2.29-1.32a.71.71,0,0,1,.6.08l1.94,1.12c.13.07.2.16.2.24S166.28,301.76,166.27,301.83Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.18,301.27h0v.56c0,.07.07.16.2.24l1.93,1.12a1.18,1.18,0,0,0,.35.11v-.56a1,1,0,0,1-.35-.11l-1.93-1.12C161.24,301.43,161.18,301.34,161.18,301.27Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,301.28a.19.19,0,0,1-.07.11l-2.29,1.32a.52.52,0,0,1-.26,0v.56a.44.44,0,0,0,.26,0l2.28-1.32a.13.13,0,0,0,.07-.11C166.28,301.76,166.27,301.34,166.28,301.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.54,299.84l-2.29,1.32c-.13.08-.08.23.13.35l1.94,1.12a.71.71,0,0,0,.6.08l2.29-1.32c.13-.08.07-.24-.13-.35l-1.94-1.12A.71.71,0,0,0,163.54,299.84Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36,299.47a.12.12,0,0,1-.07.11L168,300.9a.7.7,0,0,1-.6-.07l-1.94-1.12c-.13-.08-.2-.17-.2-.24v-.56a.1.1,0,0,1,.07-.1l2.29-1.32a.67.67,0,0,1,.6.07l1.94,1.12a.33.33,0,0,1,.2.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26,298.91h0v.56c0,.07.07.16.2.24l1.94,1.12a.85.85,0,0,0,.34.11v-.56a.72.72,0,0,1-.34-.11l-1.94-1.12C165.33,299.08,165.26,299,165.26,298.91Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36,298.93s0,.07-.07.1L168,300.35a.42.42,0,0,1-.26,0v.56a.42.42,0,0,0,.26,0l2.29-1.32s.07-.06.07-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,297.49l-2.29,1.32c-.13.07-.07.23.13.34l1.94,1.12a.71.71,0,0,0,.6.08l2.29-1.32c.13-.08.07-.23-.13-.35l-1.94-1.12A.67.67,0,0,0,167.62,297.49Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.44,297.12a.1.1,0,0,1-.07.1l-2.29,1.32a.67.67,0,0,1-.6-.07l-1.94-1.12c-.13-.07-.2-.16-.2-.24v-.55a.14.14,0,0,1,.07-.11l2.29-1.32a.72.72,0,0,1,.61.07l1.93,1.12c.13.08.2.17.2.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,296.55h0v.55c0,.08.07.17.2.24l1.94,1.12a.89.89,0,0,0,.35.11V298a.89.89,0,0,1-.35-.11l-1.94-1.12C169.41,296.72,169.34,296.63,169.35,296.55Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.44,296.57s0,.07-.07.1L172.08,298a.39.39,0,0,1-.25,0v.55a.39.39,0,0,0,.25,0l2.29-1.32a.1.1,0,0,0,.07-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,295.13l-2.29,1.32c-.13.07-.07.23.13.35l1.94,1.12a.7.7,0,0,0,.6.07l2.29-1.32c.13-.08.08-.23-.13-.35l-1.93-1.12A.72.72,0,0,0,171.7,295.13Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,306.56a.15.15,0,0,1-.07.11L188.44,308a.71.71,0,0,1-.6-.08l-1.94-1.12c-.13-.07-.2-.16-.2-.24V306a.13.13,0,0,1,.07-.11l2.29-1.32a.7.7,0,0,1,.6.07l1.94,1.12c.13.08.2.17.2.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,306a.14.14,0,0,1-.07.1l-2.29,1.32a.42.42,0,0,1-.26,0V308a.52.52,0,0,0,.26,0l2.29-1.32a.15.15,0,0,0,.07-.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.7,306h0v.55c0,.08.07.17.2.24l1.94,1.12a.85.85,0,0,0,.34.11v-.55a.85.85,0,0,1-.34-.11l-1.94-1.12C185.77,306.16,185.7,306.07,185.7,306Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.45,301.83a.14.14,0,0,1-.07.11l-2.29,1.32a.7.7,0,0,1-.6-.07l-1.94-1.12c-.13-.08-.2-.17-.2-.24v-.55a.11.11,0,0,1,.07-.11l2.29-1.32a.67.67,0,0,1,.6.07l1.94,1.12c.13.08.2.17.2.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.45,301.29s0,.07-.07.1l-2.29,1.32a.43.43,0,0,1-.26,0v.56a.42.42,0,0,0,.26,0l2.29-1.32s.07-.06.07-.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,301.27h0v.56c0,.07.07.16.2.24l1.94,1.12a.85.85,0,0,0,.34.11v-.56a.72.72,0,0,1-.34-.11l-1.94-1.12C169.42,301.44,169.35,301.35,169.35,301.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36,304.19a.13.13,0,0,1-.07.11L168,305.62a.72.72,0,0,1-.61-.07l-1.94-1.12c-.12-.08-.19-.17-.19-.24v-.56a.13.13,0,0,1,.07-.11l2.28-1.32a.73.73,0,0,1,.61.08l1.94,1.12c.13.07.2.16.19.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36,303.64a.13.13,0,0,1-.07.11L168,305.07a.53.53,0,0,1-.26,0v.56a.44.44,0,0,0,.26,0l2.28-1.32a.13.13,0,0,0,.07-.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.27,303.63h0v.56c0,.07.07.16.19.24l1.94,1.12a.89.89,0,0,0,.35.11v-.56a.89.89,0,0,1-.35-.11l-1.93-1.12C165.33,303.8,165.26,303.7,165.27,303.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,299.48a.1.1,0,0,1-.07.1l-2.29,1.32a.67.67,0,0,1-.6-.07l-1.94-1.12c-.13-.07-.2-.16-.2-.24v-.55a.14.14,0,0,1,.07-.11l2.29-1.32a.7.7,0,0,1,.6.07l1.94,1.12c.13.08.2.17.2.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,298.93s0,.07-.07.1l-2.29,1.32a.41.41,0,0,1-.26,0v.55a.41.41,0,0,0,.26,0l2.29-1.32a.1.1,0,0,0,.07-.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,298.91h0v.55c0,.08.07.17.2.24l1.94,1.12a.9.9,0,0,0,.34.11v-.55a.9.9,0,0,1-.34-.11l-1.94-1.12C173.5,299.08,173.43,299,173.43,298.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,304.19a.12.12,0,0,1-.07.11l-2.28,1.32a.72.72,0,0,1-.61-.07l-1.94-1.12c-.12-.08-.19-.17-.19-.24v-.56a.1.1,0,0,1,.07-.1l2.28-1.32a.69.69,0,0,1,.61.07l1.94,1.12c.13.07.2.17.19.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,303.65s0,.07-.07.1l-2.28,1.32a.44.44,0,0,1-.26,0v.56a.44.44,0,0,0,.26,0l2.28-1.32a.12.12,0,0,0,.07-.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,303.63h0v.56c0,.07.07.16.19.24l1.94,1.12a.89.89,0,0,0,.35.11v-.56a.76.76,0,0,1-.35-.11l-1.93-1.12C173.5,303.8,173.43,303.71,173.44,303.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.45,306.55a.13.13,0,0,1-.07.11L172.09,308a.74.74,0,0,1-.6-.07l-1.94-1.12c-.13-.08-.2-.17-.2-.24V306a.15.15,0,0,1,.07-.11l2.29-1.32a.71.71,0,0,1,.6.08l1.94,1.12c.13.07.2.16.2.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.45,306a.13.13,0,0,1-.07.11l-2.29,1.32a.5.5,0,0,1-.26,0V308a.41.41,0,0,0,.26,0l2.29-1.32a.13.13,0,0,0,.07-.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,306h0v.56c0,.07.07.16.2.24l1.94,1.12a1.12,1.12,0,0,0,.34.11v-.56a.9.9,0,0,1-.34-.11l-1.94-1.12C169.42,306.15,169.35,306.06,169.35,306Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,301.84a.12.12,0,0,1-.07.1l-2.29,1.32a.67.67,0,0,1-.6-.07l-1.94-1.12c-.13-.07-.2-.16-.2-.24v-.55a.12.12,0,0,1,.07-.11l2.29-1.32a.7.7,0,0,1,.6.07l1.94,1.12c.13.08.2.17.2.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,301.29s0,.07-.07.1l-2.29,1.32a.42.42,0,0,1-.26,0v.55a.42.42,0,0,0,.26,0l2.29-1.32a.12.12,0,0,0,.07-.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.52,301.27h0v.55c0,.08.07.17.2.24l1.94,1.12a.85.85,0,0,0,.34.11v-.55a1,1,0,0,1-.34-.11l-1.94-1.12C177.59,301.44,177.52,301.35,177.52,301.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,306.55a.12.12,0,0,1-.07.11L180.26,308a.7.7,0,0,1-.6-.07l-1.94-1.12c-.13-.08-.2-.17-.2-.24V306a.12.12,0,0,1,.07-.1l2.29-1.32a.67.67,0,0,1,.6.07l1.94,1.12a.33.33,0,0,1,.2.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,306s0,.07-.07.1l-2.29,1.32a.39.39,0,0,1-.25,0V308a.39.39,0,0,0,.25,0l2.29-1.32s.07-.06.07-.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,306h0v.56c0,.07.07.16.2.24l1.94,1.12a.89.89,0,0,0,.35.11v-.56a.89.89,0,0,1-.35-.11l-1.94-1.12C177.59,306.16,177.52,306.07,177.53,306Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,308.91a.15.15,0,0,1-.07.11l-2.29,1.32a.74.74,0,0,1-.6-.07l-1.94-1.12c-.13-.08-.2-.17-.2-.24v-.56a.13.13,0,0,1,.07-.11l2.29-1.32a.71.71,0,0,1,.6.08l1.94,1.12c.13.07.2.16.2.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,308.36a.15.15,0,0,1-.07.11l-2.29,1.31a.42.42,0,0,1-.26,0v.56a.42.42,0,0,0,.26,0l2.29-1.32a.15.15,0,0,0,.07-.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,308.35h0v.56c0,.07.07.16.2.24l1.94,1.12a1,1,0,0,0,.34.11v-.56a.85.85,0,0,1-.34-.11l-1.94-1.12C173.51,308.51,173.44,308.42,173.44,308.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,304.2a.1.1,0,0,1-.07.1l-2.28,1.32a.69.69,0,0,1-.61-.07l-1.93-1.12c-.13-.07-.2-.16-.2-.24v-.55a.12.12,0,0,1,.07-.11l2.29-1.32a.7.7,0,0,1,.6.07l1.94,1.12c.13.08.2.17.2.24S186.71,304.12,186.7,304.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71,303.65a.17.17,0,0,1-.07.1l-2.29,1.32a.42.42,0,0,1-.26,0v.55a.44.44,0,0,0,.26,0l2.28-1.32a.1.1,0,0,0,.07-.1C186.71,304.12,186.7,303.7,186.71,303.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.61,303.63h0v.55a.32.32,0,0,0,.19.24l1.94,1.12a1,1,0,0,0,.35.11v-.55a1,1,0,0,1-.35-.11l-1.93-1.12C181.67,303.8,181.61,303.71,181.61,303.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,294.76a.17.17,0,0,1-.08.11l-2.28,1.32a.73.73,0,0,1-.61-.08L173.63,295c-.13-.07-.2-.16-.2-.24v-.55a.13.13,0,0,1,.07-.11l2.29-1.32a.74.74,0,0,1,.6.07l1.94,1.12c.13.08.2.17.2.25S178.53,294.68,178.53,294.76Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,294.19h0v.55c0,.08.07.17.2.24l1.93,1.12a1,1,0,0,0,.35.11v-.55a.85.85,0,0,1-.34-.11l-1.94-1.12C173.5,294.36,173.43,294.27,173.43,294.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,294.21a.14.14,0,0,1-.07.1l-2.29,1.32a.42.42,0,0,1-.26,0v.55a.53.53,0,0,0,.26,0l2.28-1.32a.17.17,0,0,0,.08-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.79,292.77l-2.29,1.32c-.13.08-.07.23.13.35l1.94,1.12a.7.7,0,0,0,.6.07l2.29-1.32c.13-.07.07-.23-.13-.35l-1.94-1.12A.74.74,0,0,0,175.79,292.77Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88,304.2a.13.13,0,0,1-.07.11l-2.29,1.32a.71.71,0,0,1-.6-.08L190,304.43c-.13-.07-.2-.16-.2-.23v-.56a.13.13,0,0,1,.07-.11l2.29-1.32a.71.71,0,0,1,.6.08l1.94,1.12c.13.07.2.16.2.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.78,303.63h0v.56c0,.07.07.16.2.23l1.94,1.12a.72.72,0,0,0,.34.11v-.55a.85.85,0,0,1-.34-.11L190,303.88C189.85,303.8,189.78,303.71,189.78,303.63Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88,303.65a.12.12,0,0,1-.07.1l-2.29,1.32a.41.41,0,0,1-.26,0v.55a.52.52,0,0,0,.26,0l2.29-1.32a.13.13,0,0,0,.07-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.14,302.21l-2.29,1.32c-.13.08-.07.23.13.35l1.94,1.12a.67.67,0,0,0,.6.07l2.29-1.32c.13-.07.07-.23-.13-.34l-1.94-1.12A.71.71,0,0,0,192.14,302.21Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71,308.92a.1.1,0,0,1-.07.1l-2.29,1.32a.67.67,0,0,1-.6-.07l-1.94-1.12c-.13-.07-.2-.16-.2-.24s0-.48,0-.55,0-.08.08-.11l2.28-1.32a.72.72,0,0,1,.61.07l1.93,1.12c.13.08.2.17.2.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.62,308.35h0v.55c0,.08.07.17.2.24l1.94,1.12a.89.89,0,0,0,.35.11v-.55a1.1,1.1,0,0,1-.35-.11l-1.94-1.12C181.68,308.52,181.61,308.43,181.62,308.35Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71,308.37s0,.07-.07.1l-2.29,1.32a.39.39,0,0,1-.25,0v.55a.39.39,0,0,0,.25,0l2.29-1.32a.1.1,0,0,0,.07-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,306.93l-2.28,1.32c-.14.07-.08.23.12.35l1.94,1.12a.74.74,0,0,0,.6.07l2.29-1.32c.13-.08.08-.23-.13-.35L184.58,307A.72.72,0,0,0,184,306.93Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.63,311.27a.14.14,0,0,1-.07.11l-2.29,1.32a.7.7,0,0,1-.6-.07l-1.94-1.12c-.13-.08-.2-.17-.2-.24v-.56a.1.1,0,0,1,.07-.1l2.29-1.32a.67.67,0,0,1,.6.07l1.94,1.12a.33.33,0,0,1,.2.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,310.71h0v.56c0,.07.07.16.2.24l1.94,1.12a.85.85,0,0,0,.34.11v-.56a.85.85,0,0,1-.34-.11L177.73,311A.33.33,0,0,1,177.53,310.71Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.63,310.72a.14.14,0,0,1-.07.11l-2.29,1.32a.5.5,0,0,1-.26,0v.56a.42.42,0,0,0,.26,0l2.29-1.32a.14.14,0,0,0,.07-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.89,309.29l-2.29,1.32c-.13.07-.07.23.13.34l1.94,1.12a.71.71,0,0,0,.6.08l2.29-1.32c.13-.08.07-.23-.13-.35l-1.94-1.12A.67.67,0,0,0,179.89,309.29Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,297.12a.13.13,0,0,1-.07.11l-2.28,1.32a.73.73,0,0,1-.61-.08l-1.94-1.12a.32.32,0,0,1-.19-.24v-.55a.13.13,0,0,1,.07-.11l2.29-1.32a.71.71,0,0,1,.6.08l1.94,1.11c.13.08.2.17.19.25Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.52,296.55h0v.55a.32.32,0,0,0,.19.24l1.94,1.12a.89.89,0,0,0,.35.11V298a.89.89,0,0,1-.35-.11l-1.93-1.12C177.58,296.72,177.51,296.63,177.52,296.55Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,296.57a.1.1,0,0,1-.07.1L180.26,298a.44.44,0,0,1-.26,0v.55a.53.53,0,0,0,.26,0l2.28-1.32a.13.13,0,0,0,.07-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.88,295.13l-2.29,1.32c-.13.08-.08.23.13.35l1.93,1.12a.69.69,0,0,0,.61.07l2.28-1.32c.14-.07.08-.23-.12-.35l-1.94-1.11A.71.71,0,0,0,179.88,295.13Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,299.48a.13.13,0,0,1-.07.11l-2.29,1.32a.71.71,0,0,1-.6-.08l-1.94-1.12c-.13-.07-.2-.16-.2-.24s0-.47,0-.55a.13.13,0,0,1,.07-.11l2.28-1.32a.73.73,0,0,1,.61.08l1.93,1.12c.13.07.2.16.2.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.61,298.91h0c0,.08,0,.51,0,.56a.35.35,0,0,0,.2.23l1.94,1.12a.89.89,0,0,0,.35.11v-.55a.89.89,0,0,1-.35-.11l-1.94-1.12C181.67,299.08,181.6,299,181.61,298.91Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,298.93a.1.1,0,0,1-.07.1l-2.28,1.32a.44.44,0,0,1-.26,0v.55a.48.48,0,0,0,.25,0l2.29-1.32a.13.13,0,0,0,.07-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,297.49l-2.28,1.32c-.14.08-.08.23.12.35l1.94,1.12a.69.69,0,0,0,.61.07l2.28-1.32c.13-.07.08-.23-.13-.34l-1.93-1.12A.73.73,0,0,0,184,297.49Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.79,301.84a.13.13,0,0,1-.07.11l-2.29,1.32a.71.71,0,0,1-.6-.08l-1.94-1.12c-.13-.07-.2-.16-.2-.23v-.56a.15.15,0,0,1,.07-.11l2.29-1.32a.71.71,0,0,1,.6.08l1.94,1.12c.13.07.2.16.2.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.69,301.27h0v.56c0,.07.07.16.2.23l1.94,1.12a.76.76,0,0,0,.34.11v-.55a.89.89,0,0,1-.35-.11l-1.94-1.12C185.76,301.44,185.69,301.35,185.69,301.27Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.79,301.29a.1.1,0,0,1-.07.1l-2.29,1.32a.39.39,0,0,1-.25,0v.55a.5.5,0,0,0,.26,0l2.29-1.32a.13.13,0,0,0,.07-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,299.85l-2.29,1.32c-.13.08-.07.23.13.35l1.94,1.12a.67.67,0,0,0,.6.07l2.29-1.32c.13-.07.07-.23-.13-.34l-1.94-1.12A.71.71,0,0,0,188.05,299.85Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.16,304.1h0l-.61-.68-.39.23h-.09l-.18-.11,0,0a0,0,0,0,1,0,0l.64-.36h.08l.17.1.07.06.6.69,0,0s0,0,0,0l-.19.11h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.25,301.36a.47.47,0,0,1-.13-.11.3.3,0,0,1,0-.11.28.28,0,0,1,0-.12.4.4,0,0,1,.12-.1l.17-.07.2,0a.69.69,0,0,1,.2,0,.62.62,0,0,1,.19.07.35.35,0,0,1,.11.09.24.24,0,0,1,.06.09l.18,0a.61.61,0,0,1,.17.07.36.36,0,0,1,.13.11.21.21,0,0,1,0,.11.26.26,0,0,1-.05.12.36.36,0,0,1-.13.11.75.75,0,0,1-.18.07.69.69,0,0,1-.2,0l-.21,0a.62.62,0,0,1-.19-.07.4.4,0,0,1-.12-.1.24.24,0,0,1-.05-.1l-.16,0Zm.73.16a.24.24,0,0,0,.12,0,.3.3,0,0,0,.15-.05c.05,0,.07-.05.07-.08s0-.05,0-.07a.28.28,0,0,0-.13,0,.3.3,0,0,0-.14.05s-.08.05-.08.08S172,301.5,172,301.52Zm-.48-.3a.21.21,0,0,0,.12,0,.19.19,0,0,0,.12,0s.06,0,.06-.07,0-.05-.05-.07a.21.21,0,0,0-.12,0,.31.31,0,0,0-.13,0s-.06.05-.06.08S171.46,301.2,171.5,301.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.38,299.05a.39.39,0,0,1-.15-.13.24.24,0,0,1,0-.13.27.27,0,0,1,0-.12.4.4,0,0,1,.12-.1l.17-.07.22,0a.83.83,0,0,1,.22,0,.85.85,0,0,1,.22.09l.09.06.06.06,0,.06,0,.06.21.41v0a0,0,0,0,1,0,0l-.21.12h-.09l-.14-.28-.18.05h-.19a.64.64,0,0,1-.2,0Zm.53-.31-.07,0h-.16l-.07,0,0,0a.07.07,0,0,0,0,.05.06.06,0,0,0,0,0l.06.05.07,0h.16s0,0,.07,0l0,0s0,0,0-.05l0-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,306.33h0l-.05,0-.18-.1-.42.24h0l0,0-.19-.11a.1.1,0,0,1-.06,0l-.27-.62s0,0,0,0l0,0,.2-.12h0l0,0,.68.39.12-.06h.08l.19.11,0,0s0,0,0,0l-.11.07.18.1,0,0a0,0,0,0,1,0,0Zm-.55-.28-.32-.19.13.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.07,303.87h.18l.06,0,0,0a.05.05,0,0,0,0,0l0,0a.12.12,0,0,0,0-.05.33.33,0,0,0-.14,0,.2.2,0,0,0-.13,0l0,0,0,0v0l-.21.12h-.08l-.59-.39,0,0a0,0,0,0,1,0,0l.57-.33h.09l.18.11,0,0v0l-.39.22.15.1s0,0,0-.05l.06-.05a.49.49,0,0,1,.17-.06.68.68,0,0,1,.2,0l.21,0a.88.88,0,0,1,.2.09.55.55,0,0,1,.16.12.49.49,0,0,1,.06.13.28.28,0,0,1,0,.12.34.34,0,0,1-.13.1.64.64,0,0,1-.19.08.71.71,0,0,1-.2,0l-.2,0-.17-.07,0,0s0,0,0,0l.17-.1h.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.63,301.17a.39.39,0,0,1,.15.13.18.18,0,0,1,.06.13.19.19,0,0,1,0,.12.43.43,0,0,1-.12.11l-.18.07-.22,0-.23,0a1,1,0,0,1-.22-.09l-.09-.07-.06-.06,0-.06,0-.05-.2-.42v0l0,0,.21-.12h0l0,0h0l.14.28.18-.05h.2l.2,0A.7.7,0,0,1,180.63,301.17Zm-.55.32.08,0h.17l.06,0a.1.1,0,0,0,.05,0l0,0s0,0,0-.05,0,0-.06-.05l-.08,0h-.16s0,0-.07,0l0,0s0,0,0,.05a.06.06,0,0,0,0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47,308.4l0,0,0,0V308l0,0,.16-.09h0l.05,0,1.14.66s0,0,0,0l0,0-.17.1h-.08l-.78-.45v.21h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21,305.68l.09.06s0,0,.06.07a.2.2,0,0,1,0,.08.28.28,0,0,1,0,.09v.22l.33-.19h.08l.19.11,0,0s0,0,0,0l-.7.41h-.08l-.16-.09,0,0a0,0,0,0,1,0,0l0-.45a.1.1,0,0,0,0-.08l-.06-.05,0,0-.06,0h-.07a.13.13,0,0,0-.08,0s0,0,0,0v0l0,0,0,0s0,0,0,0l0,0-.16.09h-.07l-.13-.1a.34.34,0,0,1-.06-.12.17.17,0,0,1,0-.12.51.51,0,0,1,.13-.12l.19-.07h.2l.21,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,303.11h.08l.19.11,0,0v0l.05.22a1.43,1.43,0,0,1,.29,0,.75.75,0,0,1,.29.09c.13.08.2.16.2.24s-.07.15-.19.22a.72.72,0,0,1-.2.09l-.21,0-.19,0A.34.34,0,0,1,184,304a0,0,0,0,1,0,0v0l.17-.09,0,0h.16l.1,0a.13.13,0,0,0,.07-.08s0,0-.05-.07a.15.15,0,0,0-.13,0,.28.28,0,0,0-.13,0l-.11.07s0,0,0,0h0l-.15-.09,0,0a0,0,0,0,0,0,0l0-.19-.35.2h0l-.05,0-.18-.11s0,0,0,0a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,308a.58.58,0,0,1,.21-.07.6.6,0,0,1,.23,0,.59.59,0,0,1,.22.05,1,1,0,0,1,.21.09.65.65,0,0,1,.16.09l.16.09.15.12a.34.34,0,0,1,.09.13.2.2,0,0,1,0,.13.31.31,0,0,1-.13.12.9.9,0,0,1-.21.08h-.22a.93.93,0,0,1-.23,0l-.21-.09-.16-.09-.16-.1a.44.44,0,0,1-.15-.12.38.38,0,0,1-.09-.13.21.21,0,0,1,0-.13A.38.38,0,0,1,183.5,308Zm.93.37-.3-.17-.09,0-.09,0h-.08a.11.11,0,0,0-.08,0s0,0,0,0a0,0,0,0,0,0,.05.07.07,0,0,0,0,.05l.07.06.3.17.09,0,.09,0h.08l.09,0,.05-.05v0a.1.1,0,0,0,0-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,301.75h-.05l-.42-.1.59.34,0,0v0l-.17.1h0l0,0-1.15-.66,0,0a0,0,0,0,1,0,0l.16-.09h.1l.71.16-.28-.41v0s0,0,0,0l.16-.09h0l0,0,1.15.66,0,0a0,0,0,0,1,0,0l-.18.1h-.08l-.59-.34.17.24a0,0,0,0,1,0,0s0,0,0,0l-.09.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,300.94l.06,0,.08,0,.09.05.06,0,.09,0,.1,0h.09l.1,0a.1.1,0,0,0,.06-.05.06.06,0,0,0,0,0s0,0,0-.05l0,0,0,0s0,0,0,0l.17-.1h.07a.4.4,0,0,1,.14.11.27.27,0,0,1,0,.14.19.19,0,0,1,0,.12.38.38,0,0,1-.13.12.66.66,0,0,1-.21.08h-.23l-.24,0a.78.78,0,0,1-.21-.09l-.16-.09-.16-.09a.64.64,0,0,1-.15-.13.21.21,0,0,1-.07-.13.18.18,0,0,1,0-.14.51.51,0,0,1,.13-.12.68.68,0,0,1,.2-.07.58.58,0,0,1,.23,0l.22,0a1.31,1.31,0,0,1,.21.08v0a0,0,0,0,1,0,0l-.18.1s0,0,0,0h-.06l-.06,0h-.15l-.09,0a.1.1,0,0,0-.06,0,.11.11,0,0,0,0,.05.21.21,0,0,0,0,.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,299.38h-.05l-.42-.1.59.34,0,0a0,0,0,0,1,0,0l-.17.1h-.09l-1.14-.66,0,0v0l.16-.09h.1l.71.16-.28-.41a0,0,0,0,0,0,0l0,0,.16-.09h0l0,0,1.15.66,0,0a0,0,0,0,1,0,0l-.17.1h-.09l-.59-.34.17.24a0,0,0,0,1,0,0s0,0,0,0l-.09,0S167.63,299.39,167.62,299.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,298.2l.18-.08.19,0a.69.69,0,0,1,.2,0,1,1,0,0,1,.21.09.47.47,0,0,1,.18.15.16.16,0,0,1,0,.15l.59.14h0v0a0,0,0,0,1,0,0l-.19.11h-.1l-.53-.13-.12.07.38.22,0,0s0,0,0,0l-.17.1h-.09l-1.14-.66,0,0s0,0,0,0Zm.38.4.15-.09a.12.12,0,0,0,.07-.07s0-.05-.07-.08a.25.25,0,0,0-.14,0l-.12,0-.15.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.86,296.94h-.05l-.42-.1.59.34,0,0v0l-.17.1h0l-.05,0-1.14-.66,0,0a0,0,0,0,1,0,0l.16-.09h.1l.71.16-.28-.41v0l0,0,.16-.09h0l0,0,1.15.66,0,0v0l-.18.1h-.08l-.59-.34.17.24a0,0,0,0,1,0,0s0,0,0,0l-.09.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51,296.46h0l0,0-.18-.1,0,0s0,0,0,0l.42-.24h0l0,0,.18.1,0,0v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,294.64h-.05l-.42-.1.59.34,0,0s0,0,0,0l-.17.1h-.09l-1.14-.67s0,0,0,0,0,0,0,0l.16-.09.06,0h0l.71.16-.28-.41v0a.05.05,0,0,1,0,0l.16-.09h.08l1.15.66,0,0v0l-.17.1h0l-.05,0-.59-.34.17.25s0,0,0,0,0,0,0,0l-.09.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.91,293.92l.29.17,0,0v0l-.17.1H177l-.3-.17-.2.12h0l-.05,0-.18-.1,0,0s0,0,0,0l.21-.12-.3-.17s0,0,0,0a0,0,0,0,1,0,0l.17-.09h.08l.3.17.2-.12h.09l.17.1,0,0s0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.85,296.83h0l0,0-.18-.1,0,0s0,0,0,0l.79-.46h.08l.18.11s0,0,0,0l0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,296.16c.1.06.11.14,0,.18a.35.35,0,0,1-.31,0c-.09-.05-.11-.13,0-.17A.34.34,0,0,1,179.75,296.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.76,296.74a.38.38,0,0,0-.31,0c-.07,0,0,.12.05.18a.36.36,0,0,0,.3,0C180.88,296.88,180.86,296.8,180.76,296.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,299l-.4,0h0l0,0,0-.16v0h0l.41,0-.06-.23s0,0,0,0h0l.28,0,0,0,0,0,.06.23.4,0,0,0,0,0,0,.16,0,0h0l-.4,0,.05.23s0,0,0,0h0l-.27,0,0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,301.56H188l-.18-.1,0,0a0,0,0,0,1,0,0l.79-.46h.08l.18.1,0,0s0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.18,310.52l.06,0,.06,0,1.41.47,0,0,0,0a0,0,0,0,1,0,0l-.17.09-.05,0h0l-.19-.07-.35.21.11.1a0,0,0,0,1,0,0s0,0,0,0l-.17.1h-.07l0,0-.82-.81,0,0s0,0,0,0Zm.56.57L180,311l-.54-.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.31,310.41l.06,0,.08.05.09.05.07,0,.09,0,.09,0h.1l.09,0,.06-.06a.06.06,0,0,0,0,0,.09.09,0,0,0,0-.05l0,0,0,0s0,0,0,0l.17-.1h.07a.33.33,0,0,1,.14.12.21.21,0,0,1,.05.13.24.24,0,0,1,0,.13.29.29,0,0,1-.13.11.66.66,0,0,1-.21.08.87.87,0,0,1-.23,0,1.09,1.09,0,0,1-.45-.13l-.16-.09-.16-.09a.64.64,0,0,1-.15-.13.28.28,0,0,1-.07-.13.23.23,0,0,1,0-.14A.43.43,0,0,1,180,310a.62.62,0,0,1,.19-.07.6.6,0,0,1,.23,0,.83.83,0,0,1,.22,0,.65.65,0,0,1,.21.07l0,0h0l-.18.1,0,0,0,0-.06,0h-.16l-.09,0a.1.1,0,0,0-.06.05,0,0,0,0,0,0,.05.09.09,0,0,0,0,.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,306.14h0l-.05,0-.18-.1,0,0v0l.76-.44h.08l.18.1,0,0s0,0,0,0Zm.44.25h0l0,0-.18-.1,0,0,0,0,.75-.43h.09l.17.11s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.64,303.62l.3.17,0,0a0,0,0,0,1,0,0l-.17.09h-.08l-.3-.17-.2.12h-.09l-.17-.1,0,0s0,0,0,0l.21-.12-.29-.17s0,0,0,0l0,0,.16-.09h.09l.29.17.2-.12h.09l.18.1,0,0s0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,313.87a2.17,2.17,0,0,1-1-.24l-27.78-16a.75.75,0,0,1-.42-.58v2.21a.73.73,0,0,0,.43.59l27.78,16a2.11,2.11,0,0,0,1,.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,304.05v0a.71.71,0,0,1-.42.61l-15.57,9a2.11,2.11,0,0,1-1,.24v2.22a2.17,2.17,0,0,0,1-.24l15.56-9a.74.74,0,0,0,.43-.58C197.05,306.06,197,304.26,197,304.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,288.46h0a.53.53,0,0,0-.26.06l-14.22,8.21c-.14.09-.14.22,0,.3l5.76,3.33a.57.57,0,0,0,.51,0l8.2-4.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,291.85l-5.76-3.33a.51.51,0,0,0-.25-.06v7.16l5.8-3.34.22-.13C174,292.06,174,291.93,173.82,291.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.6,292.28l-5.54-3.2a.57.57,0,0,0-.51,0l-14,8.08,5.53,3.2a.57.57,0,0,0,.51,0Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.6,292.28l-5.54-3.2a.57.57,0,0,0-.51,0l-14,8.08,5.53,3.2a.57.57,0,0,0,.51,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.35,298l-.5.29a.93.93,0,0,1-.55.09,1.37,1.37,0,0,1-.61-.19c-.05,0-.08-.06-.08-.09a.07.07,0,0,1,0-.08.21.21,0,0,1,.14,0,.25.25,0,0,1,.15.05.85.85,0,0,0,.31.09.47.47,0,0,0,.28-.05l.5-.28a.15.15,0,0,0,.08-.16.3.3,0,0,0-.16-.18l-.43-.25a.31.31,0,0,1-.16.2l-.5.29a.93.93,0,0,1-.55.09,1.41,1.41,0,0,1-.61-.19l-.34-.19A.59.59,0,0,1,157,297a.27.27,0,0,1,.16-.32l.5-.29a.93.93,0,0,1,.55-.09,1.41,1.41,0,0,1,.61.19l1.33.76a.62.62,0,0,1,.33.36A.28.28,0,0,1,160.35,298Zm-1.75-1.3a.75.75,0,0,0-.3-.09.48.48,0,0,0-.28,0l-.5.29a.14.14,0,0,0-.08.16.37.37,0,0,0,.16.18l.34.19a.75.75,0,0,0,.31.09.46.46,0,0,0,.27,0l.5-.29a.14.14,0,0,0,.08-.16.33.33,0,0,0-.16-.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.85,296.23l.08,0H160l.68-.4a1,1,0,0,1,.55-.09,1.45,1.45,0,0,1,.62.19l.33.19a.63.63,0,0,1,.32.36.27.27,0,0,1-.15.32l-.5.28a.93.93,0,0,1-.55.09,1.44,1.44,0,0,1-.62-.18.22.22,0,0,1-.08-.09s0-.06,0-.08a.21.21,0,0,1,.14,0,.42.42,0,0,1,.15,0,.67.67,0,0,0,.31.1.45.45,0,0,0,.27-.05l.5-.29a.13.13,0,0,0,.08-.16.29.29,0,0,0-.16-.17l-.33-.2a.85.85,0,0,0-.31-.09.47.47,0,0,0-.28.05l-.74.43a.48.48,0,0,1-.28,0,.69.69,0,0,1-.31-.09l-.83-.48a.22.22,0,0,1-.08-.09.06.06,0,0,1,0-.08l1.25-.72a.18.18,0,0,1,.13,0,.3.3,0,0,1,.16.05.15.15,0,0,1,.08.08s0,.06,0,.08l-1.06.62s0,0,0,0a.07.07,0,0,0,0,.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.34,295.65l-.5.29a.91.91,0,0,1-.54.09,1.41,1.41,0,0,1-.62-.19l-1.33-.76a.65.65,0,0,1-.33-.36.28.28,0,0,1,.16-.32l.5-.28a1,1,0,0,1,.55-.1,1.51,1.51,0,0,1,.61.19l1.34.77a.6.6,0,0,1,.32.36A.26.26,0,0,1,164.34,295.65Zm-.83.1.5-.29a.18.18,0,0,0,.08-.09l-2.46-.42,1.3.75a.75.75,0,0,0,.31.09A.46.46,0,0,0,163.51,295.75Zm-1.5-1.44-.5.29a.13.13,0,0,0-.07.09l2.46.42-1.3-.75a.71.71,0,0,0-.31-.1A.47.47,0,0,0,162,294.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.21,294.57l-.75.44-.13,0a.43.43,0,0,1-.16,0,.14.14,0,0,1-.08-.09.07.07,0,0,1,0-.08l.25-.14-1.66-1a.69.69,0,0,0-.31-.09.46.46,0,0,0-.27,0h0a.18.18,0,0,1-.13,0,.42.42,0,0,1-.16,0,.22.22,0,0,1-.08-.09.07.07,0,0,1,0-.08h0a.93.93,0,0,1,.55-.09,1.6,1.6,0,0,1,.62.18l1.66,1,.25-.14a.2.2,0,0,1,.14,0,.27.27,0,0,1,.15.05.13.13,0,0,1,.08.08S166.25,294.55,166.21,294.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.84,293.64l-.5.28a.93.93,0,0,1-.55.09,1.44,1.44,0,0,1-.62-.18l-1.33-.77a.63.63,0,0,1-.32-.36.26.26,0,0,1,.15-.31l.5-.29a.93.93,0,0,1,.55-.09,1.6,1.6,0,0,1,.62.18l1.33.77a.63.63,0,0,1,.32.36A.27.27,0,0,1,167.84,293.64Zm-.84.09.5-.29a.14.14,0,0,0,.08-.09l-2.46-.42,1.3.75a.67.67,0,0,0,.31.1A.45.45,0,0,0,167,293.73Zm-1.49-1.44-.5.29a.14.14,0,0,0-.08.09l2.46.42-1.3-.75a.81.81,0,0,0-.31-.1A.54.54,0,0,0,165.51,292.29Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.24,292.19a.07.07,0,0,1,0,.08.3.3,0,0,1-.14,0,.25.25,0,0,1-.15-.05l-.93-.53a.28.28,0,0,1-.16.2l-.5.28a1,1,0,0,1-.54.1,1.55,1.55,0,0,1-.62-.19l-.83-.48a.16.16,0,0,1-.08-.09.06.06,0,0,1,0-.08.18.18,0,0,1,.13,0,.42.42,0,0,1,.16,0l.83.48a.63.63,0,0,0,.31.1A.45.45,0,0,0,168,292l.5-.29c.07,0,.1-.09.08-.15a.3.3,0,0,0-.16-.18l-.83-.48c-.05,0-.08-.06-.08-.09a.07.07,0,0,1,0-.08.21.21,0,0,1,.14,0,.42.42,0,0,1,.16,0l2.32,1.35C170.21,292.12,170.24,292.15,170.24,292.19Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M179.87,287.12l36,20.77a3.5,3.5,0,0,0,3.18,0l58-33.51a1,1,0,0,0,0-1.84l-36-20.77a3.5,3.5,0,0,0-3.18,0l-58,33.51A1,1,0,0,0,179.87,287.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.84,283.51c0,.9.67,1.47,1.5,1.95l34,19.63a3.33,3.33,0,0,0,3,0l54.84-31.66a2.44,2.44,0,0,0,1.5-2c0-.9-.67-1.45-1.5-1.93l-34-19.63a3.31,3.31,0,0,0-3,0l-54.84,31.66A2.41,2.41,0,0,0,180.84,283.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,283.27l34,19.63a3.39,3.39,0,0,0,3,0l54.84-31.67a.91.91,0,0,0,0-1.73l-34-19.63a3.31,3.31,0,0,0-3,0l-54.84,31.66A.92.92,0,0,0,182.34,283.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.84,303.26v2.19a3.09,3.09,0,0,1-1.51-.36l-34-19.63c-.83-.48-1.5-1-1.5-1.95a2.35,2.35,0,0,1,1.38-1.91.93.93,0,0,0,.12,1.67l34,19.63A3.09,3.09,0,0,0,217.84,303.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,281.79l50.39-29.1a1.61,1.61,0,0,1,1.42,0l1.83,1c.4.23.4.6,0,.82l-50.4,29.09a1.53,1.53,0,0,1-1.41,0l-1.83-1A.43.43,0,0,1,187,281.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.93,284.71l50.39-29.1a1.5,1.5,0,0,1,1.3-.07l13.11,7.58c.33.18.27.52-.12.74l-50.34,29.06A1.41,1.41,0,0,1,205,293l-13.17-7.54C191.48,285.27,191.54,284.93,191.93,284.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59,267.83l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13l1.51.87A.22.22,0,0,0,235.59,267.83Zm-2.3-3.15-1.58.91c-.06,0-.07.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.13l-1.51-.88A.27.27,0,0,0,233.29,264.68Zm-5.1,2.94-2.67,1.55c-.06,0-.07.09,0,.13l1.51.87a.27.27,0,0,0,.23,0l2.67-1.54c.07,0,.07-.1,0-.13l-1.51-.87A.26.26,0,0,0,228.19,267.62ZM231,266l-1.57.91c-.07,0-.08.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87A.24.24,0,0,0,231,266Zm-6.19,3.58-1.57.91c-.07,0-.08.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.09,0-.13l-1.51-.87A.24.24,0,0,0,224.79,269.59Zm-2.3,1.33-1.58.91c-.07,0-.07.1,0,.13l1.51.87a.26.26,0,0,0,.23,0l1.57-.92c.07,0,.08-.09,0-.13l-1.51-.87A.27.27,0,0,0,222.49,270.92Zm5.91,3.55,1.58-.91c.07,0,.08-.09,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13l1.51.87A.22.22,0,0,0,228.4,274.47Zm-2.3,1.34,1.58-.91c.06,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.87A.26.26,0,0,0,226.1,275.81Zm-2.31,1.33,1.58-.91c.07,0,.07-.1,0-.14l-1.51-.87a.25.25,0,0,0-.22,0l-1.58.91c-.07,0-.08.1,0,.13l1.51.88A.27.27,0,0,0,223.79,277.14Zm-2.3,1.33,1.57-.91c.07,0,.08-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.14l1.51.87A.27.27,0,0,0,221.49,278.47Zm11.8-9.3,1.58-.92a.07.07,0,0,0,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.87A.26.26,0,0,0,233.29,269.17Zm-2.58,4,3.52-2c.07,0,.07-.1,0-.13l-3.66-2.12a.27.27,0,0,0-.23,0l-1.82,1.05c-.07,0-.07.1,0,.13l1.94,1.12c.06,0,0,.1,0,.14l-1.45.84c-.07,0-.08.1,0,.13l1.51.87A.24.24,0,0,0,230.71,273.14Zm-10.53-.89-1.58.91c-.06,0-.07.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.14l-1.51-.87A.27.27,0,0,0,220.18,272.25Zm-2.3,1.33-1.58.91c-.07,0-.08.1,0,.13l1.51.88a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.88A.25.25,0,0,0,217.88,273.58ZM205.11,287.8a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.14Zm-5.68-3.57-1.58.91c-.07,0-.07.1,0,.14l1.5.87a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.87A.24.24,0,0,0,199.43,284.23Zm2.92,2.67a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.09,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13Zm6.36,1.43,1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13l1.5.87A.24.24,0,0,0,208.71,288.33Zm-2.53,1.34a.24.24,0,0,0,.23,0l1.58-.91a.07.07,0,0,0,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13Zm-4.45-6.77-1.57.91c-.07,0-.08.1,0,.13l1.51.88a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.88A.27.27,0,0,0,201.73,282.9Zm11.53-6.66-1.57.92c-.07,0-.08.09,0,.13l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87A.26.26,0,0,0,213.26,276.24ZM204,281.57l-1.58.91c-.07,0-.07.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.14l-1.51-.87A.27.27,0,0,0,204,281.57Zm11.53-6.66-1.58.91c-.07,0-.07.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.13l-1.51-.88A.27.27,0,0,0,215.57,274.91ZM211,277.58l-1.58.91c-.07,0-.07.09,0,.13l1.51.87a.24.24,0,0,0,.22,0l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.87A.24.24,0,0,0,211,277.58Zm-2.31,1.33-1.58.91c-.06,0-.07.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.58-.91c.06,0,.07-.09,0-.13l-1.51-.87A.24.24,0,0,0,208.65,278.91Zm-2.3,1.33-1.58.91c-.07,0-.08.1,0,.13l1.51.87a.27.27,0,0,0,.23,0l1.58-.92c.07,0,.07-.09,0-.13l-1.51-.87A.24.24,0,0,0,206.35,280.24Zm10.52.89,1.58-.91c.07,0,.08-.1,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.92c-.07,0-.07.09,0,.13l1.51.87A.25.25,0,0,0,216.87,281.13Zm21.52-19.39-1.58.91c-.07,0-.07.1,0,.13l1.51.87a.26.26,0,0,0,.23,0l1.57-.92c.07,0,.08-.09,0-.13l-1.51-.87A.27.27,0,0,0,238.39,261.74Zm-2.79,1.61-1.58.91c-.07,0-.07.1,0,.13l1.5.88a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.14l-1.51-.87A.27.27,0,0,0,235.6,263.35Zm5.09-2.94-1.57.91c-.07,0-.08.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.09,0-.13l-1.51-.87A.24.24,0,0,0,240.69,260.41ZM228,272.25l1.58-.91c.06,0,.07-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.88A.27.27,0,0,0,228,272.25Zm15.28-13.18a.24.24,0,0,0-.23,0l-1.58.91c-.06,0-.07.09,0,.13l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.13Zm-24,20.73,1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.14l1.51.87A.27.27,0,0,0,219.18,279.8Zm28.28-16.33,1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.57.91c-.07,0-.08.09,0,.13l1.51.87A.27.27,0,0,0,247.46,263.47Zm-4.46.09,1.58-.91c.06,0,.07-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.14l1.51.87A.27.27,0,0,0,243,263.56Zm2.39-3.25a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13l1.51.88a.25.25,0,0,0,.22,0l1.58-.91c.07,0,.08-.1,0-.14Zm.48-.28,3.67,2.12a.27.27,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.13L247.69,259a.27.27,0,0,0-.23,0l-1.57.91C245.82,259.94,245.81,260,245.87,260Zm-5.33,3-1.57.91c-.07,0-.08.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87A.24.24,0,0,0,240.54,263Zm-17.35,10-1.58.92c-.07,0-.07.09,0,.13l1.51.87a.27.27,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.13l-1.51-.87A.26.26,0,0,0,223.19,273Zm21.74-8.19a.22.22,0,0,0,.22,0l1.58-.91c.07,0,.08-.09,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13Zm-19.44,6.86-1.57.91c-.07,0-.08.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87A.24.24,0,0,0,225.49,271.67Zm-18.07,14.8a.27.27,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13Zm-2.68-2.81-1.58.91c-.07,0-.07.09,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.13l-1.51-.87A.24.24,0,0,0,204.74,283.66Zm5.22,1.47,1.57-.91c.07,0,.08-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13l1.51.87A.26.26,0,0,0,210,285.13Zm2.3-1.34,1.58-.91c.07,0,.07-.09,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13l1.51.87A.24.24,0,0,0,212.26,283.79Zm2.31-1.33,1.58-.91c.06,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.87A.24.24,0,0,0,214.57,282.46Zm-7.52-.14-1.58.92c-.07,0-.08.09,0,.13l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87A.24.24,0,0,0,207.05,282.32Zm2.3-1.33-1.58.91c-.06,0-.07.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.13l-1.51-.87A.24.24,0,0,0,209.35,281Zm9.23-5.32-1.58.91c-.07,0-.08.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.09,0-.13l-1.5-.87A.27.27,0,0,0,218.58,275.67ZM216.27,277l-1.58.91c-.07,0-.07.1,0,.13l1.51.87a.26.26,0,0,0,.23,0L218,278c.07,0,.08-.09,0-.13L216.5,277A.27.27,0,0,0,216.27,277Zm4.61-2.66-1.58.91c-.06,0-.07.09,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.13l-1.51-.87A.24.24,0,0,0,220.88,274.34Zm-9.22,5.32-1.58.91c-.07,0-.07.1,0,.13l1.51.88a.24.24,0,0,0,.22,0l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.88A.27.27,0,0,0,211.66,279.66Zm2.3-1.33-1.57.91c-.07,0-.08.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.14l-1.51-.87A.27.27,0,0,0,214,278.33ZM211,287l1.58-.91c.06,0,.07-.1,0-.13l-1.51-.87a.26.26,0,0,0-.23,0l-1.58.92a.07.07,0,0,0,0,.13l1.51.87A.27.27,0,0,0,211,287Zm-12.16-.57-1.51-.87a.26.26,0,0,0-.23,0l-1.58.92a.07.07,0,0,0,0,.13l1.51.87a.27.27,0,0,0,.23,0l1.58-.91C198.91,286.52,198.92,286.46,198.86,286.43Zm3,.75-1.51-.87a.27.27,0,0,0-.23,0l-2.43,1.4c-.07,0-.07.1,0,.13l1.51.87a.22.22,0,0,0,.22,0l2.43-1.41C201.92,287.28,201.93,287.22,201.87,287.18Zm-5.26-2.47-1.51-.87a.24.24,0,0,0-.23,0L192.93,285c-.07,0-.08.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.94-1.12C196.66,284.8,196.67,284.74,196.61,284.71Zm1.49-.86a.25.25,0,0,0,.22,0l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.14Zm6.53,4.23-1.51-.87a.24.24,0,0,0-.23,0l-3,1.76c-.07,0-.08.09,0,.13l1.51.87a.27.27,0,0,0,.23,0l3-1.75C204.68,288.17,204.69,288.11,204.63,288.08Zm1.06,1.87-1.51-.87a.27.27,0,0,0-.23,0L202,290.21c-.06,0-.07.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.94-1.12C205.75,290.05,205.75,290,205.69,290Zm9.55-16a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.14Zm-4.61,2.66a.24.24,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.06,0-.07.09,0,.13Zm-10.23,5.91a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13Zm12.54-7.24a.25.25,0,0,0,.22,0l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.92c-.07,0-.07.09,0,.13Zm-4.62,2.66a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.09,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13Zm-1.49,12.11a.27.27,0,0,0-.23,0l-2.43,1.41c-.07,0-.07.09,0,.13l1.5.87a.27.27,0,0,0,.23,0l2.43-1.4c.07,0,.07-.1,0-.13ZM205,279.85a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.09,0-.13l-1.51-.87a.25.25,0,0,0-.22,0l-1.58.91c-.07,0-.08.1,0,.13Zm-2.3,1.33a.24.24,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13Zm46.84-15.8a.27.27,0,0,0-.23,0l-3.88,2.24c-.07,0-.08.1,0,.13l1.51.87a.26.26,0,0,0,.23,0l3.89-2.25c.06,0,.07-.09,0-.13Zm-5.1,2.94a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.88a.27.27,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.14Zm-31.12,17.35,1.57-.91c.07,0,.08-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.14l1.51.87A.27.27,0,0,0,213.33,285.67ZM239.84,271a.24.24,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.13Zm12-6.94a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.09,0,.13l1.5.87a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13Zm3.81-.46L252,261.47a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.08.1,0,.13l3.67,2.12a.27.27,0,0,0,.23,0l1.58-.91C255.72,263.68,255.73,263.62,255.67,263.59ZM231.22,276a.27.27,0,0,0-.23,0l-1.94,1.12c-.07,0-.07.1,0,.13l1.51.87a.26.26,0,0,0,.23,0l1.94-1.13a.07.07,0,0,0,0-.13Zm5.83-3.36a.24.24,0,0,0-.23,0l-2.43,1.4c-.07,0-.07.09,0,.13l1.51.87a.27.27,0,0,0,.23,0l2.42-1.4c.07,0,.08-.1,0-.13ZM225.88,279a.27.27,0,0,0-.23,0l-13,7.5c-.07,0-.08.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l13-7.5c.06,0,.07-.1,0-.13ZM212.17,287a.27.27,0,0,0-.23,0L210,288.09c-.06,0-.07.1,0,.13l1.51.88a.27.27,0,0,0,.23,0l1.94-1.12c.07,0,.08-.1,0-.14Zm16.38-9.46a.27.27,0,0,0-.23,0l-1.94,1.12c-.07,0-.07.1,0,.13l1.51.88a.27.27,0,0,0,.23,0l1.94-1.12c.06,0,.07-.1,0-.14Zm-19.05,11a.27.27,0,0,0-.23,0l-2,1.12c-.06,0-.07.1,0,.14l1.51.87a.27.27,0,0,0,.23,0l1.94-1.12c.07,0,.07-.1,0-.13Zm24.39-14.08a.24.24,0,0,0-.23,0l-1.94,1.12c-.07,0-.07.1,0,.13l1.51.87a.24.24,0,0,0,.23,0l1.94-1.12c.07,0,.07-.09,0-.13Zm8.26-4.77a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.14l1.5.87a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13Zm5.16-3.6,1.58-.91c.07,0,.07-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.14l1.51.87A.27.27,0,0,0,247.31,266.05Zm-9.41.45,1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.57.91c-.07,0-.08.09,0,.13l1.51.87A.27.27,0,0,0,237.9,266.5ZM231.78,275l4.61-2.66c.06,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0L230.05,274c-.07,0-.07.1,0,.14l1.51.87A.27.27,0,0,0,231.78,275Zm13-7.63a.24.24,0,0,0,.22,0l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.14Zm-1.93-1.25,1.58-.92a.07.07,0,0,0,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.87A.26.26,0,0,0,242.85,266.14Zm-13.38,10.21,1.58-.91c.06,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.14l1.51.87A.27.27,0,0,0,229.47,276.35Zm10.21-6a.24.24,0,0,0,.23,0l1.58-.91c.06,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13ZM217.94,283l1.58-.91c.06,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.88A.27.27,0,0,0,217.94,283Zm2.3-1.33,1.58-.91c.07,0,.08-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13l1.51.87A.24.24,0,0,0,220.24,281.68Zm-4.61,2.66,1.58-.91c.07,0,.07-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.14l1.51.87A.27.27,0,0,0,215.63,284.34Zm9.23-5.33,1.57-.91c.07,0,.08-.1,0-.13l-1.51-.87a.24.24,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13l1.51.87A.24.24,0,0,0,224.86,279Zm-2.31,1.33,1.58-.91c.07,0,.07-.09,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13l1.51.87A.24.24,0,0,0,222.55,280.34Zm4.61-2.66,1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87a.24.24,0,0,0-.22,0l-1.58.92c-.07,0-.08.09,0,.13l1.51.87A.27.27,0,0,0,227.16,277.68Zm12.59-18.52a.27.27,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.13l-.4-.23a.27.27,0,0,0-.23,0l-1.58.92c-.07,0-.07.09,0,.13Zm-11.46,7.26a.25.25,0,0,0,.22,0l1.58-.91c.07,0,.08-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.14Zm4.61-2.67a.26.26,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13ZM225.47,268a.24.24,0,0,0,.23,0l1.58-.91a.07.07,0,0,0,0-.13l-1.51-.87a.27.27,0,0,0-.23,0L224,267c-.06,0-.07.1,0,.13Zm5.12-3a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13Zm-9.73,5.62a.27.27,0,0,0,.23,0l1.57-.91c.07,0,.08-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.07,0-.07.1,0,.13Zm2.3-1.34a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13Zm12-7.55a.22.22,0,0,0,.22,0l1.58-.91c.07,0,.08-.09,0-.13l-.41-.23a.24.24,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.13Zm6.91-4a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-.4-.24a.27.27,0,0,0-.23,0l-1.57.91c-.07,0-.08.1,0,.14Zm3.17,1.83a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.92c-.07,0-.07.09,0,.13Zm4.4,5.06,1.58-.91c.06,0,.07-.1,0-.14l-1.51-.87a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.13l1.51.88A.27.27,0,0,0,249.62,264.72Zm-12.18-4.23a.24.24,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-.4-.23a.24.24,0,0,0-.23,0l-1.58.91c-.06,0-.07.09,0,.13ZM218.55,272a.27.27,0,0,0,.23,0l1.58-.91c.07,0,.07-.1,0-.13l-1.51-.88a.27.27,0,0,0-.23,0l-1.58.91c-.06,0-.07.1,0,.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "225.16 285.16 225.5 285.36 234.61 290.62 250.82 281.26 251.16 281.07 241.7 275.61 225.16 285.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.61 281.38 241.7 276.24 225.71 285.48 234.61 290.62 250.61 281.38",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,281.77c-.65-.31-.83-.83-.9-1.75l-2.94-43.11a3,3,0,0,1,1.39-2.54l54.84-31.66c.82-.48,1.43-.74,2.2-.22s.78.82.84,1.74l2.95,43.11a3,3,0,0,1-1.39,2.54l-54.84,31.66A2,2,0,0,1,180.18,281.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.61,204.23c-.06-.92-.78-1.28-1.61-.8l-54.84,31.66a2.81,2.81,0,0,0-1,1.1l-1.43-.72h0a2.81,2.81,0,0,1,1-1.1l54.83-31.66c.83-.48,1.44-.75,2.21-.22S235.55,203.31,235.61,204.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.22,281.6a1.92,1.92,0,0,1-2,.17c-.62-.26-.84-.83-.9-1.75l-2.95-43.12a2.72,2.72,0,0,1,.36-1.43l1.43.72h0a2.72,2.72,0,0,0-.36,1.43l2.95,43.12A1,1,0,0,0,182.22,281.6Z",
    style: {
      fill: "#263238"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.11,236.74l52.78-30.46c.49-.29.93-.08,1,.48L236.6,247a1.78,1.78,0,0,1-.83,1.52L183,279c-.5.29-.94.07-1-.48l-2.75-40.22A1.77,1.77,0,0,1,180.11,236.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.11,236.74a1.77,1.77,0,0,0-.83,1.52l2.7,39.55,52.17-30.11a1.82,1.82,0,0,0,.84-1.53l-2.71-39.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spreadsheets--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.43,211l-2.55-1.28-56.15,33.43,2.47,36.21a1.8,1.8,0,0,0,.88,1.56h0l1.62.81h0a2,2,0,0,0,1.85-.21l52-30a5,5,0,0,0,2.34-4.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.18,249.65l2,29.72a1.8,1.8,0,0,0,.88,1.56h0l1.62.81a1.46,1.46,0,0,0,.7.14l-1.57-1.7-2-29.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.38,281.6a2.06,2.06,0,0,0,1-.31l52-30a4.74,4.74,0,0,0,2.2-4l-2.44-35.73-56.49,32.62,2.46,36.05C190.19,281.08,190.66,281.62,191.38,281.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,212l2.4,35.24a4.5,4.5,0,0,1-2.06,3.77l-52,30a1.82,1.82,0,0,1-.85.27c-.76,0-.9-.8-.93-1.15L188,244.28,243.89,212m.54-1-57.07,33,2.47,36.22c.07,1.1.71,1.72,1.57,1.7a2.4,2.4,0,0,0,1.15-.35l52-30a5,5,0,0,0,2.34-4.27L244.43,211Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.81,206.48a1.9,1.9,0,0,0-1.87.19l-52,30a5,5,0,0,0-2.33,4.27l.14,2.19,1.63.8,57.07-33-.15-2.18a1.74,1.74,0,0,0-.87-1.55C243,207.05,242.25,206.71,241.81,206.48Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,241.78a5,5,0,0,1,2.34-4.27l52-30c1.4-.81,2.62-.2,2.72,1.35l.15,2.18-57.07,33Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,241.78a5,5,0,0,1,2.34-4.27l52-30c1.4-.81,2.62-.2,2.72,1.35l.15,2.18-57.07,33Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.44,207.29a1.9,1.9,0,0,0-1.88.19l-52,30a4.79,4.79,0,0,0-1.73,1.86l-1.63-.81a4.81,4.81,0,0,1,1.74-1.86l52-30a1.93,1.93,0,0,1,1.87-.19c.44.23,1.15.57,1.61.79Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.44,207.29a1.9,1.9,0,0,0-1.88.19l-52,30a4.79,4.79,0,0,0-1.73,1.86l-1.63-.81a4.81,4.81,0,0,1,1.74-1.86l52-30a1.93,1.93,0,0,1,1.87-.19c.44.23,1.15.57,1.61.79Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.37,212.8a1.76,1.76,0,0,0-.81,1.49c0,.54.46.75.95.47a1.74,1.74,0,0,0,.81-1.49C236.29,212.73,235.86,212.52,235.37,212.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,211a1.76,1.76,0,0,0-.81,1.49c0,.54.46.75.95.47a1.74,1.74,0,0,0,.81-1.49C239.38,211,239,210.74,238.46,211Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.56,209.24a1.75,1.75,0,0,0-.82,1.49c0,.54.46.75.95.47a1.77,1.77,0,0,0,.82-1.49A.58.58,0,0,0,241.56,209.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.36 243.97 187.8 250.43 244.87 217.49 244.43 211.01 187.36 243.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.76 244.25 195.61 240.89 195.83 244.12 189.98 247.49 189.76 244.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.05 240.04 197.14 241.32 200.05 239.63 199.97 238.36 197.05 240.04",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.18 242.01 197.27 243.29 200.19 241.6 200.1 240.33 197.18 242.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.42 237.52 201.51 238.79 204.43 237.11 204.34 235.83 201.42 237.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.56 239.49 201.65 240.76 204.56 239.08 204.47 237.8 201.56 239.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.8 234.99 205.88 236.27 208.8 234.58 208.71 233.31 205.8 234.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.93 236.96 206.02 238.23 208.94 236.55 208.85 235.28 205.93 236.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.92 227.42 219.01 228.69 221.92 227.01 221.84 225.73 218.92 227.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.05 229.38 219.14 230.66 222.06 228.98 221.97 227.7 219.05 229.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.29 224.89 223.38 226.17 226.3 224.48 226.21 223.21 223.29 224.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.43 226.86 223.51 228.13 226.43 226.45 226.34 225.18 223.43 226.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.67 222.37 227.75 223.64 230.67 221.96 230.58 220.68 227.67 222.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.8 224.33 227.89 225.61 230.81 223.92 230.72 222.65 227.8 224.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.17 232.47 217.46 228.26 217.68 231.5 210.39 235.71 210.17 232.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.04 219.84 237.89 216.48 238.11 219.71 232.26 223.08 232.04 219.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.33 215.63 239.42 216.91 242.34 215.22 242.25 213.95 239.33 215.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.47 217.6 239.56 218.87 242.47 217.19 242.38 215.92 239.47 217.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.36 243.97 185.74 243.17 186.18 249.65 187.8 250.43 187.36 243.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--spreadsheets--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.96 249.85 203.5 246.08 203.7 248.98 197.16 252.76 196.96 249.85",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.55 273.11 205.09 269.34 205.28 272.24 198.75 276.02 198.55 273.11",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.81 250.45 244.34 246.67 244.54 249.57 238 253.35 237.81 250.45",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.81 250.45 244.34 246.67 244.54 249.57 238 253.35 237.81 250.45",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.69 263.52 211.23 259.75 211.43 262.65 204.89 266.43 204.69 263.52",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.69 263.52 211.23 259.75 211.43 262.65 204.89 266.43 204.69 263.52",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.79 241.43 223.33 237.65 223.53 240.55 216.99 244.33 216.79 241.43",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.79 241.43 223.33 237.65 223.53 240.55 216.99 244.33 216.79 241.43",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.13,250.59l-.09,0,2,29.44.33-.19,13.08-7.55,6.23-3.6.32-.18,6.22-3.59.33-.19,6.21-3.59.33-.19,6.21-3.59.33-.18,6.22-3.6.32-.18,6.23-3.6.31-.17-2-29.45Zm8.45,25.35-6.23,3.59-.17-2.55,6.22-3.58Zm-.2-2.9-6.23,3.58-.17-2.54,6.22-3.59Zm-.2-2.91L192,273.72l-.17-2.55,6.23-3.59Zm-.2-2.91-6.22,3.59-.18-2.55,6.23-3.59Zm-.2-2.91-6.22,3.59-.18-2.55,6.23-3.59Zm-.2-2.91L191.36,265l-.17-2.55,6.22-3.59Zm-.19-2.91-6.23,3.59-.17-2.55,6.22-3.58Zm-.2-2.9L191,259.17l-.17-2.54L197,253Zm-.2-2.91-6.23,3.59-.17-2.55,6.23-3.59Zm-.2-2.91-6.22,3.59-.18-2.55,6.23-3.59Zm8.33,22.39-6.22,3.6-.18-2.56,6.23-3.58Zm-.19-2.9-6.23,3.59-.17-2.55,6.22-3.59Zm-.2-2.91-6.23,3.59-.17-2.55,6.22-3.59Zm-.2-2.91L198.3,267l-.17-2.55,6.22-3.59Zm-.2-2.91-6.22,3.59-.18-2.55,6.23-3.59Zm-.2-2.91-6.22,3.6-.18-2.56,6.23-3.59Zm-.2-2.91-6.22,3.59-.18-2.55,6.23-3.58Zm-.2-2.9-6.22,3.59-.17-2.55,6.22-3.59Zm-.19-2.91-6.23,3.59-.17-2.55,6.22-3.59Zm-.2-2.91-6.23,3.59-.17-2.55,6.22-3.59Zm8.32,22.4L205.44,272l-.18-2.55,6.23-3.59Zm-.2-2.91-6.22,3.59-.17-2.55,6.22-3.59Zm-.19-2.91L205,266.16l-.17-2.55,6.22-3.59Zm-.2-2.91-6.23,3.6-.17-2.56,6.22-3.59Zm-.2-2.91-6.23,3.59-.17-2.55,6.23-3.59Zm-.2-2.91-6.22,3.6-.18-2.55,6.23-3.6Zm-.2-2.91-6.22,3.6-.18-2.56,6.23-3.58Zm-.2-2.9-6.22,3.59-.17-2.55,6.22-3.59Zm-.19-2.91-6.23,3.59-.17-2.55,6.22-3.59Zm-.2-2.91-6.23,3.59-.17-2.55,6.22-3.59Zm8.32,22.4L212,268.2l-.18-2.55,6.22-3.59Zm-.2-2.91-6.21,3.59-.18-2.55,6.22-3.59Zm-.19-2.91-6.22,3.59-.17-2.55,6.21-3.59Zm-.2-2.91-6.22,3.6-.17-2.56,6.21-3.59Zm-.2-2.91-6.22,3.6L211,254l6.22-3.59Zm-.2-2.9L211,253.66l-.17-2.55,6.22-3.59Zm-.2-2.91-6.21,3.59-.18-2.55,6.22-3.59Zm-.2-2.91-6.21,3.59-.18-2.55,6.22-3.59Zm-.19-2.91-6.22,3.59-.17-2.55,6.21-3.59Zm-.2-2.91L210.2,242l-.17-2.55,6.21-3.59Zm8.33,22.4-6.22,3.59-.17-2.54,6.22-3.6Zm-.2-2.91-6.21,3.6-.18-2.56,6.22-3.59Zm-.2-2.91-6.21,3.6-.18-2.55,6.22-3.6Zm-.19-2.9-6.22,3.59-.18-2.55,6.22-3.6Zm-.2-2.92-6.22,3.6-.17-2.55,6.21-3.6Zm-.2-2.9-6.22,3.59-.17-2.55,6.21-3.59Zm-.2-2.91L217.34,247l-.17-2.55,6.22-3.59Zm-.2-2.91-6.22,3.59-.17-2.55,6.22-3.59Zm-.2-2.91L217,241.15l-.18-2.54L223,235Zm-.2-2.91-6.21,3.6-.18-2.55,6.22-3.6Zm8.33,22.41-6.22,3.59-.17-2.55,6.22-3.6Zm-.2-2.91-6.22,3.59-.17-2.55,6.22-3.6Zm-.2-2.91-6.21,3.59-.18-2.55,6.22-3.59Zm-.2-2.91-6.21,3.59-.18-2.55,6.22-3.59Zm-.19-2.91-6.22,3.6-.17-2.56,6.21-3.59Zm-.2-2.91-6.22,3.59-.17-2.55,6.21-3.59Zm-.2-2.91-6.22,3.6-.17-2.55,6.22-3.6Zm-.2-2.91-6.22,3.6-.17-2.56,6.22-3.59Zm-.2-2.91-6.21,3.6-.18-2.55,6.22-3.6Zm-.2-2.9-6.21,3.59-.18-2.55,6.22-3.59Zm8.34,22.4-6.23,3.59-.17-2.55,6.22-3.59Zm-.2-2.91L231.41,254l-.17-2.55,6.23-3.59Zm-.2-2.91-6.22,3.59L231,248.5l6.23-3.59Zm-.2-2.91L231,248.14l-.18-2.55,6.23-3.59Zm-.2-2.91-6.22,3.6-.17-2.56,6.22-3.59Zm-.19-2.91-6.23,3.6-.17-2.56,6.22-3.59Zm-.2-2.9-6.23,3.59-.17-2.55,6.22-3.6Zm-.2-2.92-6.23,3.6-.17-2.55,6.22-3.6Zm-.2-2.9L230,233.6l-.18-2.55,6.23-3.59Zm-.2-2.91-6.22,3.59-.18-2.55,6.23-3.59Zm8.33,22.4-6.22,3.59-.17-2.55,6.22-3.59Zm-.19-2.91L238,250.18l-.17-2.55L244,244Zm-.2-2.91-6.23,3.6-.17-2.56,6.22-3.59Zm-.2-2.91-6.22,3.6-.18-2.56,6.23-3.59Zm-.2-2.9-6.22,3.59-.18-2.55,6.23-3.6Zm-.2-2.92-6.22,3.6L237,236l6.23-3.6Zm-.2-2.9L237,235.64l-.17-2.55L243,229.5Zm-.19-2.91-6.23,3.59-.17-2.55,6.22-3.6Zm-.2-2.91-6.23,3.59-.17-2.55,6.22-3.59Zm-.2-2.91-6.23,3.59-.17-2.54,6.23-3.6Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.35,254.42,317.5,275.14a1.5,1.5,0,0,1-1.34,0l-45.89-26.5a1.47,1.47,0,0,1-.67-1.16v-.16a1.48,1.48,0,0,1,.68-1.16l35.87-20.71a1.5,1.5,0,0,1,1.34,0l45.87,26.48a1.5,1.5,0,0,1,.67,1.17v.15A1.54,1.54,0,0,1,353.35,254.42Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.35,254.42,317.5,275.14a1.5,1.5,0,0,1-1.34,0l-45.89-26.5a1.47,1.47,0,0,1-.67-1.16v-.16a1.48,1.48,0,0,1,.68-1.16l35.87-20.71a1.5,1.5,0,0,1,1.34,0l45.87,26.48a1.5,1.5,0,0,1,.67,1.17v.15A1.54,1.54,0,0,1,353.35,254.42Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,225.43a1.49,1.49,0,0,0-1.56.17L270.54,246c-.52.3-.52.78,0,1.07l45.38,26.21h0a1.83,1.83,0,0,0,1.84,0l35.37-20.42a.62.62,0,0,0,0-1.07h0Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,225.43a1.49,1.49,0,0,0-1.56.17L270.54,246c-.52.3-.52.78,0,1.07l45.38,26.21h0a1.83,1.83,0,0,0,1.84,0l35.37-20.42a.62.62,0,0,0,0-1.07h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.36,251.93l-.23-.13a.62.62,0,0,1,0,1.07l-35.37,20.42a1.86,1.86,0,0,1-.92.24h0v1.77a1.37,1.37,0,0,0,.68-.16l35.85-20.72a1.54,1.54,0,0,0,.68-1.17v-.15A1.5,1.5,0,0,0,353.36,251.93Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.36,251.93l-.23-.13a.62.62,0,0,1,0,1.07l-35.37,20.42a1.86,1.86,0,0,1-.92.24h0v1.77a1.37,1.37,0,0,0,.68-.16l35.85-20.72a1.54,1.54,0,0,0,.68-1.17v-.15A1.5,1.5,0,0,0,353.36,251.93Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M310.65,228.65a1.54,1.54,0,0,0-1.6.18l-33.42,19.29a.59.59,0,0,0,0,1.11l40.29,23.26h0a2,2,0,0,0,1.9,0l33.43-19.3a.64.64,0,0,0,0-1.1l-.62-.36Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.26,272l33.1-19.11a.64.64,0,0,0,.28-.49V252a.64.64,0,0,0-.28-.49L309.47,228a.64.64,0,0,0-.57,0l-33.1,19.11a.64.64,0,0,0-.28.49v.37a.64.64,0,0,0,.28.49L316.69,272A.64.64,0,0,0,317.26,272Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.74,247.1l-.07.08,0,0a1.09,1.09,0,0,0-.08.15.43.43,0,0,0,0,.11.15.15,0,0,0,0,.07v.36a.66.66,0,0,0,.28.5L316.69,272a.53.53,0,0,0,.28.07v-1a.65.65,0,0,1-.29-.07l-40.89-23.6C275.67,247.31,275.65,247.19,275.74,247.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.43,251.6c.08.08.06.2-.07.27L317.26,271a.64.64,0,0,1-.28.07v1a.53.53,0,0,0,.28-.07l33.1-19.11a.64.64,0,0,0,.28-.49V252A.61.61,0,0,0,350.43,251.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Forms--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "310.64 230.41 303.57 234.49 304.08 234.79 311.15 230.71 310.64 230.41",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.67 231 301.06 237.13 301.57 237.42 312.18 231.3 311.67 231",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.69 231.59 303.26 237.03 303.77 237.33 313.2 231.88 312.69 231.59",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.77 242.61 301.46 260.11 302.78 260.86 333.08 243.37 331.77 242.61",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.77 242.61 301.46 260.11 302.78 260.86 333.08 243.37 331.77 242.61",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.09,260.83,333,243.54l1.73,1-29.93,17.28-1.73-1m-.31,0,2,1.15,30.3-17.5-2-1.14-30.3,17.49Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.86 250.37 324.98 250.22 323.14 249.16 323.01 249.3 324.86 250.37",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.86 256.14 314.99 255.99 313.13 254.92 313.01 255.07 314.86 256.14",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.94,261.9l29.94-17.28,1.73,1L306.68,262.9l-1.74-1m-.31,0,2,1.14,30.31-17.5-2-1.14-30.31,17.5Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.71 251.44 326.84 251.3 325 250.23 324.87 250.38 326.71 251.44",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.72 257.21 316.85 257.07 314.99 256 314.87 256.14 316.72 257.21",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8,263l29.93-17.28,1.74,1L308.54,264l-1.74-1m-.31,0,2,1.14,30.31-17.5-2-1.14L306.49,263Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.57 252.51 328.7 252.37 326.85 251.31 326.73 251.45 328.57 252.51",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.58 258.28 318.7 258.14 316.85 257.07 316.72 257.21 318.58 258.28",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.66,264l29.93-17.28,1.74,1-29.94,17.29-1.73-1m-.31,0,2,1.14,30.3-17.49-2-1.15-30.3,17.5Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.43 253.58 330.56 253.44 328.71 252.38 328.59 252.52 330.43 253.58",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.44 259.35 320.56 259.21 318.71 258.14 318.58 258.28 320.44 259.35",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,266l10-5.75,2.3,1.33-9.95,5.74L312,266m-.35,0,2.63,1.52,10.32-6L322,260l-10.32,6Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.42 249.33 328.11 258.17 329.21 258.81 344.52 249.97 343.42 249.33",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.52 239.26 282.21 248.1 283.31 248.74 298.62 239.9 297.52 239.26",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.56 247.57 293.16 255.31 294.47 256.07 307.87 248.33 306.56 247.57",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.56 247.57 293.16 255.31 294.47 256.07 307.87 248.33 306.56 247.57",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,256.24l-1.06.61-1.05-.6,1.06-.62Zm-1.05.48.81-.47-.82-.48-.82.47Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,257.36l-1.06.62-1.05-.61,1.07-.61Zm-1.05.48.82-.47-.83-.47-.81.46Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.91,258.49l-1.07.62-1-.61,1.07-.61Zm-1.05.48.81-.47-.83-.48-.81.47Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,249.33a.08.08,0,0,1,0,0l-10.58,6.11a.09.09,0,0,1-.12,0,.09.09,0,0,1,.05-.12l10.58-6.11a.08.08,0,0,1,.12,0A.09.09,0,0,1,308.56,249.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.05,249.62l0,0-10.59,6.11a.07.07,0,0,1-.11,0,.11.11,0,0,1,0-.13L309,249.5s.1,0,.11,0A.08.08,0,0,1,309.05,249.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.51,250.46l0,0-10.58,6.11a.08.08,0,0,1-.12,0,.12.12,0,0,1,.05-.13l10.59-6.11a.08.08,0,0,1,.11,0A.1.1,0,0,1,310.51,250.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,250.75l0,0-10.58,6.11a.08.08,0,0,1-.12,0,.09.09,0,0,1,.05-.12l10.58-6.11a.08.08,0,0,1,.12,0A.1.1,0,0,1,311,250.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46,251.59l0,0-10.59,6.11a.07.07,0,0,1-.11,0,.1.1,0,0,1,0-.12l10.59-6.11s.1,0,.11,0A.08.08,0,0,1,312.46,251.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,251.87a.08.08,0,0,1,0,0L302.34,258a.09.09,0,0,1-.12,0,.09.09,0,0,1,0-.12l10.58-6.11a.08.08,0,0,1,.12,0A.08.08,0,0,1,313,251.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.46 237.81 310.06 245.55 311.37 246.31 324.77 238.57 323.46 237.81",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.46 237.81 310.06 245.55 311.37 246.31 324.77 238.57 323.46 237.81",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.9,246.48l-1.06.61-1-.6,1.07-.62Zm-1,.48.81-.47-.83-.48-.81.47Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.86,247.61l-1.07.61-1.05-.6,1.07-.62Zm-1.05.47.81-.46-.83-.48-.81.47Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,248.73l-1.07.62-1-.61,1.06-.61Zm-1.05.48.81-.47-.83-.48-.81.47Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.46,239.57a.08.08,0,0,1,0,0l-10.58,6.11a.09.09,0,0,1-.12,0,.11.11,0,0,1,0-.12l10.59-6.11a.07.07,0,0,1,.11,0A.07.07,0,0,1,325.46,239.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,239.86l0,0L315.34,246a.08.08,0,0,1-.12,0,.11.11,0,0,1,0-.13l10.58-6.11a.09.09,0,0,1,.12,0A.1.1,0,0,1,326,239.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.41,240.7l0,0-10.59,6.11a.07.07,0,0,1-.11,0,.1.1,0,0,1,0-.12l10.59-6.11s.1,0,.11,0A.08.08,0,0,1,327.41,240.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,241l0,0-10.58,6.11a.08.08,0,0,1-.12,0s0-.09.05-.12l10.58-6.11a.09.09,0,0,1,.12,0A.1.1,0,0,1,327.91,241Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37,241.83l0,0L318.75,248a.08.08,0,0,1-.12,0,.09.09,0,0,1,.05-.12l10.58-6.11a.09.09,0,0,1,.12,0A.1.1,0,0,1,329.37,241.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.86,242.11l0,0-10.59,6.11a.08.08,0,0,1-.11,0,.1.1,0,0,1,0-.12L329.76,242a.07.07,0,0,1,.11,0A.06.06,0,0,1,329.86,242.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.6 235 288.29 252.5 289.6 253.26 319.91 235.76 318.6 235",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.6 235 288.29 252.5 289.6 253.26 319.91 235.76 318.6 235",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.64,245.2l0,0-14.37,8.3a.09.09,0,0,1-.12,0,.09.09,0,0,1,.05-.12l14.37-8.3a.08.08,0,0,1,.12,0A.1.1,0,0,1,305.64,245.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,237.22l0,0L292,254a.07.07,0,0,1-.11,0,.1.1,0,0,1,0-.12l29-16.73a.08.08,0,0,1,.11,0A.08.08,0,0,1,321,237.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.73,237.64l0,0-29,16.73a.09.09,0,0,1-.12,0,.09.09,0,0,1,0-.12l29-16.73a.09.09,0,0,1,.12,0A.14.14,0,0,1,321.73,237.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.59,242.29l0,0-14.38,8.3a.07.07,0,0,1-.11,0,.09.09,0,0,1,.05-.12l14.37-8.3a.08.08,0,0,1,.12,0A.1.1,0,0,1,300.59,242.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,234.3a.08.08,0,0,1,0,0l-29,16.72a.07.07,0,0,1-.11,0,.1.1,0,0,1,0-.12l29-16.73a.07.07,0,0,1,.11,0A.06.06,0,0,1,316,234.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.67,234.72l0,0-29,16.73a.08.08,0,0,1-.12,0,.09.09,0,0,1,.05-.12l29-16.72a.08.08,0,0,1,.12,0A.1.1,0,0,1,316.67,234.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.28,233.31h0a.57.57,0,0,0,.24-.53,1.84,1.84,0,0,0-.82-1.43.58.58,0,0,0-.59,0h0L284,238.89l1.16,2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.55,239.89,298.28,232a1.72,1.72,0,0,1,.24.82.28.28,0,0,1,0,.09L285,240.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.38,240.37c0,.52-.37.74-.83.47a1.82,1.82,0,0,1-.82-1.42c0-.53.37-.74.82-.48A1.81,1.81,0,0,1,285.38,240.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.26,244.69a1.49,1.49,0,0,1-.73-.18l-3.5-2a.66.66,0,0,1-.37-.55.52.52,0,0,1,.29-.45l2.48-1.43a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.29l-2.48,1.43c-.05,0-.09.07-.09.09s.06.12.17.19l3.5,2a1,1,0,0,0,.89,0l6.73-3.88a4,4,0,0,0,1.29-1.23,3.73,3.73,0,0,1,1.18-1.14,1.75,1.75,0,0,1,.95-.27,4,4,0,0,0,2.13-.57l6.11-3.52a.14.14,0,0,0,.08-.1s-.05-.11-.16-.18l-3.5-2a1.06,1.06,0,0,0-.9-.05l-2.18,1.26a1.8,1.8,0,0,0-.21-.35l2.19-1.27a1.48,1.48,0,0,1,1.31,0l3.5,2a.66.66,0,0,1,.37.54.55.55,0,0,1-.29.46l-6.11,3.53a4.49,4.49,0,0,1-2.36.62,1.31,1.31,0,0,0-.72.21,3.34,3.34,0,0,0-1,1,4.58,4.58,0,0,1-1.43,1.35l-6.73,3.88A1.21,1.21,0,0,1,286.26,244.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.26,244.32a1.4,1.4,0,0,1-.73-.19l-3.5-2a.66.66,0,0,1-.37-.55.52.52,0,0,1,.29-.45l2.48-1.43a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.29l-2.48,1.43c-.05,0-.09.06-.09.09s.06.12.17.18l3.5,2a1,1,0,0,0,.89,0l6.73-3.89a3.83,3.83,0,0,0,1.29-1.22,3.73,3.73,0,0,1,1.18-1.14,1.75,1.75,0,0,1,.95-.27,4,4,0,0,0,2.13-.57l6.11-3.52c.05,0,.08-.07.08-.1s-.05-.11-.16-.18l-3.5-2a1.06,1.06,0,0,0-.9,0l-2.18,1.26a1.8,1.8,0,0,0-.21-.35l2.19-1.27a1.42,1.42,0,0,1,1.31.05l3.5,2a.65.65,0,0,1,.37.54.55.55,0,0,1-.29.46l-6.11,3.52a4.41,4.41,0,0,1-2.36.63,1.31,1.31,0,0,0-.72.21,3.23,3.23,0,0,0-1,1,4.58,4.58,0,0,1-1.43,1.35l-6.73,3.88A1.21,1.21,0,0,1,286.26,244.32Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "285.34 221.64 291.69 225.31 291.69 199.63 285.34 195.97 285.34 221.64",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.04 195.97 291.69 199.63 291.69 225.31 298.04 221.64 298.04 195.97",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.04 195.97 291.69 199.63 291.69 225.31 298.04 221.64 298.04 195.97",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.69 192.3 298.04 195.97 291.69 199.63 285.34 195.97 291.69 192.3",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.69 192.3 298.04 195.97 291.69 199.63 285.34 195.97 291.69 192.3",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.81 227.14 282.16 230.81 282.16 219.81 275.81 216.14 275.81 227.14",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.51 216.14 282.16 219.81 282.16 230.81 288.51 227.14 288.51 216.14",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.51 216.14 282.16 219.81 282.16 230.81 288.51 227.14 288.51 216.14",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.16 212.47 288.51 216.14 282.16 219.81 275.81 216.14 282.16 212.47",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.16 212.47 288.51 216.14 282.16 219.81 275.81 216.14 282.16 212.47",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.28 232.65 272.63 236.31 272.63 217.97 266.28 214.31 266.28 232.65",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.98 214.31 272.63 217.97 272.63 236.31 278.98 232.65 278.98 214.31",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.98 214.31 272.63 217.97 272.63 236.31 278.98 232.65 278.98 214.31",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.63 210.64 278.98 214.31 272.63 217.97 266.28 214.31 272.63 210.64",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.63 210.64 278.98 214.31 272.63 217.97 266.28 214.31 272.63 210.64",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.75 238.15 263.1 241.81 263.1 232.86 256.75 229.19 256.75 238.15",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.45 229.19 263.1 232.86 263.1 241.81 269.45 238.15 269.45 229.19",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.45 229.19 263.1 232.86 263.1 241.81 269.45 238.15 269.45 229.19",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.1 225.52 269.45 229.19 263.1 232.86 256.75 229.19 263.1 225.52",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.1 225.52 269.45 229.19 263.1 232.86 256.75 229.19 263.1 225.52",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.37,183.54l-3.28,1.18.3.81,1.87-.67-10,21.21-10.44-2-10.64,16.62.72.46L266.21,205l10.52,2,10.32-21.86.7,1.93.81-.29Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.37,183.54l-3.28,1.18.3.81,1.87-.67-10,21.21-10.44-2-10.64,16.62.72.46L266.21,205l10.52,2,10.32-21.86.7,1.93.81-.29Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.11,253.52l30.94,17.89,4.78,1a.14.14,0,0,0,.16-.21l-1.5-2.74-30.94-17.89C259.61,251,256.38,253.1,257.11,253.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.19,248.84a.34.34,0,0,1,.14,0l-.27-.16,0,0h0l-.05,0h-.23a1.17,1.17,0,0,0-.57.18,2.82,2.82,0,0,0-1.28,2.22,1.66,1.66,0,0,0,0,.32s0,0,0,0a0,0,0,0,0,0,0,.25.25,0,0,0,0,.07,1.14,1.14,0,0,0,.1.19.88.88,0,0,0,.19.17l.31.17a.49.49,0,0,1-.14-.11,1,1,0,0,0,.74-.15,2.84,2.84,0,0,0,1.28-2.22A1,1,0,0,0,260.19,248.84Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,266l-1.81,3.15-.31-.18-29.35-17a.49.49,0,0,1-.14-.11,1,1,0,0,1-.23-.72,2.82,2.82,0,0,1,1.28-2.22,1.12,1.12,0,0,1,.57-.17.41.41,0,0,1,.16,0,.34.34,0,0,1,.14,0h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.11,266.12c.71-.41,1.28-.07,1.28.74a2.82,2.82,0,0,1-1.28,2.22c-.71.41-1.28.08-1.28-.74A2.84,2.84,0,0,1,289.11,266.12Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,268l0,0-1.63-1.8h0v0l0,0,0,0h0a.81.81,0,0,0-1,0,2.84,2.84,0,0,0-1.28,2.22c0,.48.19.79.49.88h0l.09,0h0l2.37.52a.55.55,0,0,0,.41-.09,1.6,1.6,0,0,0,.74-1.27A.56.56,0,0,0,291.86,268Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,254.63h0l0,0a.35.35,0,0,0-.3.05,1,1,0,0,0-.45.79.35.35,0,0,0,.1.27h0l.06,0,22.44,13L291,268Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.94,267.67l1.81,1L291,268l-2.45-1.41A3.16,3.16,0,0,0,287.94,267.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.51,268.88h0L291,267.25l0,0a.58.58,0,0,0-.73,0,2,2,0,0,0-.91,1.57.59.59,0,0,0,.35.62h.07l2.17.47h0a.32.32,0,0,0,.24-.05.9.9,0,0,0,.41-.71A.33.33,0,0,0,292.51,268.88Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.51,268.88h0L291,267.25l0,0a.58.58,0,0,0-.73,0,2,2,0,0,0-.91,1.57.59.59,0,0,0,.35.62h.07l2.17.47h0a.32.32,0,0,0,.24-.05.9.9,0,0,0,.41-.71A.33.33,0,0,0,292.51,268.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.59,269.12a.9.9,0,0,1-.41.71.3.3,0,0,1-.23.05h0l-1.09-.24c-.18,0-.29-.2-.29-.46a1.44,1.44,0,0,1,.66-1.14.42.42,0,0,1,.53,0l0,0,.74.81h0A.33.33,0,0,1,292.59,269.12Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,268.88c.23-.13.41,0,.41.24a.9.9,0,0,1-.41.71c-.23.13-.41,0-.41-.24A.9.9,0,0,1,292.18,268.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,251.83a.32.32,0,0,0-.32,0,1,1,0,0,0-.45.79.3.3,0,0,0,.13.29h0l4.79,2.77a.35.35,0,0,1-.1-.27,1,1,0,0,1,.45-.79.35.35,0,0,1,.3-.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.23,252.12a1,1,0,0,1-.45.79.32.32,0,0,1-.32,0,.3.3,0,0,1-.13-.29,1,1,0,0,1,.45-.79.32.32,0,0,1,.32,0A.32.32,0,0,1,263.23,252.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.22,250.18h0l0,0-1.89-1.09,0,0h0a.84.84,0,0,0-.78.1,2.55,2.55,0,0,0-1.16,2,.82.82,0,0,0,.35.75h0l1.91,1.1h0a.82.82,0,0,0,.8-.09,2.52,2.52,0,0,0,1.15-2A.85.85,0,0,0,262.22,250.18Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.22,250.18h0l0,0-1.89-1.09,0,0h0a.84.84,0,0,0-.78.1,2.55,2.55,0,0,0-1.16,2,.82.82,0,0,0,.35.75h0l1.91,1.1h0a.82.82,0,0,0,.8-.09,2.52,2.52,0,0,0,1.15-2A.85.85,0,0,0,262.22,250.18Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.38,250.25c.64-.37,1.15-.07,1.15.67a2.52,2.52,0,0,1-1.15,2c-.64.37-1.15.07-1.15-.66A2.54,2.54,0,0,1,261.38,250.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.11,269.57h0l-.78-.47h0a.16.16,0,0,0-.15,0,.46.46,0,0,0-.21.37c0,.07,0,.11.06.13h0l.78.48h0a.32.32,0,0,0,.14,0,.29.29,0,0,0,.3-.3A.29.29,0,0,0,293.11,269.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.16,269.6h0l0,0h0a.13.13,0,0,0-.13,0,.46.46,0,0,0-.21.37.14.14,0,0,0,.06.13H293a.29.29,0,0,0,.3-.3A.31.31,0,0,0,293.16,269.6Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadows--inject-5",
    d: "M218.07,321.59c4.09,2.37,4.09,6.19,0,8.55-3.57,2.07-9.1,2.33-13.16.78h0l-.17-.06a11.92,11.92,0,0,1-1.48-.72c-3.41-2-4-4.95-1.7-7.26h0a8.06,8.06,0,0,1,1.69-1.29A16.37,16.37,0,0,1,218.07,321.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.23,323.45a5.87,5.87,0,0,0-2.16-2,14.15,14.15,0,0,0-12.8,0,5.87,5.87,0,0,0-2.16,2h-.49v1.85h0c.06,1.29.94,2.56,2.64,3.54a14.15,14.15,0,0,0,12.8,0c1.7-1,2.58-2.25,2.65-3.54h0v-1.85Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.23,323.45a5.87,5.87,0,0,0-2.16-2,14.15,14.15,0,0,0-12.8,0,5.87,5.87,0,0,0-2.16,2h-.49v1.85h0c.06,1.29.94,2.56,2.64,3.54a14.15,14.15,0,0,0,12.8,0c1.7-1,2.58-2.25,2.65-3.54h0v-1.85Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.67,319.92a13.08,13.08,0,0,0-6.4,1.53,5.87,5.87,0,0,0-2.16,2h-.49v1.85h0c.06,1.29.94,2.56,2.64,3.54a13.08,13.08,0,0,0,6.4,1.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.73,320.77a10.31,10.31,0,0,0-1.46.68,5.87,5.87,0,0,0-2.16,2h-.49v1.85h0c.06,1.29.94,2.56,2.64,3.54a9.31,9.31,0,0,0,1.46.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.61,320.77a10.86,10.86,0,0,1,1.46.68,5.87,5.87,0,0,1,2.16,2h.49v1.85h0c-.07,1.29-.95,2.56-2.65,3.54a9.75,9.75,0,0,1-1.46.68Z",
    style: {
      fill: "#800080",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.27,319.76c-3.53,2-3.53,5.35,0,7.39a14.38,14.38,0,0,0,11.38.67h0l.14-.06a10.07,10.07,0,0,0,1.28-.61c2.94-1.7,3.43-4.29,1.46-6.28h0a6.9,6.9,0,0,0-1.46-1.11A14.15,14.15,0,0,0,204.27,319.76Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.27,319.76c-3.53,2-3.53,5.35,0,7.39a14.38,14.38,0,0,0,11.38.67h0l.14-.06a10.07,10.07,0,0,0,1.28-.61c2.94-1.7,3.43-4.29,1.46-6.28h0a6.9,6.9,0,0,0-1.46-1.11A14.15,14.15,0,0,0,204.27,319.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53,320.87a3.93,3.93,0,0,1,.95,3.22c-.31,1.8-2.83,3.31-3.69,3.67a10.07,10.07,0,0,0,1.28-.61C220,325.45,220.5,322.86,218.53,320.87Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,326a3.94,3.94,0,0,1-.94-3.22c.31-1.8,2.82-3.31,3.69-3.67a8.87,8.87,0,0,0-1.28.61C201.32,321.46,200.83,324,202.8,326Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,326.88c3.28-1.9,3.28-5,0-6.87a13.2,13.2,0,0,0-11.9,0c-3.28,1.9-3.28,5,0,6.87A13.13,13.13,0,0,0,216.62,326.88Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,326.88c3.28-1.9,3.28-5,0-6.87a13.2,13.2,0,0,0-11.9,0c-3.28,1.9-3.28,5,0,6.87A13.13,13.13,0,0,0,216.62,326.88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7,324.9a3.11,3.11,0,0,0-.66-3.8,6.3,6.3,0,0,0-.71-.62,6.67,6.67,0,0,0-.68-.45l-.42-.23c.35.58.22,1.2-1.76,1.31-3.87.23,1,3.93,1,3.93S218,323.84,218.7,324.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,323.87c.58-.06.87-.66.64-1.33a1.51,1.51,0,0,0-1.46-1.1c-.58.06-.87.66-.64,1.33A1.51,1.51,0,0,0,218.3,323.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,327c-.19-1.44-6.48-5.42-6.48-5.42s-1.4-.56-.94-1.54c-.24.14-.46.28-.67.43s-.28.22-.41.33a3.28,3.28,0,0,0,0,5.38l.41.32a7.4,7.4,0,0,0,.62.41c.22.12.44.24.67.35l.57.24a5.89,5.89,0,0,0,.59.21,11.46,11.46,0,0,0,1.88.45l.42.06a14.56,14.56,0,0,0,1.87.12,13.47,13.47,0,0,0,2.3-.19A1,1,0,0,1,212.17,327Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,327c-.19-1.44-6.48-5.42-6.48-5.42s-1.4-.56-.94-1.54c-.24.14-.46.28-.67.43s-.28.22-.41.33a3.28,3.28,0,0,0,0,5.38l.41.32a7.4,7.4,0,0,0,.62.41c.22.12.44.24.67.35l.57.24a5.89,5.89,0,0,0,.59.21,11.46,11.46,0,0,0,1.88.45l.42.06a14.56,14.56,0,0,0,1.87.12,13.47,13.47,0,0,0,2.3-.19A1,1,0,0,1,212.17,327Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.24,320.89c-2.35,1.35-2.44,3.52-.29,4.94l.29.18a9.81,9.81,0,0,0,8.86,0c2.45-1.42,2.45-3.71,0-5.12l-.31-.17A9.86,9.86,0,0,0,206.24,320.89Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.24,320.89c-2.35,1.35-2.44,3.52-.29,4.94l.29.18a9.81,9.81,0,0,0,8.86,0c2.45-1.42,2.45-3.71,0-5.12l-.31-.17A9.86,9.86,0,0,0,206.24,320.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,321c-2.34,1.35-2.34,3.54,0,4.89a9.36,9.36,0,0,0,8.47,0c2.34-1.35,2.34-3.54,0-4.89A9.36,9.36,0,0,0,206.44,321Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,321c-2.34,1.35-2.34,3.54,0,4.89a9.36,9.36,0,0,0,8.47,0c2.34-1.35,2.34-3.54,0-4.89A9.36,9.36,0,0,0,206.44,321Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,322a9.36,9.36,0,0,1,8.47,0,2,2,0,0,1,0,3.92,9.36,9.36,0,0,1-8.47,0,2,2,0,0,1,0-3.92Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,322a9.36,9.36,0,0,1,8.47,0,2,2,0,0,1,0,3.92,9.36,9.36,0,0,1-8.47,0,2,2,0,0,1,0-3.92Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.44,324.49c0-.12,0-.59,0-.72,0-.29-.2-.57-.64-.83h0a3.13,3.13,0,0,0-2.38-.22h0c-.32.08-.62.19-.89.28a7.85,7.85,0,0,1-1,.29h0a1.87,1.87,0,0,1-.45,0,1,1,0,0,1-.38-.1l0,0,.1-.06a1.15,1.15,0,0,1,.25-.12,1.71,1.71,0,0,1,1.33,0l.77-.78v-.71a3.67,3.67,0,0,0-2.1-.08,5.3,5.3,0,0,0-.67.23l-.77-.44-.92.53v.71l.32.18a.78.78,0,0,0-.14.42v.71c0,.29.21.57.66.83a2.55,2.55,0,0,0,1.26.36h0a1.13,1.13,0,0,0,.26,0,5.07,5.07,0,0,0,1.36-.29l.26-.09-.77.77v.71a3.75,3.75,0,0,0,3-.13l.76.44.91-.53v-.71l-.31-.18A.84.84,0,0,0,214.44,324.49Zm-1.93-.06-.21.1a2,2,0,0,1-1.5,0c.72-.26,1.32-.48,1.83-.21Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.41,322.71h0c-.32.08-.62.19-.89.28a7.85,7.85,0,0,1-1,.29h0a1.87,1.87,0,0,1-.45,0,1,1,0,0,1-.44-.13c-.29-.17-.34-.42.09-.7l.1-.06.25-.13a1.8,1.8,0,0,1,1.33,0l.77-.77a3.67,3.67,0,0,0-2.1-.08,5.3,5.3,0,0,0-.67.23l-.77-.44-.92.53.76.44h0c-.77.59-.79,1.2.08,1.7a2.66,2.66,0,0,0,1.26.36h.26a5.07,5.07,0,0,0,1.36-.29c.87-.3,1.59-.64,2.18-.3.4.23.29.52-.15.77l-.21.1a1.93,1.93,0,0,1-1.53,0l-.8.81a3.75,3.75,0,0,0,3-.13l.76.44.91-.53-.75-.44c.76-.59.85-1.23,0-1.75h0A3.13,3.13,0,0,0,211.41,322.71Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.41,322.71h0c-.32.08-.62.19-.89.28a7.85,7.85,0,0,1-1,.29h0a1.87,1.87,0,0,1-.45,0,1,1,0,0,1-.44-.13c-.29-.17-.34-.42.09-.7l.1-.06.25-.13a1.8,1.8,0,0,1,1.33,0l.77-.77a3.67,3.67,0,0,0-2.1-.08,5.3,5.3,0,0,0-.67.23l-.77-.44-.92.53.76.44h0c-.77.59-.79,1.2.08,1.7a2.66,2.66,0,0,0,1.26.36h.26a5.07,5.07,0,0,0,1.36-.29c.87-.3,1.59-.64,2.18-.3.4.23.29.52-.15.77l-.21.1a1.93,1.93,0,0,1-1.53,0l-.8.81a3.75,3.75,0,0,0,3-.13l.76.44.91-.53-.75-.44c.76-.59.85-1.23,0-1.75h0A3.13,3.13,0,0,0,211.41,322.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 321.75 207.69 321.33 208.45 321.67 207.68 321.22 206.76 321.75",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,321.46a4.45,4.45,0,0,1,2,.07l-.53.75.77-.77A3.72,3.72,0,0,0,209,321.46Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,322.93h0c.9.52.81,1.16,0,1.75.67-.73.55-1.24-.19-1.67a3.49,3.49,0,0,0-2.25-.31A3.13,3.13,0,0,1,213.79,322.93Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.84 324.69 214.43 325.14 213.69 325.66 214.6 325.13 213.84 324.69",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.3,324.53a1.93,1.93,0,0,1-1.46.13l-.87.69.8-.81A1.93,1.93,0,0,0,212.3,324.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.57,323.29a1.2,1.2,0,0,1-1.1-.11c-.26-.23-.09-.47.3-.68-.43.28-.38.53-.09.7a1,1,0,0,0,.44.13A1.87,1.87,0,0,0,209.57,323.29Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,322.19c-.07.06-.62.58-.38,1.09a2.24,2.24,0,0,0,1.72,1h0a2.66,2.66,0,0,1-1.26-.36C206.73,323.39,206.75,322.78,207.52,322.19Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.18,320.69a5.79,5.79,0,0,0-2.16-2,14.13,14.13,0,0,0-12.79,0,5.9,5.9,0,0,0-2.17,2h-.48v1.85h0a4.61,4.61,0,0,0,2.65,3.54,14.13,14.13,0,0,0,12.79,0c1.7-1,2.59-2.26,2.65-3.54h0v-1.85Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.18,320.69a5.79,5.79,0,0,0-2.16-2,14.13,14.13,0,0,0-12.79,0,5.9,5.9,0,0,0-2.17,2h-.48v1.85h0a4.61,4.61,0,0,0,2.65,3.54,14.13,14.13,0,0,0,12.79,0c1.7-1,2.59-2.26,2.65-3.54h0v-1.85Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.62,317.16a13,13,0,0,0-6.39,1.53,5.9,5.9,0,0,0-2.17,2h-.48v1.85h0a4.61,4.61,0,0,0,2.65,3.54,13,13,0,0,0,6.39,1.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68,318a9.64,9.64,0,0,0-1.45.68,5.9,5.9,0,0,0-2.17,2h-.48v1.85h0a4.61,4.61,0,0,0,2.65,3.54,9.64,9.64,0,0,0,1.45.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.57,318a9.64,9.64,0,0,1,1.45.68,5.79,5.79,0,0,1,2.16,2h.49v1.85h0c-.06,1.28-.95,2.56-2.65,3.54a9.64,9.64,0,0,1-1.45.68Z",
    style: {
      fill: "#800080",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.23,317c-3.54,2-3.54,5.35,0,7.38a14.32,14.32,0,0,0,11.37.67h0l.14-.05a8.91,8.91,0,0,0,1.28-.62c2.95-1.7,3.44-4.28,1.47-6.27h0A6.73,6.73,0,0,0,216,317,14.13,14.13,0,0,0,203.23,317Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.23,317c-3.54,2-3.54,5.35,0,7.38a14.32,14.32,0,0,0,11.37.67h0l.14-.05a8.91,8.91,0,0,0,1.28-.62c2.95-1.7,3.44-4.28,1.47-6.27h0A6.73,6.73,0,0,0,216,317,14.13,14.13,0,0,0,203.23,317Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.49,318.11a4,4,0,0,1,.95,3.22c-.32,1.8-2.83,3.31-3.7,3.67a8.91,8.91,0,0,0,1.28-.62C219,322.68,219.46,320.1,217.49,318.11Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.76,323.28a4,4,0,0,1-.95-3.23c.31-1.79,2.83-3.3,3.7-3.67a10.11,10.11,0,0,0-1.28.62C200.28,318.7,199.79,321.28,201.76,323.28Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.63,
    cy: 320.68,
    rx: 8.41,
    ry: 4.86,
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.63,
    cy: 320.68,
    rx: 8.41,
    ry: 4.86,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.66,322.13a3.12,3.12,0,0,0-.66-3.79,5.6,5.6,0,0,0-.72-.63,7.26,7.26,0,0,0-.68-.44l-.41-.23c.35.58.22,1.19-1.76,1.31-3.88.22,1,3.93,1,3.93S217,321.07,217.66,322.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,321.11c.58-.07.87-.66.64-1.34a1.55,1.55,0,0,0-1.46-1.1c-.58.07-.87.67-.65,1.34A1.55,1.55,0,0,0,217.26,321.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.12,324.2c-.19-1.44-6.48-5.43-6.48-5.43s-1.4-.56-.93-1.53a7,7,0,0,0-.67.43,3.47,3.47,0,0,0-.41.33,3.26,3.26,0,0,0,0,5.37,4.91,4.91,0,0,0,.41.33,7.36,7.36,0,0,0,.62.4,7.06,7.06,0,0,0,.67.35l.56.25.59.21a12.58,12.58,0,0,0,1.88.45l.42.06a14.35,14.35,0,0,0,4.18-.07S210.94,325.14,211.12,324.2Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.12,324.2c-.19-1.44-6.48-5.43-6.48-5.43s-1.4-.56-.93-1.53a7,7,0,0,0-.67.43,3.47,3.47,0,0,0-.41.33,3.26,3.26,0,0,0,0,5.37,4.91,4.91,0,0,0,.41.33,7.36,7.36,0,0,0,.62.4,7.06,7.06,0,0,0,.67.35l.56.25.59.21a12.58,12.58,0,0,0,1.88.45l.42.06a14.35,14.35,0,0,0,4.18-.07S210.94,325.14,211.12,324.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.19,318.13c-2.34,1.35-2.44,3.51-.28,4.93l.28.18a9.81,9.81,0,0,0,8.86,0c2.45-1.41,2.45-3.7,0-5.11l-.31-.17A9.85,9.85,0,0,0,205.19,318.13Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.19,318.13c-2.34,1.35-2.44,3.51-.28,4.93l.28.18a9.81,9.81,0,0,0,8.86,0c2.45-1.41,2.45-3.7,0-5.11l-.31-.17A9.85,9.85,0,0,0,205.19,318.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.39,318.24c-2.34,1.35-2.34,3.54,0,4.89a9.36,9.36,0,0,0,8.47,0c2.34-1.35,2.34-3.54,0-4.89A9.36,9.36,0,0,0,205.39,318.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.39,318.24c-2.34,1.35-2.34,3.54,0,4.89a9.36,9.36,0,0,0,8.47,0c2.34-1.35,2.34-3.54,0-4.89A9.36,9.36,0,0,0,205.39,318.24Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.39,319.2a9.36,9.36,0,0,1,8.47,0,2,2,0,0,1,0,3.93,9.36,9.36,0,0,1-8.47,0,2,2,0,0,1,0-3.93Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.39,319.2a9.36,9.36,0,0,1,8.47,0,2,2,0,0,1,0,3.93,9.36,9.36,0,0,1-8.47,0,2,2,0,0,1,0-3.93Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,321.73V321c0-.29-.2-.58-.64-.83h0a3,3,0,0,0-2.37-.22h0a9.11,9.11,0,0,0-.88.28c-.38.13-.69.23-.95.29h0a1.82,1.82,0,0,1-.45.05,1.2,1.2,0,0,1-.37-.1l0,0,.09-.06.25-.13a1.76,1.76,0,0,1,1.33,0l.77-.77v-.71a3.66,3.66,0,0,0-2.1-.08,4.84,4.84,0,0,0-.67.23l-.76-.44-.92.53v.71l.31.18a.76.76,0,0,0-.13.41V321c0,.3.21.58.65.84a2.81,2.81,0,0,0,1.27.36h.25a4.65,4.65,0,0,0,1.36-.3l.26-.09-.77.78v.71a3.74,3.74,0,0,0,3-.13l.76.44.92-.53v-.71l-.32-.18A.8.8,0,0,0,213.4,321.73Zm-1.93-.07-.22.11a2,2,0,0,1-1.5,0c.72-.25,1.32-.47,1.83-.2Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,320h0a9.11,9.11,0,0,0-.88.28c-.38.13-.69.23-.95.29h0a1.82,1.82,0,0,1-.45.05.94.94,0,0,1-.43-.13c-.3-.18-.34-.42.09-.71l.09-.05.25-.13a1.71,1.71,0,0,1,1.33,0l.77-.77a3.66,3.66,0,0,0-2.1-.08,4.84,4.84,0,0,0-.67.23l-.76-.44-.92.53.76.44h0c-.77.59-.78,1.19.08,1.69a2.71,2.71,0,0,0,1.27.37h.25a5,5,0,0,0,1.36-.3c.88-.29,1.59-.64,2.18-.29.4.22.29.51-.14.76l-.22.11a2,2,0,0,1-1.52,0l-.81.81a3.74,3.74,0,0,0,3-.13l.76.44.92-.53-.76-.44c.76-.59.85-1.23,0-1.75h0A3,3,0,0,0,210.37,320Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.37,320h0a9.11,9.11,0,0,0-.88.28c-.38.13-.69.23-.95.29h0a1.82,1.82,0,0,1-.45.05.94.94,0,0,1-.43-.13c-.3-.18-.34-.42.09-.71l.09-.05.25-.13a1.71,1.71,0,0,1,1.33,0l.77-.77a3.66,3.66,0,0,0-2.1-.08,4.84,4.84,0,0,0-.67.23l-.76-.44-.92.53.76.44h0c-.77.59-.78,1.19.08,1.69a2.71,2.71,0,0,0,1.27.37h.25a5,5,0,0,0,1.36-.3c.88-.29,1.59-.64,2.18-.29.4.22.29.51-.14.76l-.22.11a2,2,0,0,1-1.52,0l-.81.81a3.74,3.74,0,0,0,3-.13l.76.44.92-.53-.76-.44c.76-.59.85-1.23,0-1.75h0A3,3,0,0,0,210.37,320Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "205.72 318.99 206.65 318.57 207.4 318.9 206.64 318.46 205.72 318.99",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,318.7a4.17,4.17,0,0,1,2,.07l-.53.75.77-.77A3.64,3.64,0,0,0,208,318.7Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.74,320.17h0c.89.52.8,1.16,0,1.75.68-.73.55-1.25-.18-1.67a3.49,3.49,0,0,0-2.25-.31A3,3,0,0,1,212.74,320.17Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.8 321.93 213.38 322.38 212.64 322.9 213.56 322.37 212.8 321.93",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.25,321.77a2,2,0,0,1-1.46.13l-.87.69.81-.81A2,2,0,0,0,211.25,321.77Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,320.52a1.16,1.16,0,0,1-1.09-.1c-.27-.23-.1-.47.3-.69-.43.29-.39.53-.09.71a.94.94,0,0,0,.43.13A1.82,1.82,0,0,0,208.52,320.52Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.47,319.43c-.06.06-.62.57-.37,1.09a2.24,2.24,0,0,0,1.72,1h0a2.71,2.71,0,0,1-1.27-.37C205.69,320.62,205.7,320,206.47,319.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.77,317.8a5.77,5.77,0,0,1,2.16-2,14.13,14.13,0,0,1,12.79,0,5.77,5.77,0,0,1,2.16,2h.49v1.85h0c-.07,1.29-1,2.56-2.65,3.54a14.13,14.13,0,0,1-12.79,0c-1.7-1-2.59-2.25-2.65-3.54h0V317.8Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77,317.8a5.77,5.77,0,0,1,2.16-2,14.13,14.13,0,0,1,12.79,0,5.77,5.77,0,0,1,2.16,2h.49v1.85h0c-.07,1.29-1,2.56-2.65,3.54a14.13,14.13,0,0,1-12.79,0c-1.7-1-2.59-2.25-2.65-3.54h0V317.8Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.32,314.28a13.06,13.06,0,0,1,6.4,1.53,5.77,5.77,0,0,1,2.16,2h.49v1.85h0c-.07,1.29-1,2.56-2.65,3.54a13.06,13.06,0,0,1-6.4,1.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.27,315.12a10.76,10.76,0,0,1,1.45.69,5.77,5.77,0,0,1,2.16,2h.49v1.85h0c-.07,1.29-1,2.56-2.65,3.54a10.76,10.76,0,0,1-1.45.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.38,315.12a10.76,10.76,0,0,0-1.45.69,5.77,5.77,0,0,0-2.16,2h-.49v1.85h0c.06,1.29.95,2.56,2.65,3.54a10.76,10.76,0,0,0,1.45.69Z",
    style: {
      fill: "#800080",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.72,314.11c3.54,2,3.54,5.35,0,7.39a14.36,14.36,0,0,1-11.37.67h0l-.14-.06a8.87,8.87,0,0,1-1.28-.61c-3-1.7-3.44-4.28-1.47-6.28h0a6.73,6.73,0,0,1,1.47-1.11A14.13,14.13,0,0,1,216.72,314.11Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.72,314.11c3.54,2,3.54,5.35,0,7.39a14.36,14.36,0,0,1-11.37.67h0l-.14-.06a8.87,8.87,0,0,1-1.28-.61c-3-1.7-3.44-4.28-1.47-6.28h0a6.73,6.73,0,0,1,1.47-1.11A14.13,14.13,0,0,1,216.72,314.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.46,315.22a4,4,0,0,0-1,3.22c.32,1.8,2.83,3.31,3.7,3.67a8.87,8.87,0,0,1-1.28-.61C201,319.8,200.49,317.22,202.46,315.22Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.19,320.39a3.93,3.93,0,0,0,.95-3.22c-.32-1.8-2.83-3.31-3.7-3.67a10.07,10.07,0,0,1,1.28.61C219.67,315.81,220.16,318.4,218.19,320.39Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,321.23c-3.28-1.89-3.28-5,0-6.87a13.2,13.2,0,0,1,11.9,0c3.28,1.9,3.28,5,0,6.87A13.13,13.13,0,0,1,204.38,321.23Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,321.23c-3.28-1.89-3.28-5,0-6.87a13.2,13.2,0,0,1,11.9,0c3.28,1.9,3.28,5,0,6.87A13.13,13.13,0,0,1,204.38,321.23Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,319.25a3.11,3.11,0,0,1,.66-3.8,6.3,6.3,0,0,1,.71-.62,6.67,6.67,0,0,1,.68-.45l.42-.22c-.35.57-.22,1.19,1.76,1.3,3.87.23-1,3.93-1,3.93S203,318.19,202.3,319.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7,318.22c-.58-.06-.87-.66-.64-1.33a1.51,1.51,0,0,1,1.46-1.1c.58.06.87.66.64,1.33A1.51,1.51,0,0,1,202.7,318.22Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.83,321.31c.19-1.44,6.49-5.42,6.49-5.42s1.39-.56.93-1.54c.24.14.46.29.67.44a4.47,4.47,0,0,1,.41.32,3.28,3.28,0,0,1,0,5.38,4.47,4.47,0,0,1-.41.32,7.4,7.4,0,0,1-.62.41c-.22.12-.44.24-.67.35l-.57.24a5.89,5.89,0,0,1-.59.21,11.34,11.34,0,0,1-1.87.45l-.43.07a15.28,15.28,0,0,1-4.17-.07A1,1,0,0,0,208.83,321.31Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.83,321.31c.19-1.44,6.49-5.42,6.49-5.42s1.39-.56.93-1.54c.24.14.46.29.67.44a4.47,4.47,0,0,1,.41.32,3.28,3.28,0,0,1,0,5.38,4.47,4.47,0,0,1-.41.32,7.4,7.4,0,0,1-.62.41c-.22.12-.44.24-.67.35l-.57.24a5.89,5.89,0,0,1-.59.21,11.34,11.34,0,0,1-1.87.45l-.43.07a15.28,15.28,0,0,1-4.17-.07A1,1,0,0,0,208.83,321.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,315.24c2.35,1.36,2.45,3.52.29,4.94l-.29.18a9.81,9.81,0,0,1-8.86,0c-2.45-1.42-2.45-3.71,0-5.12l.31-.17A9.89,9.89,0,0,1,214.76,315.24Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,315.24c2.35,1.36,2.45,3.52.29,4.94l-.29.18a9.81,9.81,0,0,1-8.86,0c-2.45-1.42-2.45-3.71,0-5.12l.31-.17A9.89,9.89,0,0,1,214.76,315.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,315.35c2.34,1.35,2.34,3.54,0,4.89a9.36,9.36,0,0,1-8.47,0c-2.34-1.35-2.34-3.54,0-4.89A9.36,9.36,0,0,1,214.56,315.35Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,315.35c2.34,1.35,2.34,3.54,0,4.89a9.36,9.36,0,0,1-8.47,0c-2.34-1.35-2.34-3.54,0-4.89A9.36,9.36,0,0,1,214.56,315.35Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,316.32a9.36,9.36,0,0,0-8.47,0,2,2,0,0,0,0,3.92,9.36,9.36,0,0,0,8.47,0,2,2,0,0,0,0-3.92Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,316.32a9.36,9.36,0,0,0-8.47,0,2,2,0,0,0,0,3.92,9.36,9.36,0,0,0,8.47,0,2,2,0,0,0,0-3.92Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1,318.84v-.71c0-.3-.2-.58-.64-.84h0a3.08,3.08,0,0,0-2.38-.21h0c-.31.08-.61.18-.88.27s-.69.24-1,.3h0a1.91,1.91,0,0,1-.46,0,1,1,0,0,1-.37-.1l0,0,.09-.06.25-.12a1.71,1.71,0,0,1,1.33,0l.77-.78v-.71a3.75,3.75,0,0,0-2.1-.08,4.38,4.38,0,0,0-.66.24l-.77-.45-.92.53v.71l.31.18a.86.86,0,0,0-.13.42v.71c0,.29.21.57.65.83a2.61,2.61,0,0,0,1.27.36h.25a5,5,0,0,0,1.36-.29l.27-.09-.78.77v.71a3.81,3.81,0,0,0,3-.12l.75.43.92-.53v-.71l-.31-.18A.84.84,0,0,0,214.1,318.84Zm-1.93-.06-.22.11a2,2,0,0,1-1.49,0c.71-.26,1.31-.48,1.82-.21Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.07,317.07h0c-.31.08-.61.18-.88.27s-.69.24-1,.3h0a1.91,1.91,0,0,1-.46,0,1,1,0,0,1-.43-.13c-.3-.17-.34-.42.09-.7l.09-.06.25-.12a1.71,1.71,0,0,1,1.33,0l.77-.78a3.75,3.75,0,0,0-2.1-.08,4.38,4.38,0,0,0-.66.24l-.77-.45-.92.53.76.44h0c-.77.58-.78,1.19.08,1.69a2.61,2.61,0,0,0,1.27.36h.25a5,5,0,0,0,1.36-.29c.88-.3,1.59-.64,2.19-.3.39.23.28.52-.15.77l-.21.11a2,2,0,0,1-1.53,0l-.81.8a3.81,3.81,0,0,0,3-.12l.75.43.92-.53-.76-.43c.76-.59.85-1.24,0-1.76h0A3.08,3.08,0,0,0,211.07,317.07Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.07,317.07h0c-.31.08-.61.18-.88.27s-.69.24-1,.3h0a1.91,1.91,0,0,1-.46,0,1,1,0,0,1-.43-.13c-.3-.17-.34-.42.09-.7l.09-.06.25-.12a1.71,1.71,0,0,1,1.33,0l.77-.78a3.75,3.75,0,0,0-2.1-.08,4.38,4.38,0,0,0-.66.24l-.77-.45-.92.53.76.44h0c-.77.58-.78,1.19.08,1.69a2.61,2.61,0,0,0,1.27.36h.25a5,5,0,0,0,1.36-.29c.88-.3,1.59-.64,2.19-.3.39.23.28.52-.15.77l-.21.11a2,2,0,0,1-1.53,0l-.81.8a3.81,3.81,0,0,0,3-.12l.75.43.92-.53-.76-.43c.76-.59.85-1.24,0-1.76h0A3.08,3.08,0,0,0,211.07,317.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "206.42 316.1 207.35 315.68 208.1 316.02 207.34 315.57 206.42 316.1",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,315.81a4.45,4.45,0,0,1,2,.07l-.54.76.77-.78A3.69,3.69,0,0,0,208.67,315.81Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45,317.28h0c.89.52.8,1.17,0,1.76.68-.74.56-1.25-.18-1.68a3.41,3.41,0,0,0-2.25-.3A3.08,3.08,0,0,1,213.45,317.28Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.5 319.05 214.08 319.49 213.34 320.01 214.26 319.48 213.5 319.05",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,318.89a2,2,0,0,1-1.47.12l-.87.69.81-.8A2,2,0,0,0,212,318.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,317.64a1.2,1.2,0,0,1-1.1-.11c-.27-.22-.1-.47.3-.68-.43.28-.39.53-.09.7a1,1,0,0,0,.43.13A1.91,1.91,0,0,0,209.23,317.64Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.17,316.55c-.06.05-.61.57-.37,1.08a2.24,2.24,0,0,0,1.72,1h0a2.61,2.61,0,0,1-1.27-.36C206.39,317.74,206.4,317.13,207.17,316.55Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.33 316.88 202.56 315.15 202.79 316.88 205.79 317.02 202.79 317.15 202.56 318.88 202.33 317.15 199.34 317.02 202.33 316.88",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M243.75,305.31l0,0c-.58-.34-.56-.89,0-1.23l24.86-14.35a2.35,2.35,0,0,1,2.16,0l16.41,9.47c.59.34.6.89,0,1.23l0,0-24.85,14.35a2.41,2.41,0,0,1-2.16,0l-4-2.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--card--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.78,311.64h0l-.44.26-.15.07-.13.06h0l-.15,0-.09,0-.23,0h-.18s0,0,0,0h-.08a.75.75,0,0,1-.15,0h-.25l-.12,0-.21-.05-.11,0-.07,0-.07,0-.1-.05-4-2.3-12.43-7.17-.44-.64V303a.75.75,0,0,0,.45.67l16.41,9.48.11.06.13.05.23.08.1,0a1.46,1.46,0,0,0,.22,0l.29,0h.29a1.26,1.26,0,0,0,.28-.05.53.53,0,0,0,.12,0h0l.1,0,.11-.05.15-.07.44-.26Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,311.64h0l-.44.26-.15.07-.13.06h0l-.15,0-.09,0-.23,0h-.18s0,0,0,0h-.08a.75.75,0,0,1-.15,0h-.25l-.12,0-.21-.05-.11,0-.07,0-.07,0-.1-.05-4-2.3-12.43-7.17-.44-.64V303a.75.75,0,0,0,.45.67l16.41,9.48.11.06.13.05.23.08.1,0a1.46,1.46,0,0,0,.22,0l.29,0h.29a1.26,1.26,0,0,0,.28-.05.53.53,0,0,0,.12,0h0l.1,0,.11-.05.15-.07.44-.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.64,296.92l-.45.63-24.41,14.09h0l-.44.26a2.39,2.39,0,0,1-1.37.24v1.21a2.24,2.24,0,0,0,1.37-.24l.44-.26,24.41-14.09a.75.75,0,0,0,.45-.56C287.65,297.91,287.64,296.92,287.64,296.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,311.64h0l-.44.26a2.39,2.39,0,0,1-1.37.24v1.21a2.24,2.24,0,0,0,1.37-.24l.44-.26Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,311.64h0l-.44.26-.15.07-.13.06h0l-.15,0-.09,0-.23,0h-.29a.38.38,0,0,1-.15,0H261v1.21l.3,0h.29a1.37,1.37,0,0,0,.28-.05.53.53,0,0,0,.12,0h0l.1,0,.11-.05.15-.07.44-.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,302.42h0a.65.65,0,0,1,0-1.23l24.86-14.35a2.35,2.35,0,0,1,2.16,0l16.42,9.47a.65.65,0,0,1,0,1.23l0,0L262.34,311.9a2.41,2.41,0,0,1-2.16,0l-4-2.3Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.18,311.9h0a2.38,2.38,0,0,0,2.13,0l24.85-14.35c.6-.35.6-.91,0-1.25l-16.41-9.48a2.38,2.38,0,0,0-2.13,0h0l-24.85,14.35c-.6.35-.6.91,0,1.25l4,2.3Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,302.42l4,2.3,27-15.6-4-2.3a2.38,2.38,0,0,0-2.13,0h0l-24.85,14.35C243.17,301.52,243.17,302.08,243.77,302.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,311.41,244.41,300.8l-.65.38c-.58.34-.59.89,0,1.22,0,0,0,0,0,0l12.43,7.17,4,2.3a2.24,2.24,0,0,0,1.08.26h.15l.19,0h0l.19,0a1.93,1.93,0,0,0,.51-.19l.44-.26h0Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.98 311.53 263.87 311.01 250.37 303.21 249.47 303.73 262.98 311.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.69,302.13l-.09,0a.11.11,0,0,1-.08,0L247.6,301a.05.05,0,0,1,0,0,.08.08,0,0,1,.05-.05l1-.58a1.27,1.27,0,0,1,.42-.18,1.36,1.36,0,0,1,.38-.06,1.47,1.47,0,0,1,.32,0,.61.61,0,0,1,.23.09.49.49,0,0,1,.13.1.21.21,0,0,1,0,.11.34.34,0,0,1,0,.09.64.64,0,0,1,0,.07,1.48,1.48,0,0,1,.37,0,.84.84,0,0,1,.38.11.66.66,0,0,1,.17.16.25.25,0,0,1,.06.2.37.37,0,0,1-.08.21.89.89,0,0,1-.27.22Zm-.16-1.62a.42.42,0,0,0-.25-.05.85.85,0,0,0-.32.12l-.6.35.45.26.61-.35c.12-.07.19-.13.2-.18S249.61,300.56,249.53,300.51Zm.16,1.19.64-.37c.12-.07.19-.14.2-.2a.14.14,0,0,0-.09-.15.61.61,0,0,0-.28-.06.82.82,0,0,0-.34.12l-.64.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,299a.17.17,0,0,1,.11,0l.12,0,2.72.6h0a.05.05,0,0,1,0,.05s0,0,0,.05l-.25.14a.19.19,0,0,1-.12,0h-.08l-.48-.1-1.08.62.18.28a.07.07,0,0,1,0,0s0,0-.07.07l-.25.14s-.05,0-.09,0a.11.11,0,0,1-.08,0l0,0-1-1.56a.13.13,0,0,1,0-.07.1.1,0,0,1,.06-.07Zm1.49.64-1.22-.27.47.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,298.56l-.12,0h-.08l-2.2-.16,1.23.71a.05.05,0,0,1,0,.05.08.08,0,0,1-.05.05l-.27.16-.09,0a.13.13,0,0,1-.09,0l-1.91-1.11a.05.05,0,0,1,0-.05s0,0,0-.05l.24-.14.12,0h.08l2.2.16-1.23-.7a.05.05,0,0,1,0-.05.1.1,0,0,1,0-.05l.28-.16a.32.32,0,0,1,.09,0l.09,0,1.91,1.11a.05.05,0,0,1,0,.05s0,0,0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,296.93h.07s0,0,0,.05a.07.07,0,0,1,0,.05l-.33.19a.34.34,0,0,1-.14,0h-1.68l.78.45a.05.05,0,0,1,0,.05.07.07,0,0,1,0,0l-.28.16-.09,0-.08,0-1.92-1.11a.05.05,0,0,1,0,0s0,0,0-.05l.28-.16.09,0a.11.11,0,0,1,.08,0l.7.4,0-.84a.14.14,0,0,1,0-.07.22.22,0,0,1,.07-.06l.32-.18a.12.12,0,0,1,.09,0l.08,0s0,0,0,0l-.05,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.09,306.23l-.44.25-.07,0h-.07a.05.05,0,0,1,0,0,.05.05,0,0,1,0,0l.15-.08L259,306a.25.25,0,0,0-.13,0,.33.33,0,0,0-.14,0h0l-.07,0h-.07l0,0s0,0,0,0h0a.54.54,0,0,1,.28-.08.45.45,0,0,1,.27.05l.64.37.14-.08a.1.1,0,0,1,.07,0h.07s0,0,0,0A.05.05,0,0,1,260.09,306.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.66,305.46l-.29.17a.13.13,0,0,0-.07.08s0,.05.05.07l.1.06s0,0,0,0h0l.63-.36.07,0h.07a.05.05,0,0,1,0,0,.05.05,0,0,1,0,0l-.74.42a.08.08,0,0,1-.07,0h-.07l-.19-.11a.14.14,0,0,1-.09-.15.24.24,0,0,1,.13-.17l.3-.17a.09.09,0,0,0,.06-.08s0-.05,0-.07l-.13-.08a.25.25,0,0,0-.13,0l-.14,0-.3.17s-.06.05-.06.08,0,.06,0,.08,0,0,0,0a.08.08,0,0,1,0,0l-.07,0h-.06a.16.16,0,0,1-.1-.16.24.24,0,0,1,.13-.16l.3-.17a.61.61,0,0,1,.28-.08.54.54,0,0,1,.27.06l.12.07c.07,0,.11.09.1.15A.23.23,0,0,1,260.66,305.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.19,304.65l.07,0a.16.16,0,0,1,.09.16.24.24,0,0,1-.13.16l-.29.17a.7.7,0,0,1-.29.08.53.53,0,0,1-.26-.06s0,0,0,0l0,0,.07,0,.06,0a.21.21,0,0,0,.14,0,.32.32,0,0,0,.14,0l.29-.17a.17.17,0,0,0,.07-.08.07.07,0,0,0-.05-.08l-.06,0a.28.28,0,0,0-.13,0l-.15,0-.07.05h-.07a.08.08,0,0,1-.07,0,.05.05,0,0,1,0,0,.05.05,0,0,1,0,0l.08,0a.09.09,0,0,0,.06-.08.07.07,0,0,0,0-.08l-.07,0a.25.25,0,0,0-.13,0,.23.23,0,0,0-.14,0l-.29.17s-.07,0-.07.08,0,.05,0,.07a.08.08,0,0,1,0,0s0,0,0,0l-.07,0h-.07a.14.14,0,0,1-.09-.15c0-.07.05-.12.13-.17l.29-.17a.64.64,0,0,1,.28-.07.45.45,0,0,1,.27.05l.06,0s.07,0,.08.07a.1.1,0,0,1,0,.09h.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.65,304.15l0,.05h-.07a.06.06,0,0,1-.06,0l-.36-.2a.27.27,0,0,1-.11.1l-.29.17a.65.65,0,0,1-.28.08.54.54,0,0,1-.27-.06l-.32-.18a.05.05,0,0,1,0,0,.05.05,0,0,1,0,0l.07,0,.07,0,.32.18a.25.25,0,0,0,.13,0l.14,0,.3-.17s.06,0,.06-.08,0-.06-.05-.08l-.31-.18a.05.05,0,0,1,0,0s0,0,0,0l.07,0h.06l.89.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63,302.83h.07l.41-.23a.61.61,0,0,1,.28-.08.53.53,0,0,1,.26.06l.13.07a.14.14,0,0,1,.09.15c0,.06-.05.12-.13.17l-.29.17a.64.64,0,0,1-.28.07.45.45,0,0,1-.27,0s0,0,0,0,0,0,0,0l.07,0h.07a.25.25,0,0,0,.13,0,.23.23,0,0,0,.14,0l.29-.17c.05,0,.07-.05.07-.08a.08.08,0,0,0-.05-.08l-.12-.07a.29.29,0,0,0-.14,0l-.14,0-.44.26-.14,0a.25.25,0,0,1-.13,0l-.32-.19s0,0,0,0,0,0,0,0l.73-.43.08,0,.06,0s0,0,0,0,0,0,0,0l-.62.36,0,0a0,0,0,0,0,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,302.09l.29-.17a.65.65,0,0,1,.28-.08.54.54,0,0,1,.27.06l.13.07a.14.14,0,0,1,.09.15.24.24,0,0,1-.13.17l-.3.17a.61.61,0,0,1-.28.07.45.45,0,0,1-.27,0l-.5-.29c-.07,0-.11-.09-.1-.16s0-.11.14-.16l.29-.17a.65.65,0,0,1,.28-.08.54.54,0,0,1,.27.06s0,0,0,0a.05.05,0,0,1,0,0l-.07,0-.07,0a.18.18,0,0,0-.13,0,.29.29,0,0,0-.14,0l-.3.17s-.06.05-.06.09,0,.05,0,.07l.16.1A.32.32,0,0,1,266,302.09Zm.23.31a.27.27,0,0,0,.13,0,.21.21,0,0,0,.14,0l.3-.17a.13.13,0,0,0,.07-.08s0-.05-.05-.07l-.13-.08a.18.18,0,0,0-.13,0,.32.32,0,0,0-.14,0l-.3.17s-.06,0-.06.09,0,.05,0,.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,301.11l.21.51h0v0h0l-.06,0-.07,0a.06.06,0,0,1,0-.06l-.21-.46,0-.05-.05,0h0a.18.18,0,0,0-.13,0,.23.23,0,0,0-.14,0l-.15.08-.07,0-.29.17-.07,0h-.07s0,0,0,0a.05.05,0,0,1,0,0l.29-.17.08,0,.14-.09a.65.65,0,0,1,.29-.07.44.44,0,0,1,.26.05l.08.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.24,300.58l.06,0a.17.17,0,0,1,.1.15.22.22,0,0,1-.14.16l-.29.17a.61.61,0,0,1-.28.08.45.45,0,0,1-.27-.06l-.06,0a.2.2,0,0,1-.08-.08.1.1,0,0,1,0-.09h-.16a.4.4,0,0,1-.13,0l-.07,0a.14.14,0,0,1-.09-.15.26.26,0,0,1,.13-.17l.3-.16a.51.51,0,0,1,.28-.08.45.45,0,0,1,.27.05l.06,0a.2.2,0,0,1,.08.08.14.14,0,0,1,0,.09h.16Zm-.59-.17a.28.28,0,0,0-.13,0,.33.33,0,0,0-.15,0l-.29.17a.13.13,0,0,0-.07.08.1.1,0,0,0,.05.08l.06,0a.29.29,0,0,0,.14,0,.33.33,0,0,0,.14,0l.29-.17a.13.13,0,0,0,.07-.08.08.08,0,0,0-.05-.08Zm.44.25a.18.18,0,0,0-.13,0,.23.23,0,0,0-.14,0l-.29.17s-.07,0-.07.08,0,.05.05.07l.06,0a.25.25,0,0,0,.13,0l.14,0,.3-.17a.09.09,0,0,0,.06-.08.07.07,0,0,0,0-.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.61,299.58l-.29.17a.64.64,0,0,1-.28.07.45.45,0,0,1-.27-.05s0,0,0,0,0,0,0,0l.07,0h.07a.25.25,0,0,0,.13,0,.23.23,0,0,0,.14,0l.3-.17a.09.09,0,0,0,.06-.08.07.07,0,0,0,0-.08l-.17-.09a.29.29,0,0,1-.11.11l-.29.17a.64.64,0,0,1-.28.07.45.45,0,0,1-.27-.05l-.13-.07c-.07-.05-.1-.1-.09-.16a.24.24,0,0,1,.13-.16l.3-.17a.61.61,0,0,1,.28-.08.5.5,0,0,1,.26.06l.51.29a.17.17,0,0,1,.1.15A.28.28,0,0,1,271.61,299.58Zm-.61-.53a.29.29,0,0,0-.14,0l-.14,0-.29.17a.17.17,0,0,0-.07.08.08.08,0,0,0,.05.08l.13.07a.25.25,0,0,0,.13,0,.23.23,0,0,0,.14,0l.29-.17s.07,0,.07-.08a.08.08,0,0,0-.05-.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.71,298.94l-.44.26-.07,0-.06,0s0,0,0,0a.05.05,0,0,1,0,0l.15-.08-.63-.37a.29.29,0,0,0-.14,0l-.14,0h0l-.07,0h-.06s0,0,0,0,0,0,0,0h0a.61.61,0,0,1,.28-.08.53.53,0,0,1,.26.06l.64.36.15-.08.07,0h.06a.05.05,0,0,1,0,0A.08.08,0,0,1,272.71,298.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.67,298.39l-.3.17a.61.61,0,0,1-.28.08.5.5,0,0,1-.26-.06l-.51-.29a.17.17,0,0,1-.1-.15.25.25,0,0,1,.14-.17l.29-.17a.64.64,0,0,1,.28-.07.45.45,0,0,1,.27,0l.51.29a.16.16,0,0,1,.09.16A.24.24,0,0,1,273.67,298.39Zm-.42.1.29-.17s0,0,0-.05l-1.11-.06.49.29a.21.21,0,0,0,.14,0A.32.32,0,0,0,273.25,298.49Zm-.47-.61-.3.17a.12.12,0,0,0-.05.05l1.12,0-.5-.28a.18.18,0,0,0-.13,0A.21.21,0,0,0,272.78,297.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.77,297.76l-.44.25-.07,0h-.07s0,0,0,0,0,0,0,0l.15-.09-.64-.37a.25.25,0,0,0-.13,0,.32.32,0,0,0-.14,0h0l-.07,0-.07,0s0,0,0,0a.05.05,0,0,1,0,0h0a.61.61,0,0,1,.28-.07.45.45,0,0,1,.27,0l.63.37.15-.09.07,0,.07,0,0,0S274.79,297.74,274.77,297.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.82,296.57l-.44.25-.07,0h-.06s0,0,0,0,0,0,0,0l.15-.09-.63-.36a.29.29,0,0,0-.14,0,.33.33,0,0,0-.14,0h0l-.07,0h-.06a.05.05,0,0,1,0,0s0,0,0,0h0a.57.57,0,0,1,.29-.08.44.44,0,0,1,.26,0l.64.37.14-.08a.12.12,0,0,1,.08,0h.06s0,0,0,0A.05.05,0,0,1,276.82,296.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,295.8l-.3.17a.09.09,0,0,0-.06.08s0,.05,0,.07l.1.06h.07l.62-.36a.08.08,0,0,1,.07,0H278s0,0,0,0a.05.05,0,0,1,0,0l-.74.42a.08.08,0,0,1-.07,0h-.06l-.19-.11c-.07,0-.11-.09-.1-.15a.23.23,0,0,1,.14-.17l.29-.17a.13.13,0,0,0,.07-.08s0-.05,0-.07l-.13-.08a.25.25,0,0,0-.13,0l-.14,0-.3.17s-.06.05-.06.08,0,.06,0,.08,0,0,0,0,0,0,0,0l-.07,0h-.06a.18.18,0,0,1-.1-.16c0-.06.06-.11.14-.16l.29-.17a.65.65,0,0,1,.28-.08.54.54,0,0,1,.27.06l.13.07a.14.14,0,0,1,.09.15A.24.24,0,0,1,277.4,295.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88,295.38l-.44.26-.07,0-.07,0s0,0,0,0a.05.05,0,0,1,0,0l.15-.08-.64-.37a.25.25,0,0,0-.13,0l-.14,0h0a.1.1,0,0,1-.07,0h-.07s0,0,0,0a.05.05,0,0,1,0,0h0a.61.61,0,0,1,.28-.08.54.54,0,0,1,.27.06l.63.36.15-.08.07,0h.07l0,0S278.9,295.37,278.88,295.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.81,294.48l.06,0c.07.05.1.1.09.16s0,.11-.13.16l-.29.17a.65.65,0,0,1-.28.08A.54.54,0,0,1,279,295s0,0,0,0,0,0,0-.05h.07a.08.08,0,0,1,.07,0,.25.25,0,0,0,.13,0l.14,0,.29-.17c.05,0,.07-.05.07-.08a.08.08,0,0,0,0-.08l-.06,0a.18.18,0,0,0-.13,0,.29.29,0,0,0-.14,0l-.08.05-.07,0-.06,0s0,0,0,0l0,0,.07,0a.13.13,0,0,0,.07-.08.1.1,0,0,0-.05-.08l-.06,0a.29.29,0,0,0-.14,0,.23.23,0,0,0-.14,0l-.29.17a.13.13,0,0,0-.07.08s0,.05.05.08,0,0,0,0,0,0,0,0a.1.1,0,0,1-.07,0h-.07a.14.14,0,0,1-.09-.15.24.24,0,0,1,.13-.17l.29-.17a.69.69,0,0,1,.29-.07.44.44,0,0,1,.26.05l.07,0a.16.16,0,0,1,.07.07.16.16,0,0,1,0,.1h.15A.46.46,0,0,1,279.81,294.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.32,301.61l-.45.26-.07,0a.08.08,0,0,1-.07,0s0,0,0,0,0,0,0,0l.15-.08-.64-.37a.29.29,0,0,0-.14,0,.23.23,0,0,0-.14,0h0l-.07,0-.07,0s0,0,0,0l0,0h0a.65.65,0,0,1,.29-.07.45.45,0,0,1,.27.05l.64.37.15-.08a.08.08,0,0,1,.07,0h.07s0,0,0,0S273.34,301.6,273.32,301.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,300.83l-.3.17a.09.09,0,0,0-.06.08.07.07,0,0,0,0,.08l.1.06h.07l.63-.36.08,0h.06s0,0,0,0l0,0-.74.43-.07,0h-.07l-.2-.11a.16.16,0,0,1-.09-.16.22.22,0,0,1,.13-.16l.3-.18s.07-.05.07-.08a.08.08,0,0,0,0-.08l-.13-.07a.25.25,0,0,0-.13,0,.33.33,0,0,0-.14,0l-.3.17s-.07.05-.07.08a.07.07,0,0,0,.05.08,0,0,0,0,1,0,0s0,0,0,0l-.07,0h-.07a.17.17,0,0,1-.1-.16c0-.06.06-.11.14-.16l.3-.17a.54.54,0,0,1,.28-.08.45.45,0,0,1,.27.05l.13.08c.07,0,.11.09.1.15A.28.28,0,0,1,273.9,300.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.69,299.8l-.3.17a.13.13,0,0,0-.07.08.08.08,0,0,0,.05.08l.1.05h.07l.63-.36a.08.08,0,0,1,.07,0h.07s0,0,0,0a.05.05,0,0,1,0,0l-.75.43-.07,0h-.06l-.2-.12a.14.14,0,0,1-.09-.15c0-.06.05-.12.13-.17l.3-.17a.13.13,0,0,0,.07-.08.08.08,0,0,0-.05-.08l-.13-.07a.25.25,0,0,0-.13,0,.24.24,0,0,0-.15,0l-.3.17a.09.09,0,0,0-.06.08.07.07,0,0,0,0,.08s0,0,0,0,0,0,0,0l-.08,0h-.06a.15.15,0,0,1-.1-.16.22.22,0,0,1,.14-.16l.29-.18a.69.69,0,0,1,.29-.07.45.45,0,0,1,.27,0l.13.07c.07,0,.1.1.09.16S275.77,299.75,275.69,299.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.24,299l.07,0a.15.15,0,0,1,.09.16.24.24,0,0,1-.13.16l-.3.17a.55.55,0,0,1-.29.08.45.45,0,0,1-.27-.05.08.08,0,0,1,0,0s0,0,0,0l.07,0h.07a.29.29,0,0,0,.14,0,.33.33,0,0,0,.14,0l.3-.17s.06-.05.06-.09,0-.05,0-.07l-.07,0a.25.25,0,0,0-.13,0,.37.37,0,0,0-.15,0l-.07,0a.08.08,0,0,1-.07,0,.08.08,0,0,1-.07,0s0,0,0,0a.05.05,0,0,1,0,0l.08,0s.06-.05.06-.09,0-.05,0-.07l-.07,0a.25.25,0,0,0-.13,0,.33.33,0,0,0-.15,0l-.29.17c-.05,0-.07,0-.07.09s0,.05.05.07l0,0s0,0,0,0a.12.12,0,0,1-.08,0h-.06c-.07,0-.11-.09-.1-.16s.05-.11.14-.16l.29-.17a.57.57,0,0,1,.29-.08.45.45,0,0,1,.27,0l.07,0a.18.18,0,0,1,.07.08.15.15,0,0,1,0,.09h.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,300.77h0a.21.21,0,0,1-.12,0L274,300s0,0,.05,0,.09,0,.11,0l.93.75S275.12,300.76,275.09,300.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.41,300.8l2.72,1.57c.2.11.2.3,0,.42l-3.28,1.92a.85.85,0,0,1-.73,0l-2.72-1.57c-.21-.12-.21-.31,0-.43l3.27-1.91A.81.81,0,0,1,257.41,300.8Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.41,300.8l2.72,1.57c.2.11.2.3,0,.42l-3.28,1.92a.85.85,0,0,1-.73,0l-2.72-1.57c-.21-.12-.21-.31,0-.43l3.27-1.91A.81.81,0,0,1,257.41,300.8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.38,301.94l-1.29.75-1.22-.7,1.29-.76-.16-.09-4,2.33.17.1,1.29-.75,1.22.7-1.29.75.16.1,4-2.34Zm-1.46.85-1.09.64-1.23-.71,1.1-.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.83,295.79l-3.09,1.79c-.23.13-.23.34,0,.47l.05,0a.91.91,0,0,0,.82,0l3.09-1.79c.23-.13.23-.34,0-.47l-.05,0A.91.91,0,0,0,281.83,295.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,311.41l-.33.2-.33.18a2,2,0,0,1-.69.17,2.12,2.12,0,0,1-.71-.06,1.35,1.35,0,0,1-.34-.11l-.32-.18-3.69-2.11-10-5.55,13.76,7.95a2.24,2.24,0,0,0,1.08.26h.15a2.26,2.26,0,0,0,.93-.25l.45-.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.26,312.16a2.24,2.24,0,0,1-1.08-.26l-4-2.3h0l4,2.3A2.24,2.24,0,0,0,261.26,312.16Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93,306.94l-8.59,5a1.93,1.93,0,0,1-.51.19,1.93,1.93,0,0,0,.51-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.14,297.58l-5.38,3-5.44,3.07c-3.62,2.05-7.22,4.14-10.84,6.21l-2.7,1.56v.23l8.14-4.7Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.82,391.48l11-63.32,6.94-.36-14.43,63.67h0a.93.93,0,0,1-.47.62,2.73,2.73,0,0,1-2.47.13.83.83,0,0,1-.54-.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.09,317.76h7l16.34,65.77h0a.85.85,0,0,1-.51.76,2.71,2.71,0,0,1-2.48,0,.91.91,0,0,1-.49-.59h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,421.66l.31-70.92,6.94-.36-3.75,71.27h0a.92.92,0,0,1-.46.62,2.75,2.75,0,0,1-2.48.12.83.83,0,0,1-.54-.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.13,295.69h7l11.13,69.88h0a.84.84,0,0,1-.51.77,2.75,2.75,0,0,1-2.47,0,1,1,0,0,1-.5-.6h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.1,241a38.84,38.84,0,0,1,2.78,12.2c.79,9.36-2.37,39.67-4.28,53.22h0c-2.75,22.65-6.13,22.69-11,26.48-8.44,6.52-32.71,19.3-40.73,22.45-14.52,5.72-26.4-3.1-35.26-7.47a207.92,207.92,0,0,1-23.45-13.89c-2.21-1.61-3.36-3.24-3.34-5,0-.67,0-3.46,0-4.17,0-2.19,1.92-4.53,6-7.17,7.5-4.87,34.62-20.68,45.13-26.5A.12.12,0,0,1,391,291c8.08-4.91,12.95-38.27,18.55-56,.12-.38.23-.75.36-1.1s.2-.56.29-.83c.35-1,.72-1.85,1.1-2.66",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,324.8c0-2.19,1.92-4.53,6-7.17,7.5-4.87,34.62-20.68,45.13-26.5A.12.12,0,0,1,391,291c8.08-4.91,12.95-38.27,18.55-56a31.23,31.23,0,0,1,1.17-3.27c0-.08.07-.16.1-.23.1-.24.21-.48.32-.73s.11-.24.16-.36h0a16.78,16.78,0,0,1,3.74-5.39,7.82,7.82,0,0,1,1.83-1.29c.91-.52,2.82-1.58,3.29-1.86,5.5-3.28,12.7.66,21.68,5.58,5.58,3.06,10.34,6.7,13.24,13.48h0a38.84,38.84,0,0,1,2.78,12.2c.79,9.36-2.37,39.67-4.28,53.22h0c-2.75,22.65-6.13,22.69-11,26.48-8.44,6.52-32.71,19.3-40.73,22.45-14.52,5.72-26.4-3.1-35.26-7.47a207.92,207.92,0,0,1-23.45-13.89c-2.21-1.61-3.36-3.24-3.34-5C339.81,328.3,339.8,325.51,339.8,324.8Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,324.8c0-2.19,1.92-4.53,6-7.17,7.5-4.87,34.62-20.68,45.13-26.5A.12.12,0,0,1,391,291c8.08-4.91,12.95-38.27,18.55-56a31.23,31.23,0,0,1,1.17-3.27c0-.08.07-.16.1-.23.1-.24.21-.48.32-.73s.11-.24.16-.36h0a16.78,16.78,0,0,1,3.74-5.39,7.82,7.82,0,0,1,1.83-1.29c.91-.52,2.82-1.58,3.29-1.86,5.5-3.28,12.7.66,21.68,5.58,5.58,3.06,10.34,6.7,13.24,13.48h0a38.84,38.84,0,0,1,2.78,12.2c.79,9.36-2.37,39.67-4.28,53.22h0c-2.75,22.65-6.13,22.69-11,26.48-8.44,6.52-32.71,19.3-40.73,22.45-14.52,5.72-26.4-3.1-35.26-7.47a207.92,207.92,0,0,1-23.45-13.89c-2.21-1.61-3.36-3.24-3.34-5C339.81,328.3,339.8,325.51,339.8,324.8Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,343.61a205.6,205.6,0,0,1-23.46-13.9c-5-3.65-4.57-7.39,2.65-12.08,10-6.5,50.9-29.69,50.9-29.69s51.67,30.49,49.45,36.12-34.21,23.05-44.29,27C387.32,356.79,375.45,348,366.6,343.61Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.6,343.61a205.6,205.6,0,0,1-23.46-13.9c-5-3.65-4.57-7.39,2.65-12.08,10-6.5,50.9-29.69,50.9-29.69s51.67,30.49,49.45,36.12-34.21,23.05-44.29,27C387.32,356.79,375.45,348,366.6,343.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,223.75c5.44-2.86,12.51,1,21.25,5.82,5.6,3.07,10.37,6.7,13.27,13.51L455.1,241c-2.9-6.78-7.66-10.42-13.24-13.48-9-4.92-16.18-8.86-21.68-5.58C419.71,222.17,417.8,223.23,416.89,223.75Z",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,223.75c5.44-2.86,12.51,1,21.25,5.82,5.6,3.07,10.37,6.7,13.27,13.51L455.1,241c-2.9-6.78-7.66-10.42-13.24-13.48-9-4.92-16.18-8.86-21.68-5.58C419.71,222.17,417.8,223.23,416.89,223.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,291s5.27,1.73,24.06,11c7.72,3.78,12.79,7.6,20,12.15,10.63,6.69,9.82,11.66,9.82,11.66,5.29-4.38,10.56-55.19,9.26-70.57a38.51,38.51,0,0,0-3-12.79c-.14-.3-.28-.6-.43-.9l-.32-.61c0-.09-.1-.18-.15-.28-.42-.75-.87-1.46-1.34-2.14-.12-.17-.24-.34-.36-.49s-.24-.33-.37-.49-.25-.32-.37-.47-.21-.25-.32-.38a22.52,22.52,0,0,0-1.92-2c-.16-.17-.33-.32-.5-.47a32.38,32.38,0,0,0-3.37-2.55q-.27-.19-.54-.36l-.74-.46c-.2-.13-.41-.25-.62-.37-.54-.32-1.09-.64-1.65-.94-6.69-3.66-12.39-6.8-17.14-6.8a8.8,8.8,0,0,0-5.94,2.27c-3.51,3.09-5.38,9.6-5.5,10C404,252.77,399.09,286.13,391,291Z",
    style: {
      fill: "#800080"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.75,361s6.74,14.42,7.56,20.2c.86,6,2.53,7.91,2.06,14.58-.11,1.45-.62,4.38-.71,5.56a1.74,1.74,0,0,0,1.77,2c2.73.33,6.75-4.95,8.39-10.48a155.34,155.34,0,0,0,3.65-19.33,8.15,8.15,0,0,0-1.22-4.16,12.88,12.88,0,0,0-1.42-2.1c-1.12-2.56-2-7.54-3-10.94Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.19,378.7a6.19,6.19,0,0,1,.9,1.92c.17,1.21-2.27,5.4-3.23,6.93a9.56,9.56,0,0,0-1.41,7c.5,3.85-.91,7.71-3.18,11.09a26.86,26.86,0,0,1-12.71,9.69c-6.33,2.47-8.91-.55-8.91-.55s-2.28-2.91-1.18-4.27S382.19,378.7,382.19,378.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.83,367.33c.19,0,.54-.11,1.1.46.21.21,1.65,3,2.77,4.41s3.95,4.08,4.49,6.5c-1.09,4.84-5.32,8.48-5.61,13s.09,9.7-6.43,15.7-13.66,7.13-16.37,5.89-2.72-4,.43-9.43c3.35-5.78,4.88-17.87,4.88-17.87a37.86,37.86,0,0,0,.24-5.11,32.79,32.79,0,0,0-.93-5,3.64,3.64,0,0,1,.13-2.29,3.86,3.86,0,0,1,1.81-1.46,17.22,17.22,0,0,1,3.49-1.47,5.83,5.83,0,0,1,3.74.15c.85.36,1.57,1,2.44,1.26a3.37,3.37,0,0,0,3.39-.87,2.73,2.73,0,0,0,.65-3.16A5.33,5.33,0,0,0,373.83,367.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.86,402.7s-3.19-5.19-10.61-4.58-9.68,4.51-10.62,6.78c-1.11,2.69-2.1,7.5,1.08,8.61,3.44,1.2,7.24.45,13-3S373.86,402.7,373.86,402.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.58,380.88a.77.77,0,0,1-.68.05c-1.2-.48-7.38-1.25-10.63,2.24-.49-.33-.45-1,.05-2,3.91-2.9,9.76-2.2,11.21-1.62a.7.7,0,0,1,.37,1A.75.75,0,0,1,370.58,380.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.88,387.47a2.22,2.22,0,0,1,.25-2c3.89-2.49,9.33-1.82,10.71-1.27a.7.7,0,0,1,.38.95.76.76,0,0,1-.32.34.77.77,0,0,1-.68.05C368.06,385,362.19,384.32,358.88,387.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.71,397.54a4.07,4.07,0,0,1,.72-2.71c3.91-2.76,9.62-2.07,11.05-1.49a.69.69,0,0,1,.37.94.71.71,0,0,1-.32.34.74.74,0,0,1-.68.05C366.59,394.16,359.78,393.34,356.71,397.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,390a.78.78,0,0,1-.68,0c-1.19-.47-7.24-1.22-10.52,2.13a2.51,2.51,0,0,1,.43-2.2c3.89-2.49,9.33-1.82,10.71-1.26a.68.68,0,0,1,.37.94A.74.74,0,0,1,369.22,390Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.82,375.39s-1.33,15-3.05,25.53c-1.25,7.64-7.41,10.5-12.75,15.07-1.16,1-3.74,2.78-4.69,3.58a1.78,1.78,0,0,0-.19,2.78c1.79,2.23,10.44,4,15.81,1.08s10.86-9.87,14.17-12.34a45.27,45.27,0,0,0,3.56-2.92c1.1-1,1-2.11,1.25-3.37.12-.61.86-3.68.86-3.68,1.07-2.91,3.86-10.39,5.1-13.75Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.65,415.45a6.23,6.23,0,0,1-.43,2.11c-.59,1.1-5.17,3.12-6.91,3.82a9.85,9.85,0,0,0-5.45,5c-1.93,3.47-5.46,5.82-9.41,7.27a28.2,28.2,0,0,1-16.5.49c-6.78-1.71-6.43-5.72-6.43-5.72s0-3.77,1.72-4.24S366.65,415.45,366.65,415.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,401.12c.17.09.31.23.44,1,0,.3-.44,3.44-.38,5.28s.81,5.7-.2,8c-3.86,3.35-9.61,3.85-12.6,7.41s-5.82,8.05-14.91,9.16-15.08-1.61-16.58-4.24,1-4.92,5.95-7.93c5.91-3.57,14.43-12,14.43-12.05a29.84,29.84,0,0,0,2.07-2.43,9.7,9.7,0,0,0,1.8-5.44c.05-.88.23-1.62,1.16-1.94a3.81,3.81,0,0,1,1.39-.14,20,20,0,0,1,6.21,1.22,20.92,20.92,0,0,1,2.84,1.32c.72.4,1.78.85,2.12,1.64a2.12,2.12,0,0,1,.06,1.12,23.14,23.14,0,0,1-.8,3.58.73.73,0,0,0,0,.52c.28.6,2.28-1.8,2.55-2.09a4.6,4.6,0,0,1,2.2-1.46,2.37,2.37,0,0,0,1.77-1.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,430.33s.51-6.16-6.06-10.05-9.55-1.49-11.71-.18c-2.58,1.57-7.06,4.8-5.07,7.6,2.14,3,5.22,4.3,12.12,4.88S345.08,430.33,345.08,430.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63,410.39a.83.83,0,0,1-.6-.36c-.7-1.11-5.39-5.4-10.23-4.44-.21-.56.22-1.09,1.24-1.59,5-.08,9.48,3.95,10.33,5.29a.7.7,0,0,1-.27,1A.85.85,0,0,1,355.63,410.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,408.91a2.27,2.27,0,0,1,1.45-1.53c4.76.24,8.88,4,9.7,5.29a.71.71,0,0,1-.26,1,.81.81,0,0,1-.48.09.77.77,0,0,1-.59-.36C351,412.33,346.54,408.27,341.86,408.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.92,415.94a4.24,4.24,0,0,1,2.25-1.81c4.94,0,9.28,4,10.12,5.29a.7.7,0,0,1-.26,1,.83.83,0,0,1-1.07-.27C344.21,419,339,414.28,333.92,415.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.91,417.14a.78.78,0,0,1-.59-.36c-.7-1.09-5.29-5.29-10.07-4.46a2.57,2.57,0,0,1,1.7-1.56c4.76.24,8.89,4,9.7,5.29a.69.69,0,0,1-.26,1A.81.81,0,0,1,348.91,417.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.9,281.29s-28.15,15.14-41.51,29c-4.78,5-7.75,9.33-2.69,22.18,3.89,9.88,9.85,23.25,16.06,36l59.73-72.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.76,368.55l37.89-60.35-1.31-.21c-7.16-3.1-10.12-12.77-10.12-12.77-.85,3.87.75,9.37,3.15,12.32-4,3-13.11,9.7-27.09,20.23-2.43,1.84-7,5.3-7,12.12,0,9.65.41,20.09.41,20.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.86,281.29h0l58.43,8.59c0,7-2,18.65-7.22,26.56-3.82,5.74-8.05,9.24-22.94,17.12-13.87,7.35-26.28,13.48-29.45,15.2-2.4,1.3-2.34,7.72-3.57,14C377.6,375.39,370,394.35,370,394.35s-10.77,2.38-19.86-4.79c0,0,2.31-28.41,3.45-37.78,1.37-11.23,1.28-14,6.84-19.49,4.77-4.69,32.93-24.3,32.93-24.3S379.91,294.37,384.86,281.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.6,288.75c-.29,9.61-1.59,16.9-8.49,24-4.42-3-3.52-5.72-1.89-10.66.49-1.49,1-3.18,1.52-5.08a50.07,50.07,0,0,0,1.48-9.35l-.23,0-.58-.09a48.63,48.63,0,0,1-1.46,9.27c-.46,1.88-1,3.55-1.5,5-1.63,4.93-2.7,8.23,2.08,11.5a47,47,0,0,1-5.6,4.66c-10.31,7.39-24.86,16.07-33.55,21.26-3,1.82-5.44,3.25-6.68,4-5,3.23-5.46,6-5.54,14.49-.11,10.62-6.38,26.29-9.45,36.94h.83c3.14-10.84,9.58-26.74,9.43-36.95-.13-8.58.64-10.89,5.17-13.79,1.23-.78,3.62-2.21,6.65-4,8.71-5.2,23.28-13.89,33.61-21.31,12.66-9.07,14.64-17.6,15-29.77Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.55,269.73c3.64,2.43,13.47,0,18.61-5s22.08-23.5,22.08-23.5l2.07-29.63s-6.57-1-11.43,3.11-19.11,25.61-23,31.55S357.55,269.73,357.55,269.73Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.82,210.6c-5.56-.71-14.22-1.59-19.79,7.18s-11.71,22.48-11.71,22.48a19,19,0,0,0,4.38,11.64c4.69,5.9,8.71,7.18,8.71,7.18L398.7,241.8Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.12,251.41c.06,1.18.07,2.44.06,3.74,0-1.3,0-2.56-.06-3.74.05,1.34.05,2.79,0,4.29v-.28c0-.77,0-1.53,0-2.29,0-.13,0-.27,0-.4,0-.44,0-.88,0-1.32s-.05-1-.07-1.45v-.13c0-.41,0-.81-.07-1.22,0-.11,0-.22,0-.33a1.62,1.62,0,0,1,0-.22c0-.15,0-.3,0-.44-.13-2-.31-3.92-.58-5.77-.84-7.93-2.13-17.12-9.19-22-5.6-2.43-8.51-3.42-17.29-6.05-5.86-1.76-12-2.25-18-3.18a16.22,16.22,0,0,0-9.67,3.58c-8,7-9.25,18.55-9.49,28.55l-.64,20.4c-.38,6.69.12,13.72-2.77,19.91-.05.21-.18.42,0,.69,0,.14-.06.26-.06.26,2.68,6.07,8.17,10.75,13.91,13.89,11.47,6.44,38,11.34,50.27,6.48,1.71-8.67,1.92-17.68,2.57-26.49C445.37,270.11,446.54,259.08,446.12,251.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.76,211.63c1.55.24,3.12.45,4.65.66a86.43,86.43,0,0,1,13.14,2.47c8.95,2.68,11.7,3.64,17.08,6,6.41,4.51,7.81,13,8.69,21.27.23,1.62.42,3.43.57,5.71l0,.2c0,.07,0,.14,0,.22v.22a2.35,2.35,0,0,1,0,.26v0l.06,1.22V250l0,.52c0,.31,0,.61,0,.91s0,.58,0,.88v.82c0,.76,0,1.51,0,2.27v.28a1,1,0,0,0,.06.34c-.05,4.6-.43,9.83-.77,14.59-.19,2.57-.36,5-.47,7.17s-.29,4.18-.42,6.22a157.09,157.09,0,0,1-2,19.59,37,37,0,0,1-12.27,1.7c-12.22,0-28.29-3.66-36.61-8.33-6.29-3.43-11-8.07-13.32-13.08a.92.92,0,0,0-.06-.52c2.34-5.07,2.5-10.63,2.66-16,0-1.37.08-2.79.16-4.19l.64-20.42c.24-10,1.51-21.15,9.12-27.78a15.12,15.12,0,0,1,8.95-3.34m.06-1a16.22,16.22,0,0,0-9.67,3.58c-8,7-9.25,18.55-9.49,28.55l-.64,20.4c-.38,6.69.12,13.72-2.77,19.91-.05.21-.18.42,0,.69,0,.14-.06.26-.06.26,2.68,6.07,8.17,10.75,13.91,13.89,8.23,4.62,24.19,8.45,37.1,8.45a37.22,37.22,0,0,0,13.17-2c1.71-8.67,1.92-17.68,2.57-26.49.41-7.76,1.58-18.79,1.16-26.46.06,1.18.07,2.44.07,3.74,0-1.3,0-2.56-.07-3.74.05,1.34.05,2.79,0,4.29v-.28c0-.77,0-1.53,0-2.29,0-.13,0-.27,0-.4,0-.44,0-.88,0-1.32s-.05-1-.07-1.45v-.13c0-.41,0-.81-.07-1.22,0-.11,0-.22,0-.33a1.62,1.62,0,0,1,0-.22c0-.15,0-.3,0-.44-.13-2-.31-3.92-.58-5.77-.84-7.93-2.13-17.12-9.19-22-5.6-2.43-8.51-3.42-17.29-6.05-5.86-1.76-12-2.25-18-3.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.06,206.84c1.15-4.57,6.13-9,8.52-12.91s3.73-6.65,3.79-10.33c0-2.17-1.1-5.22-2.66-6a10.08,10.08,0,0,0-6.41-13.12,33.65,33.65,0,0,1-4.34-1.59c-1.69-.86-2-2.3-3.28-3.6-2.26-2.25-6.34-2.61-8.13.38-1.45-2.21-3.64-2.33-6.22-1.88a4.32,4.32,0,0,0-3.68,4.61c-3.23-2.15-6.51,0-7,1.95-.34,1.45-.13,2.7-1.19,3.94-1.19,1.4-3.23,1.21-3.75,0-.52,2,.17,3.7,2.44,3.76a4.71,4.71,0,0,0-.9,3.92,4.31,4.31,0,0,0,3.66,3.28,6.61,6.61,0,0,0,3.23,5.85c3.29,1.9,7,2.72,10.64,3.77l4.3,1.25c.25.07,1.56.25,1.7.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.14,201.29c-3.41,1.69-6-1.77-6-1.77l1.36,15.53c-3.24,5.64-12.91,12.13-19.56,10-4.28-1.37-2-7.37-.05-10l-.78-5.17a46,46,0,0,1-5.48-.68c-3.59-.78-6.09-3.94-6.82-7.94a40.94,40.94,0,0,1,.78-15.61,13.89,13.89,0,0,0,.49-3.79c-.09-3.4.67-5.32,1.77-8.08,4.24-2.91,13.56-3.28,21.76,2.62-1.4,5,.28,9.26,3.85,11.51-.28,1.37-.73,4.85,1.55,5,1.64.08,1.91-2,3.73-3.64s5.79-1.86,7.1.93C432.71,194.06,430.86,199.44,427.14,201.29Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.87,184.84l10.67,3.84a4.42,4.42,0,0,0-1.72,1.63l-9.33-2.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.05,180.77a3,3,0,0,0,.29,1.71,1.35,1.35,0,0,1,.13.61,30.61,30.61,0,0,0-.09,4.52,4.4,4.4,0,0,0,3.75,3.95,5.87,5.87,0,0,0,1.57.14h.12a4.51,4.51,0,0,0,1.37-.3l.08,0,.12-.05.16-.08.15-.07.16-.1.15-.1a1.61,1.61,0,0,0,.3-.21,6.49,6.49,0,0,0,1.37-1.5c1-1.41,1.29-3.57,2.39-3.63h.13l.14,0c1.43.28.78,2.57,1.23,4.39a5.34,5.34,0,0,0,4.61,4.35l.41.08.33,0a5.31,5.31,0,0,0,.79,0H408l.24,0,.15,0a4.15,4.15,0,0,0,.94-.28l.33-.15a4.38,4.38,0,0,0,.58-.37,5.6,5.6,0,0,0,1.25-1.4,29.43,29.43,0,0,0,1.67-4.21,1.94,1.94,0,0,1,.36-.58,3.16,3.16,0,0,0,1-1.42,1.36,1.36,0,0,0-.61-1.51l-.74-.24a22.57,22.57,0,0,0-7.53-1.27c-2.53.25-3.52.9-4.85.64s-1.87-1.23-4-2.41a19.56,19.56,0,0,0-6.94-1.64l-.71,0C388.73,179.55,388.17,180.09,388.05,180.77Zm15.36,4.41a2.11,2.11,0,0,1,.8-.46l.14-.05.07,0,.37-.11.34-.07a9,9,0,0,1,1.09-.15c.14,0,.28,0,.43,0a7.79,7.79,0,0,1,1.08,0l.25,0c2.34.22,3.66,1,4.09,1.64s-.22,2.82-.66,3.93l0,.08,0,.08a4,4,0,0,1-.19.45l-.13.28h0l-.25.46h0l-.1.15a.24.24,0,0,1-.06.09l-.07.11a.94.94,0,0,1-.09.12l-.1.14-.13.15-.13.15a3.74,3.74,0,0,1-3.59,1.05,4.38,4.38,0,0,1-3.18-2h0a5.22,5.22,0,0,1-.64-2.54C402.66,187.3,402.81,185.79,403.41,185.18Zm-13.28-3.63a2.35,2.35,0,0,1,.65-.27h.05l.28-.05.16,0h.39a5.14,5.14,0,0,1,.55,0l.29,0,.18,0,.13,0,.37.06.13,0,.13,0a10.41,10.41,0,0,1,1,.3c1.58.54,3.11,1.64,3.4,2.43s-.13,2.24-.63,3.47a6.1,6.1,0,0,1-.4.82.43.43,0,0,0,0,.07l-.05.08,0,.05a.61.61,0,0,1-.07.1,1.27,1.27,0,0,1-.13.19l-.13.17-.05.06-.09.11-.09.09s0,0,0,0a4.29,4.29,0,0,1-5.5.28c-1.45-1.19-1.4-3.22-1.37-4.15C389.31,184.24,389.53,182,390.13,181.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.39,188.71l-2.3,7.57L393.85,193c.25-.32.53-.63.78-1s.33-.42.5-.62l.66-.83c.7-.85,1.4-1.68,2.06-2.4.22-.25.5-.55.8-.86.58-.61,1.27-1.28,1.73-1.67C401.44,185.9,401.31,187.28,401.39,188.71Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.06,199.57a1.1,1.1,0,1,0,2.18.33,1.1,1.1,0,0,0-2.18-.33Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.15,209.88c5.7.18,10.23-.52,13.55-4.45a35.81,35.81,0,0,0,4-6.55,28,28,0,0,1-3.13,8.35c-1.66,2.55-5,4.78-14.09,4.85Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,188.16a1.63,1.63,0,1,0,1.83-1.48A1.66,1.66,0,0,0,404.21,188.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,180.26l3.35,2.13a2.08,2.08,0,0,0-.64-2.81A1.94,1.94,0,0,0,406,180.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.63,179.3l3.85-1.07a1.92,1.92,0,0,0-2.4-1.42A2.09,2.09,0,0,0,393.63,179.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,185.92a1.62,1.62,0,1,0,1.69-1.63A1.66,1.66,0,0,0,392.62,185.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.73,305.3v.77a3.18,3.18,0,0,0,1.57,2.77l55.47,32.4a3.11,3.11,0,0,0,1.58.43,3.17,3.17,0,0,0,1.61-.41L421.37,324a3.16,3.16,0,0,0,1.6-2.74v-1.07h0a.41.41,0,0,1-.2.35l-33.4,19.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,339.56v2.12a3.23,3.23,0,0,1-1.59-.44l-55.47-32.4a3.21,3.21,0,0,1-1.58-2.77v-.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,320.4a.34.34,0,0,0,.15-.26.31.31,0,0,0-.15-.26l-57.06-33.34a1.75,1.75,0,0,0-.95-.24,1.8,1.8,0,0,0-.82.23L331,305.3l58.39,34.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.71,286.42a1.56,1.56,0,0,1,.87.23L422.65,320a.19.19,0,0,1,.08.15.18.18,0,0,1-.09.15l-33.27,19-58.15-34,32.72-18.66a1.72,1.72,0,0,1,.77-.22m0-.25a2.06,2.06,0,0,0-.89.25L330.73,305.3l58.64,34.26,33.4-19.05a.42.42,0,0,0,0-.73l-57.06-33.35a1.91,1.91,0,0,0-1-.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.69 336.76 407.53 326.59 355.66 296.28 337.72 306.4 389.69 336.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.72 306.4 338.4 306.79 355.66 297.06 406.85 326.98 407.53 326.59 355.66 296.28 337.72 306.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.72 306.4 338.4 306.79 355.66 297.06 406.85 326.98 407.53 326.59 355.66 296.28 337.72 306.4",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.58 308.26 398.25 308.45 389.5 313.44 374.04 304.4 373.72 304.22 382.8 299.04 398.58 308.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.58 308.26 398.25 308.45 389.5 313.44 374.04 304.4 373.72 304.22 382.8 299.04 398.58 308.26",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.25 308.45 389.5 313.44 374.04 304.4 382.79 299.41 398.25 308.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.1,275c-3.42-13.53-6.71-26.48-10-36.71-1.84-5.64-2.75-13.34-14.81-17.35-7.47,5.77-4.65,21.59-3.41,25.56l7.93,31s-2.14,2.64-9.28,9.66c-6.07,6-9,8.15-16,9.25s-7.59.64-11.18,2.37c-1.91.91-6.26,3-7.74,3.86s-4.08,3.66-6.52,5.6c-2.28,2,.7,2.89,2.51,2.29A23.07,23.07,0,0,0,398,307.7a33.12,33.12,0,0,1,4.65-2,28.13,28.13,0,0,0-.79,5.54c0,1-.14,2.23.76,2.94a7.74,7.74,0,0,0,2.14.78,1.55,1.55,0,0,0,.45,1,2.54,2.54,0,0,0,1.81.39,7.91,7.91,0,0,0,1-.19,1.86,1.86,0,0,0,1.19,1.41,8.09,8.09,0,0,0,4.29,0c.21-.09,1.77-1,2.23-1.28.67-.38,1.26-.6,1.54-1.05s-.69-1.71-1.52-1.81a8.59,8.59,0,0,0-2.73.28,9.3,9.3,0,0,0,.71-2.37c.7-1.23,6.11-.22,10.85-1.23,3.58-.76,6.13-4.12,7.64-5.07,9.19-5.8,11.55-7.13,21.26-14.57C462.61,283.42,462.93,282.29,461.1,275Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.71,306.08l.92-.36a12.48,12.48,0,0,1,1.39-3.09C403,303.05,402.21,304.7,401.71,306.08Zm3.79.08a13,13,0,0,0-.7,2.91,29.13,29.13,0,0,0-.27,2.95,11.27,11.27,0,0,0,.21,3,25.91,25.91,0,0,1,.23-2.92c.13-1,.25-1.94.4-2.91a20.08,20.08,0,0,1,.54-2.84,8.25,8.25,0,0,1,.51-1.36,4.35,4.35,0,0,1,.76-1.23A5.43,5.43,0,0,0,405.5,306.16Zm2.73,4.17a23.4,23.4,0,0,0-.33,2.9,14.15,14.15,0,0,0,.11,2.91c.16-1.93.45-3.82.78-5.71.15-.95.34-1.89.55-2.82q.15-.71.36-1.38a3.65,3.65,0,0,1,.61-1.29,5.67,5.67,0,0,0-1.4,2.55A19.89,19.89,0,0,0,408.23,310.33Zm6.13,3a3.81,3.81,0,0,0-1.12.28l-.23.1,0,.23a1.19,1.19,0,0,1,0,.33,2,2,0,0,1-.11.38,3.91,3.91,0,0,1-.46.77,1.65,1.65,0,0,0,.8-.56,1.78,1.78,0,0,0,.26-.47,1.61,1.61,0,0,0,.06-.33,8.15,8.15,0,0,1,.94-.41,5.34,5.34,0,0,1,1.2-.22A2.55,2.55,0,0,0,414.36,313.29Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,220c6.24,2.4,11.26,4.12,14.13,12.94,3.48,10.7,7.75,27,7.75,27s-1.77,4.2-9.53,6.17-11.26,0-11.26,0-3.91-13.57-5.42-19.21S427.6,224.93,436,220Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.47,340a3.8,3.8,0,0,1-3.25-.27L330,307.49a3.75,3.75,0,0,1-1.82-2.64l-5.88-36.2a4.32,4.32,0,0,1-.05-.62,3.76,3.76,0,0,1,1.13-2.67l57.39,33.54a2.79,2.79,0,0,1,1.35,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,339.56l-.38.22-.52.25-6.35-39.18a2.79,2.79,0,0,0-1.35-2l-57.39-33.54a3.7,3.7,0,0,1,.77-.58l57.51,33.6a2.79,2.79,0,0,1,1.35,1.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.59,299.64l.89-.51a2.77,2.77,0,0,1,.53,1.2l6.36,39.23-.38.22-.52.25-6.35-39.18A2.76,2.76,0,0,0,381.59,299.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.44,306.48c-.39-2.42-2.87-5.65-5.54-7.21s-4.52-.86-4.12,1.56,2.87,5.65,5.54,7.21S357.84,308.9,357.44,306.48Z",
    style: {
      fill: "#800080"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.55,269.73c-2.3-1.48-4.18-7.41-2.1-14.7,1.62-5.7,5.12-9.06,9.75-14.57,5.89-7,9.61-9.94,9.3-16.57-.25-5.21-.66-5.77.72-9.26.74-1.85,2.46-6.08,3.14-7.53s3.17-4.08,4.83-6.5c1.7-2.27,2.77.47,2.32,2.21a22.31,22.31,0,0,1-2.35,5.26,28.9,28.9,0,0,0-1.56,4.5,26.06,26.06,0,0,1,5.16-1.1c.94,0,2.09-.28,2.81.52a7.69,7.69,0,0,1,.88,2,1.44,1.44,0,0,1,.93.37,2.34,2.34,0,0,1,.48,1.67,7.91,7.91,0,0,1-.11,1,1.74,1.74,0,0,1,1.4,1,7.52,7.52,0,0,1,.26,4c-.07.2-.83,1.73-1.05,2.18a3.94,3.94,0,0,1-.89,1.52c-.48.34-1.65-.55-1.8-1.32a7.92,7.92,0,0,1,.09-2.58,9,9,0,0,1-2.19.82c-1.11.74.54,2.37-.09,6.88-.49,3.42-3.36,5.66-4.16,7.14-4.85,9-5.62,18.85-11.37,26.26C369.65,265.87,362,272.59,357.55,269.73Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.78,214.08a11.91,11.91,0,0,1,2.82-1.51c.1-.3.19-.59.27-.88C380.61,212.25,379.11,213.1,378.78,214.08ZM380,217a3.79,3.79,0,0,1,1.11-.8,7.68,7.68,0,0,1,1.24-.57,19.33,19.33,0,0,1,2.64-.7c.9-.2,1.81-.38,2.71-.56a22.92,22.92,0,0,1,2.74-.41,10.93,10.93,0,0,0-2.8,0,25.6,25.6,0,0,0-2.76.45,12,12,0,0,0-2.69.84A5.15,5.15,0,0,0,380,217Zm3.66,1.38a5.33,5.33,0,0,0-2.31,1.47,3.54,3.54,0,0,1,1.17-.65c.42-.16.85-.31,1.28-.43.87-.26,1.74-.49,2.62-.7,1.75-.43,3.51-.83,5.32-1.1A13.3,13.3,0,0,0,389,217a22.5,22.5,0,0,0-2.7.5A17.81,17.81,0,0,0,383.67,218.37Zm6,6a5.1,5.1,0,0,1,.13-1.14,7.15,7.15,0,0,1,.32-.91l.31-.08a1.34,1.34,0,0,0,.42-.28,1.6,1.6,0,0,0,.48-.78,4.1,4.1,0,0,1-.69.48,1.74,1.74,0,0,1-.36.13.87.87,0,0,1-.31,0l-.21,0-.08.22a3.47,3.47,0,0,0-.2,1.08A2.38,2.38,0,0,0,389.67,224.4Z",
    style: {
      fill: "#af6152"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.83,79.45a27.36,27.36,0,0,0-4.47,54.34l3.08,7.92a1.59,1.59,0,0,0,3,0l3.06-7.93a27.36,27.36,0,0,0-4.64-54.33Zm25.27,27.32A25.15,25.15,0,0,1,423.3,124l-2.09,2a25.2,25.2,0,0,1-35.58-35.47l2-2.1a25.21,25.21,0,0,1,42.48,18.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.1,106.77A25.15,25.15,0,0,1,423.3,124l-2.09,2a25.2,25.2,0,0,1-35.58-35.47l2-2.1a25.21,25.21,0,0,1,42.48,18.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.7,92.67a17,17,0,0,1,2-1.5,13.69,13.69,0,0,1,2.3-1.24,14.45,14.45,0,0,1,2.7-.84,15.43,15.43,0,0,1,3.14-.3,13.14,13.14,0,0,1,4.18.63,9.48,9.48,0,0,1,3.23,1.81,8.07,8.07,0,0,1,2.09,2.84,9.12,9.12,0,0,1,.74,3.72,9.16,9.16,0,0,1-2,6,10.88,10.88,0,0,1-1.91,1.87l-2,1.49a16.82,16.82,0,0,0-1.6,1.37,2.74,2.74,0,0,0-.81,1.52l-.6,3.85h-4.46l-.45-4.3a3.47,3.47,0,0,1,.35-2.17,6.78,6.78,0,0,1,1.38-1.72,17.6,17.6,0,0,1,1.91-1.5,19.13,19.13,0,0,0,2-1.59,8.33,8.33,0,0,0,1.54-1.92,4.94,4.94,0,0,0,.62-2.55,4,4,0,0,0-.35-1.7,4,4,0,0,0-1-1.3,4.54,4.54,0,0,0-1.52-.83,6.21,6.21,0,0,0-1.91-.29,8.54,8.54,0,0,0-2.55.33,9.63,9.63,0,0,0-1.77.74c-.48.27-.89.52-1.23.74a1.66,1.66,0,0,1-.89.33,1.45,1.45,0,0,1-1.38-.79Zm5,28.2a4.16,4.16,0,0,1,.3-1.56,3.79,3.79,0,0,1,.83-1.26,4,4,0,0,1,1.27-.85,4,4,0,0,1,1.58-.31,3.86,3.86,0,0,1,1.57.31,4.16,4.16,0,0,1,1.27.85,3.86,3.86,0,0,1,.86,1.26,4,4,0,0,1,.31,1.56,3.85,3.85,0,0,1-1.17,2.82,4,4,0,0,1-1.27.84,4,4,0,0,1-1.57.3,4.15,4.15,0,0,1-1.58-.3,3.8,3.8,0,0,1-2.1-2.09A4.07,4.07,0,0,1,399.69,120.87Z",
    style: {
      fill: "#800080"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicConsulting);
export default __webpack_public_path__ + "static/media/Strategic-consulting.fe8e04f3b23edae1fff9616bb0981e88.svg";
export { ForwardRef as ReactComponent };